/* Classify titles into browse buckets. Spark records unchanged. */
(function (root) {
  var TYPES = [
    { id: 'magazines', label: 'Magazines' },
    { id: 'mag-extensions', label: 'Mag extensions' },
    { id: 'loaders', label: 'Mag loaders' },
    { id: 'magwells', label: 'Magwells' },
    { id: 'stocks', label: 'Stocks' },
    { id: 'buffer-tubes', label: 'Buffer tubes' },
    { id: 'forends', label: 'Forends' },
    { id: 'heatshields', label: 'Heatshields' },
    { id: 'handguards', label: 'Handguards' },
    { id: 'charging-handles', label: 'Charging handles' },
    { id: 'bcg', label: 'BCGs' },
    { id: 'gas-tubes', label: 'Gas tubes' },
    { id: 'gas-blocks', label: 'Gas blocks' },
    { id: 'dust-covers', label: 'Dust covers' },
    { id: 'pins', label: 'Pins' },
    { id: 'releases', label: 'Releases' },
    { id: 'holsters', label: 'Holsters' },
    { id: 'pouches', label: 'Pouches' },
    { id: 'side-saddles', label: 'Side saddles' },
    { id: 'lights', label: 'Lights & lasers' },
    { id: 'grips', label: 'Grips' },
    { id: 'sights', label: 'Sights' },
    { id: 'red-dots', label: 'Red dots' },
    { id: 'plates', label: 'Plates' },
    { id: 'mounts', label: 'Mounts' },
    { id: 'slides', label: 'Slides' },
    { id: 'barrels', label: 'Barrels' },
    { id: 'compensators', label: 'Comps & brakes' },
    { id: 'triggers', label: 'Triggers' },
    { id: 'recoil', label: 'Recoil / guide rods' },
    { id: 'air-pistols', label: 'Air pistols' },
    { id: 'air-rifles', label: 'Air rifles' },
    { id: 'ammo', label: 'Pellets, BBs & CO2' },
    { id: 'safeties', label: 'Safeties' },
    { id: 'internals', label: 'Small internals' },
    { id: 'tools', label: 'Tools' },
    { id: 'mats', label: 'Bench mats' },
    { id: 'end-plates', label: 'End plates' },
    { id: 'bolts', label: 'Bolts' },
    { id: 'springs', label: 'Springs & detents' },
    { id: 'sling-mounts', label: 'Sling mounts' },
    { id: 'rail-covers', label: 'Rail covers' },
    { id: 'hardware', label: 'Nuts & washers' },
    { id: 'other', label: 'All other parts' }
  ];
  var CORE_TYPES = {
    magazines: 1, 'mag-extensions': 1, loaders: 1, magwells: 1, holsters: 1, grips: 1, sights: 1, 'red-dots': 1, plates: 1, mounts: 1, barrels: 1, triggers: 1,
    stocks: 1, 'buffer-tubes': 1, forends: 1, heatshields: 1, handguards: 1, 'charging-handles': 1, bcg: 1, lights: 1,
    'side-saddles': 1, recoil: 1, compensators: 1, 'air-pistols': 1, 'air-rifles': 1, ammo: 1,
    safeties: 1, internals: 1, tools: 1, mats: 1, 'end-plates': 1,
    bolts: 1, springs: 1, 'sling-mounts': 1, 'rail-covers': 1, hardware: 1, other: 1
  };
  var TYPE_MIN = 6;
  var NEG_MAG = /MAGWELL|MAG WELL|MAG\s*RLS|MAG RELEASE|MAG CATCH|MAGAZINE CATCH|MAG CTCH|MAG REL|MAG RLESE|MAG RLSE|MAG-WRENCH|MAG WRENCH|MAG CARRY|\bINCOG\b|MAG PLATE|MAGPLATE|MAG POUCH|MAG PCH|MAG-NET|MAG SLEEVE|MAG SPACER|\bXGRIP\b|\bX-GRIP\b|FLOORPLATE|MAG EXT|MAGEX|MAGLINK|MAG COUPLER|MAG CARRIER|MAG LOADER|MAG CHARGER|MAGAZINE BRUSH|MAG BRUSH|MAG FLLWR|MAG FOLLOWER|\bFLLWR\b|\bFOLLOWER\b|\bLOADER\b|\bLOADR\b|STRIPLULA|\bLULA\b|MAGLULA|MAGPUMP|RECOIL PD|RECOIL PAD|VISE BLOCK|FOREND GRIP|QUICK CHNG|\bBCG\b|BOLT CARRIER|\bOWB\b|\bIWB\b|\bHOLSTER\b|\bHLSTR\b|BASE PAD|BASE PLATE|\.350 BASE|AMMO BOX|AMMO CAN|\bAMMO BX\b|BANDOLIER|MAGAZINE EXTENSION|MAG EXTENSION|MAGAZINE SPACER|MAGAZINE SLEEVE|MAGAZINE POUCH|MAGAZINE CARRIER|MAGAZINE RELEASE|EXTENDED REL\b|ENHANCED PLATE/;
  var POS_MAG = /(?:^MAG\b|^MAGAZINE\b|\bPMAG\b|\bHEXMAG\b|\bAMAG\b|\bL5AWM\b|\bL7AWM\b|\bMAGAZINE\b|\bMAG FOR\b|\bMAG FITS\b|\bMAG\b|\b\d+RD\b|\b\d+\s*-?\s*ROUND\b)/;
  var MAG_ACC_RE = /MAGAZINE EXTENSIONS?|MAG EXTENSIONS?|\bMAG EXT\b|\bMAGEXT\b|\bMAGEX\b|MAGAZINE SPACERS?|MAG SPACERS?|MAGAZINE SLEEVES?|MAG SLEEVES?|\bX-GRIP\b|\bXGRIP\b|MAGAZINE POUCH|MAG POUCH|MAGAZINE CARRIER|MAG CARRIER|MAGAZINE RELEASE|EXTENDED REL\b|EXTENDED MAGAZINE RELEASE|ENHANCED PLATE\s*\+\d|FINGER EXTNSN|FINGER EXTENSION|\bMG PLATE\b|MAGAZINE PLATE/;
  // AR-only buckets. Pump shotguns should not offer these as type cards.
  var PUMP_SHOTGUN_HIDE_TYPES = {
    'charging-handles': 1, bcg: 1, 'buffer-tubes': 1, 'gas-tubes': 1,
    'gas-blocks': 1, 'dust-covers': 1, slides: 1, pins: 1, 'end-plates': 1,
    magwells: 1, holsters: 1, 'rail-covers': 1
  };
  var AUTO_SHOTGUN_HIDE_TYPES = {
    bcg: 1, 'buffer-tubes': 1, 'gas-tubes': 1, 'gas-blocks': 1,
    'dust-covers': 1, slides: 1, pins: 1, 'end-plates': 1,
    magwells: 1, holsters: 1, 'rail-covers': 1
  };

  function isMagFloorplate(u) {
    if (!u) return false;
    if (/OPTIC|RMR|MOS TO|ADAPTER PLATE|MOUNTING PLATE|END PLATE/.test(u)) return false;
    if (/\b(MG PLATE|MAG PLATE|MAGPLATE|MAGAZINE PLATE|FLOORPLATE|FLOOR PLATE|BASE PLATE|BASE PAD|BSE PLT|BSE PLATE|BASE PLT)\b/.test(u)) return true;
    if (/\bPLATE\b/.test(u) && /MAGAZINE|\bMAG\b/.test(u)) return true;
    return false;
  }

  // Complete mag SKUs often mention a pad/floorplate. Those stay magazines, not mag-extensions.
  function isCompleteMag(u, v) {
    if (!u) return false;
    if (MAG_ACC_RE.test(u) || isMagFloorplate(u)) return false;
    if (/\b(EXTENSION|SPACER|SLEEVE|POUCH|HOLSTER|HLSTR)\b/.test(u)) return false;
    if (!/\d+\s*RD\b/.test(u) && !/\d+\s*-?\s*ROUND\b/.test(u)) return false;
    if (v && /PRO-?MAG/.test(v) && /GLK|GLOCK/.test(u)) return true;
    return /^MAG\b/.test(u) || /^MAGAZINE\b/.test(u) || /\bMAGAZINE\b/.test(u) || /\bPMAG\b/.test(u) ||
      /\bHEXMAG\b/.test(u) || /\bAMAG\b/.test(u) || /\bL5AWM\b/.test(u) || /\bL7AWM\b/.test(u);
  }

  var PLATFORMS = {
    glock: {
      name: 'Glock',
      queries: ['Glock', 'GLK', 'RMR', 'SRO', 'RCR', 'Duty Red Dot', 'Comp Red Dot'],
      family: /GLOCK|\bGLK\b|GLCK|GLK\d|\bGL ?(?:17|19|20|21|22|23|26|27|29|30|34|43|45|47|48)\b|G(?:17|19|20|21|22|23|26|34|42|43|45|47|48)(?:GEN|MOS)|G20L|G17L|G19X|G43X|\bG(?:17L|18|19X|19|20L|20|21|22|23|24|25|26|27|28|29|30S|30|31|32|33|34|35|36|37|38|39|40|41|42|43X|43|44|45|47|48|49)\b/i,
      models: ['17', '18', '19', '19X', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '43X', '44', '45', '47', '48', '49'],
      modelLabels: { '17': '17 / 34' },
      typeLabels: { plates: 'RMR / MOS plates', 'red-dots': 'RMR red dots' },
      preferTypesByModel: {
        '17': ['red-dots', 'plates'],
        '19': ['red-dots', 'plates'],
        '34': ['red-dots', 'plates'],
        '45': ['red-dots', 'plates']
      },
      parse: 'glock'
    },
    hk: {
      name: 'H&K',
      queries: ['Heckler', 'HK', 'H&K', 'VP9', 'HK USP', 'P30', 'HK45', 'P2000', 'CC9', 'MP5'],
      family: /HECKLER|\bH&K\b|\bH & K\b|\bHK\b|\bHK\d{2}\b|\bUSP\b|\bUSPC\b|\bVP9|\bP30\b|\bP2000\b|\bHK45\b|\bCC9\b|\bMP5|\bSP89\b|\bUMP\b|MR762|MR556/i,
      exclude: /HKS\b|H&R\b|HARRINGTON/,
      models: ['USP', 'USPC', 'VP9', 'P30', 'P2000', 'HK45', 'CC9', 'MP5', 'MP5K', 'HK91', 'UMP', 'HK416', 'MR762'],
      modelLabels: {
        USP: 'USP Full',
        USPC: 'USP Compact',
        HK45: 'HK45',
        MP5K: 'MP5K',
        HK91: 'HK91 / HK93',
        HK416: 'HK416',
        MR762: 'MR762 / MR556'
      },
      parse: 'hk'
    },
    '1911': {
      name: '1911',
      queries: ['1911', 'Wilson Combat', 'MAG KIMBER', 'MAG CMC', 'MAG ED BROWN', 'MAG COLT', 'Staccato', '2011'],
      family: /\b1911\b|\b2011\b|\b2311\b|\b2K11\b|STACCATO/i,
      models: ['Government', 'Commander', 'Officer', '2011'],
      modelLabels: {
        Government: 'Government',
        Commander: 'Commander',
        Officer: 'Officer',
        '2011': '2011 / Staccato'
      },
      parse: '1911'
    },
    beretta: {
      name: 'Beretta',
      queries: ['Beretta', 'BRTTA', 'Tomcat'],
      family: /BERETTA|\bBRTTA\b|\b92FS\b|\bPX4\b|\bAPX\b|\b1301\b|TOMCAT|\bA300\b|\bA400\b/i,
      models: ['92', '96', 'PX4', 'APX', '21', '950', 'Tomcat', 'Nano', '1301', 'A300', 'A400'],
      modelLabels: {
        '92': '92 / M9',
        '96': '96',
        '21': '21 / Bobcat',
        '950': '950 / Jetfire',
        Tomcat: 'Tomcat',
        Nano: 'Nano',
        A300: 'A300',
        A400: 'A400'
      },
      parse: 'beretta',
      mergeTypes: { handguards: 'forends' }
    },
    remington: {
      name: 'Remington',
      queries: ['Remington', 'REM 870', 'REM 700', 'R700', 'REM700', 'RMNGTN', 'REM870'],
      family: /REMINGTON|RMNGTN|\bREM700\b|\bR700\b|\bREM 870\b|\bREM 700\b|\b870\b|\b1100\b|\b1187\b|\b597\b/i,
      exclude: /\bAR[- ]?15\b|\bAR15\b|\bAR[- ]?10\b|\bAR10\b/,
      models: ['870', '1100', '1187', '700', '700SA', '700LA', '597', '760'],
      modelLabels: {
        '870': '870',
        '1100': '1100',
        '1187': '1187',
        '700': '700',
        '700SA': '700 SA',
        '700LA': '700 LA',
        '597': '597',
        '760': '760 / 740 / 742'
      },
      parse: 'remington',
      mergeTypes: { handguards: 'forends' },
      hideTypesByModel: {
        '870': PUMP_SHOTGUN_HIDE_TYPES,
        '1100': AUTO_SHOTGUN_HIDE_TYPES,
        '1187': AUTO_SHOTGUN_HIDE_TYPES
      }
    },
    springfield: {
      name: 'Springfield',
      queries: [
        'Springfield', 'Hellcat', 'XD-M', 'XDS', 'M1A', 'Echelon', 'Prodigy',
        'SPRGFLD', 'SPGFLD', 'HELLCT', 'XDM'
      ],
      family: /SPRINGFIELD|SPRGFLD|SPGFLD|SPGFD|SPNGFLD|SPRNGFLD|\bSPFLD\b|\bSPFD\b|HELLCAT|HELLCT|\bHLCT\b|\bECHELON\b|\bPRODIGY\b|\bXDS\b|\bXDM\b|\bXD[- ]?M\b|\bXD\b|\bM1A\b/i,
      exclude: /30-?06SPFLD|3006SPFLD|30-06SPFG|30-06SGP/i,
      models: [
        'Hellcat', 'Hellcat Pro', 'Echelon', 'ECHC',
        'XD', 'XDS', 'XDM', 'XDE', 'M1A', 'EMP', 'Prodigy', '1911'
      ],
      modelLabels: {
        Hellcat: 'Hellcat',
        'Hellcat Pro': 'Hellcat Pro',
        Echelon: 'Echelon',
        ECHC: 'Echelon Compact',
        XD: 'XD',
        XDS: 'XD-S',
        XDM: 'XD-M',
        XDE: 'XD-E',
        M1A: 'M1A',
        EMP: 'EMP',
        Prodigy: 'Prodigy',
        '1911': '1911'
      },
      parse: 'springfield'
    },
    colt: {
      name: 'Colt',
      queries: ['Colt', 'Python', 'Anaconda', 'King Cobra', 'Detective Special'],
      family: /\bCOLT\b|PYTHON|ANACONDA|KING COBRA|DETECTIVE SPECIAL/i,
      exclude: /\bAR[- ]?15\b|\bAR15\b/,
      models: ['1911', 'Officer', 'Python', 'Anaconda', 'King Cobra', 'Cobra', 'Detective Special', 'Viper', 'Diamondback', 'SAA'],
      modelLabels: {
        '1911': '1911 Government / Commander',
        Officer: '1911 Officer / Defender',
        'King Cobra': 'King Cobra',
        'Detective Special': 'Detective Special',
        Diamondback: 'Diamondback',
        SAA: 'Single Action Army'
      },
      parse: 'colt'
    },
    'smith-wesson': {
      name: 'S&W',
      queries: [
        'Smith & Wesson', 'S&W', 'M&P', 'SHLD', 'Shield Plus',
        'Bodyguard', 'Equalizer', 'M&P9', 'SD9'
      ],
      family: /SMITH\s*&\s*WESSON|\bS&W\b|\bM&P\b|BODYGUARD|BDYGRD|\bSHLD\b|\bSHIELD\b|EQUALIZER/i,
      exclude: /M-PRO|M PRO 7|PEPPER SPRAY|PEPPER SPRY|HANDCUFF/i,
      models: [
        'MP', 'MPC', 'Shield', 'Shield Plus', 'Shield EZ', 'Shield X',
        'Bodyguard', 'BG2', 'Equalizer', 'SD9',
        'J-frame', 'KL-frame', 'N-frame', 'X-frame', '1854', 'MP1522', 'MP22', 'MP57', 'Victory', '41', 'CSX', 'Governor'
      ],
      modelLabels: {
        MP: 'M&P',
        MPC: 'M&P Compact',
        Shield: 'Shield',
        'Shield Plus': 'Shield Plus',
        'Shield EZ': 'Shield EZ',
        'Shield X': 'Shield X',
        Bodyguard: 'Bodyguard',
        BG2: 'Bodyguard 2.0',
        Equalizer: 'Equalizer',
        SD9: 'SD9',
        'J-frame': 'J-frame',
        'KL-frame': 'K/L-frame',
        'N-frame': 'N-frame',
        'X-frame': 'X-frame',
        '1854': '1854',
        MP1522: 'M&P15-22',
        MP22: 'M&P22',
        MP57: 'M&P 5.7',
        Victory: 'Victory',
        '41': 'Model 41',
        CSX: 'CSX',
        Governor: 'Governor'
      },
      parse: 'sw'
    },
    ruger: {
      name: 'Ruger',
      queries: [
        'Ruger', 'RUG', '10/22', '10-22', 'LCP', 'LC9',
        'Mini-14', 'Mini-30', 'MAX-9', 'RXM', 'GP100', 'SP101',
        'Redhawk', 'SR1911', 'LCR', 'Security-9', 'SR22', 'M77',
        'RGR AMER'
      ],
      family: /RUGER|\bRUG\b|\bLCP\b|\bLC9\b|MINI[- ]?14|MINI[- ]?30|10\/22|10-22|\bRXM\b|MAX-?9|\bGP100\b|\bSP101\b|REDHAWK|\bLCR\b|\bM77\b/i,
      exclude: /PISTOL RUG|PSTL RUG|GUN RUG/i,
      models: [
        '10/22', 'LCP', 'LCP II', 'LCP Max', 'LC9', 'MAX-9',
        'RXM', 'RXMC', 'RXMS', 'Mark IV', 'Mark II',
        'Mini-14', 'Mini-30', 'American', 'American RF',
        'Precision', 'Precision RF', 'M77', 'GP100', 'SP101',
        'Redhawk', 'LCR', 'SEC9', 'SEC9C', 'SEC380', 'Security-Six',
        'SR1911', 'SR22', 'SR9', 'PC Carbine', 'Wrangler', 'Blackhawk', 'Scout', '5.7', 'P-series'
      ],
      modelLabels: {
        '10/22': '10/22',
        'LCP II': 'LCP II',
        'LCP Max': 'LCP Max',
        'MAX-9': 'MAX-9',
        RXM: 'RXM',
        RXMC: 'RXM Compact',
        RXMS: 'RXM Sub',
        'Mark IV': 'Mark IV',
        'Mark II': 'Mark II',
        'Mini-14': 'Mini-14',
        'Mini-30': 'Mini-30',
        American: 'American',
        'American RF': 'American Rimfire',
        Precision: 'Precision',
        'Precision RF': 'Precision Rimfire',
        M77: 'M77',
        GP100: 'GP100',
        SP101: 'SP101',
        Redhawk: 'Redhawk',
        LCR: 'LCR',
        SEC9: 'Security-9',
        SEC9C: 'Security-9 Compact',
        SEC380: 'Security-380',
        'Security-Six': 'Security-Six',
        SR1911: 'SR1911',
        SR22: 'SR22',
        SR9: 'SR9',
        'PC Carbine': 'PC Carbine',
        Wrangler: 'Wrangler',
        Blackhawk: 'Blackhawk',
        Scout: 'Gunsite Scout',
        '5.7': '5.7',
        'P-series': 'P-series'
      },
      parse: 'ruger'
    },
    'ar-10': {
      name: 'AR-10',
      queries: [
        'AR-10', 'AR10', 'AR 10', 'SR-25', 'SR25', 'LR-308', 'LR308',
        'L7AWM', 'AR308', 'AR-308', 'LPK 308', 'M5 AR', 'PMAG 7.62',
        '5/8x24', 'CMMG MK3', '6.5 CM', 'MBA 308'
      ],
      family: /\bAR[- ]?10\b|\bAR10\b|\bSR[- ]?25\b|\bSR25\b|\bLR[- ]?308\b|\bLR308\b|\bAR-308\b|\bAR308\b|L7AWM|\bLR\/SR\b/i,
      models: ['Carbine', 'Rifle', 'SR25', 'DPMS', '65CM'],
      modelLabels: {
        Carbine: 'Carbine',
        Rifle: 'Rifle',
        SR25: 'SR-25',
        DPMS: 'DPMS / LR-308',
        '65CM': '6.5 Creedmoor'
      },
      parse: 'ar10',
      mergeTypes: { forends: 'handguards', lpk: 'triggers' },
      typeLabels: { handguards: 'Handguards', other: 'Miscellaneous parts' },
      hideTypes: { holsters: 1 },
      skipBrandFor: { other: 1 },
      quickTypes: [
        'magazines', 'loaders', 'stocks', 'handguards', 'buffer-tubes',
        'charging-handles', 'bcg', 'gas-tubes', 'dust-covers', 'pins',
        'grips', 'sights', 'barrels', 'triggers',
        'recoil', 'compensators', 'safeties', 'internals', 'tools', 'mats', 'end-plates',
        'bolts', 'springs', 'sling-mounts', 'rail-covers', 'hardware', 'other'
      ]
    },
    'ar-15': {
      name: 'AR-15',
      queries: ['AR-15', 'AR15', 'AR 15', 'L5AWM', 'PMAG M3', 'LPK', 'BCM GUNF', 'Magpul MOE', 'B5 Systems', 'AR-9', 'CARB STK', 'Geissele', 'Noveske'],
      family: /\bAR[- ]?15\b|\bAR15\b|\bM16\b|L5AWM|\bAR[- ]?9\b|\bAR9\b/i,
      exclude: /\bAR[- ]?10\b|\bAR10\b|\bSR[- ]?25\b|\bLR[- ]?308\b|L7AWM/i,
      models: ['556', '9mm', '300BLK', 'Carbine', 'Mid', 'Rifle'],
      modelLabels: {
        '556': '.223 / 5.56',
        '9mm': '9mm / AR-9',
        '300BLK': '.300 BLK',
        Carbine: 'Carbine / M4',
        Mid: 'Mid-length',
        Rifle: 'Rifle'
      },
      parse: 'ar15',
      mergeTypes: { forends: 'handguards', lpk: 'triggers' },
      typeLabels: { handguards: 'Handguards', other: 'Miscellaneous parts' },
      hideTypes: { holsters: 1 },
      skipBrandFor: { other: 1 },
      headerFilters: ['type', 'model', 'brand'],
      headerFilterLabels: { type: 'Type', model: 'Caliber / size', brand: 'Brand' },
      quickTypes: [
        'magazines', 'loaders', 'stocks', 'handguards', 'buffer-tubes',
        'charging-handles', 'bcg', 'gas-tubes', 'dust-covers', 'pins',
        'grips', 'sights', 'barrels', 'triggers',
        'recoil', 'compensators', 'safeties', 'internals', 'tools', 'mats', 'end-plates',
        'bolts', 'springs', 'sling-mounts', 'rail-covers', 'hardware', 'other'
      ]
    },
    'ak-47': {
      name: 'AK-47',
      queries: [
        'AK-47', 'AK47', 'AKM', 'AK-74', 'AK74', '7.62x39', '7.62X39',
        'Magpul AK', 'WASR', 'Zhukov', '14X1LH', 'Yugo AK', 'Zastava'
      ],
      family: /\bAK[- ]?47\b|\bAK47\b|\bAKM\b|\bAK[- ]?74\b|\bAK74\b|7\.62X39|\b762X39\b|\bAK\b/i,
      exclude: /\bAR[- ]?15\b|\bAR15\b|\bAR[- ]?10\b|\bAR10\b|\bSR[- ]?25\b|\bASC AR\b|\bDURAMAG\b/i,
      models: ['AKM', 'AK74', 'Yugo'],
      modelLabels: {
        AKM: 'AKM / 7.62x39',
        AK74: 'AK-74',
        Yugo: 'Yugo / Zastava'
      },
      parse: 'ak',
      mergeTypes: { forends: 'handguards' },
      typeLabels: { handguards: 'Handguards', other: 'Miscellaneous parts' },
      hideTypes: { holsters: 1 },
      skipBrandFor: { other: 1 },
      quickTypes: [
        'magazines', 'stocks', 'handguards', 'grips', 'triggers',
        'sights', 'compensators', 'safeties', 'internals', 'tools', 'mats', 'other'
      ]
    },
    '10-22': {
      name: '10/22',
      queries: [
        '10/22', '10-22', 'RUG10-22', 'Ruger 10/22',
        'Magpul X-22', 'Magpul X22', 'Hunter X-22', 'MOE X-22',
        'BX-Trigger', 'TacSol 10/22', 'XRING 10/22', 'Archangel 10/22'
      ],
      family: /\b10\/22\b|\b10-22\b|\bRUG10-22\b|\b1022\b|X-22|HTR X22|BCKPCKR/i,
      exclude: /M&P15-22|MP15-22|MINI[- ]?14|AR223|SWEET 22|BX-1 MCKENZIE/i,
      models: ['Takedown', 'Charger'],
      modelLabels: {
        Takedown: 'Takedown',
        Charger: 'Charger'
      },
      parse: '1022',
      mergeTypes: { forends: 'handguards' },
      typeLabels: { handguards: 'Handguards', other: 'Miscellaneous parts' },
      hideTypes: { holsters: 1 },
      skipBrandFor: { other: 1 },
      quickTypes: [
        'magazines', 'stocks', 'barrels', 'triggers', 'handguards',
        'sights', 'charging-handles', 'tools', 'mats', 'bolts', 'other'
      ]
    },
    mossberg: {
      name: 'Mossberg',
      queries: ['Mossberg', 'MSBRG', 'MSSBRG', 'MOSS 500', 'MOSS 590', 'MOSSBRG', 'Shockwave', '590M'],
      family: /MOSSBERG|\bMSBRG\b|\bMSSBRG\b|MOSSBRG|\bMOSS\b|\b702\b/i,
      exclude: /PEAT MOSS/,
      models: ['500', '590', '835', '702', '930', '940', '990', 'Patriot'],
      modelLabels: {
        '500': '500 / Shockwave',
        '590': '590 / 590A1 / 590M',
        '835': '835',
        '990': '990 Aftershock',
        Patriot: 'Patriot'
      },
      parse: 'mossberg',
      mergeTypes: { handguards: 'forends' },
      hideTypesByModel: {
        '500': PUMP_SHOTGUN_HIDE_TYPES,
        '590': PUMP_SHOTGUN_HIDE_TYPES,
        '835': PUMP_SHOTGUN_HIDE_TYPES
      }
    },
    'sig-sauer': {
      name: 'Sig Sauer',
      queries: [
        'Sig Sauer', 'P320', 'P365', 'P226', 'P229', 'P220', 'P938',
        'P365XL', 'XMACRO', 'MPX', 'MCX', 'SIGP365', 'WCP320', 'WCP365',
        'P-320', 'P-365', 'SIG CROSS'
      ],
      family: /\bSIG\b|SAUER|P[- ]?320|P[- ]?365|SIGP365|SIGP320|WCP320|WCP365|XMACRO|\bMPX\b|\bMCX\b|\bP226|\bP229|\bP220|\bP938/i,
      exclude: /ULTRX FUSE|BIONIC FUSE|MASTERLOCK/i,
      models: [
        'P365', 'P365XL', 'P365X', 'P365M', 'P365F',
        'P320', 'P320C', 'P320X', 'P320XT',
        'P226', 'P229', 'P220', 'P230', 'P938', 'P239', 'P238', 'P225', 'P250',
        'MPX', 'MCX', 'Cross', '556'
      ],
      modelLabels: {
        P365: 'P365',
        P365XL: 'P365XL',
        P365X: 'P365X',
        P365M: 'XMacro',
        P365F: 'Fuse',
        P320: 'P320',
        P320C: 'P320 Compact',
        P320X: 'P320 X',
        P320XT: 'XTen',
        P226: 'P226',
        P229: 'P229 / P228',
        P220: 'P220',
        P230: 'P230',
        P938: 'P938',
        P239: 'P239',
        P238: 'P238',
        P225: 'P225',
        P250: 'P250',
        MPX: 'MPX',
        MCX: 'MCX',
        Cross: 'Cross',
        '556': '556'
      },
      parse: 'sig'
    },
    taurus: {
      kind: 'firearm',
      name: 'Taurus',
      queries: ['Taurus', 'GX4', 'G2C', 'G3C', 'Judge', 'TX22', 'PT111', 'TX9'],
      family: /TAURUS|\bTAUR\b|\bTAU\b|\bGX4\b|\bGX2\b|\bG2C\b|\bG3C\b|\bG3X\b|\bJUDGE\b|\bTX22\b|\bTX9\b|\bPT111\b/i,
      models: [
        'GX4', 'GX4C', 'G3', 'G3C', 'G2C',
        'Judge', 'PubDef', 'Tracker', 'Raging',
        'TX22', 'TX9', 'TX9C', 'TX9S',
        'PT111', 'TCP', 'GX2', '856', '85', 'Millennium', 'Curve'
      ],
      modelLabels: {
        GX4: 'GX4',
        GX4C: 'GX4 Carry',
        G3: 'G3',
        G3C: 'G3C',
        G2C: 'G2C',
        Judge: 'Judge',
        PubDef: 'Public Defender',
        Tracker: 'Tracker',
        Raging: 'Raging Bull',
        TX22: 'TX22',
        TX9: 'TX9',
        TX9C: 'TX9 Compact',
        TX9S: 'TX9 Sub',
        PT111: 'PT111',
        TCP: '738 TCP',
        GX2: 'GX2',
        '856': '856',
        '85': '85',
        Millennium: 'Millennium',
        Curve: 'Curve'
      },
      parse: 'taurus'
    },
    cz: {
      name: 'CZ',
      queries: [
        'CZ', 'CZ-75', 'CZ75', 'CZ P-10', 'CZ P10', 'P-10 C', 'P-10F',
        'CZ P-07', 'CZ P-09', 'CZ P-01', 'CZ Shadow', 'CZ SHDW',
        'CZ Scorpion', 'CZ EVO', 'CZ SCRPN', 'CZ 455', 'CZ 457',
        'CZ 452', 'CZ 527', 'CZ 600', 'SP-01'
      ],
      family: /\bCZ\b|CZ[- ]?\d{2,3}|CZ-USA|P-?10[CFS]?\b|SHADOW 2|SHDW 2|CZ SCORP|CZ EVO|CZ SCRPN/i,
      exclude: /SHADOW SYSTEMS|CR920|G-CODE SCORPION|GCODE SCORPION|EMPEROR SCORP|PARA P10|P12 WRTHG/i,
      models: [
        'P10C', 'P10F', 'P10S', 'P10',
        '75', '75C', 'P07', 'P09', 'P01',
        'Shadow2', 'Scorpion',
        '457', '455', '452', '512', '527', '600', 'Bren'
      ],
      modelLabels: {
        P10C: 'P-10 C',
        P10F: 'P-10 F',
        P10S: 'P-10 S',
        P10: 'P-10',
        '75': '75 / SP-01',
        '75C': '75 Compact',
        P07: 'P-07',
        P09: 'P-09',
        P01: 'P-01',
        Shadow2: 'Shadow 2',
        Scorpion: 'Scorpion',
        '457': '457',
        '455': '455',
        '452': '452',
        '512': '512',
        '527': '527',
        '600': '600',
        Bren: 'Bren 2'
      },
      parse: 'cz'
    },
    benelli: {
      name: 'Benelli',
      queries: ['Benelli', 'Benelli M4', 'SBE'],
      family: /BENELLI/i,
      models: ['M4', 'SBE'],
      modelLabels: { M4: 'M4', SBE: 'Super Black Eagle' },
      parse: 'benelli',
      mergeTypes: { handguards: 'forends' }
    },
    bersa: {
      name: 'Bersa',
      queries: ['Bersa', 'Thunder 380', 'BP9'],
      family: /BERSA/i,
      models: ['Thunder', 'BP9'],
      modelLabels: { Thunder: 'Thunder', BP9: 'BP9' },
      parse: 'bersa'
    },
    canik: {
      name: 'Canik',
      queries: ['Canik', 'TP9', 'METE', 'MC9'],
      family: /CANIK|TP9|\bMETE\b|\bMC9\b/i,
      exclude: /TEKMAT|B&T TP9N|TP9N FOREGRIP|METERING|\bMETERS?\b/i,
      models: ['TP9', 'METE', 'MC9', 'Rival', 'TTI'],
      modelLabels: {
        TP9: 'TP9',
        METE: 'METE',
        MC9: 'MC9',
        Rival: 'Rival',
        TTI: 'TTI Combat'
      },
      parse: 'canik'
    },
    cmmg: {
      name: 'CMMG',
      queries: ['CMMG', '22AR', '9AR', 'Zeroed'],
      family: /CMMG|\b22AR\b|\b9AR\b/i,
      exclude: /TACTICAL SNACK/i,
      models: ['Mk4', 'Mk3', '22AR', '9AR', 'Zeroed', 'Resolute', 'Banshee'],
      modelLabels: {
        Mk4: 'Mk4 / AR-15',
        Mk3: 'Mk3 / AR-10',
        '22AR': '.22 LR conversion',
        '9AR': '9AR',
        Zeroed: 'Zeroed',
        Resolute: 'Resolute',
        Banshee: 'Banshee'
      },
      parse: 'cmmg',
      typeLabels: { other: 'All other parts' }
    },
    fn: {
      name: 'FN',
      queries: ['FN 509', 'FNX', 'FNS', 'Five-seveN', 'FNH', 'FN P90', 'SCAR', 'FN 502', 'FN 503'],
      family: /FNH|\bFN 509\b|\bFN509\b|\bFNS\b|\bFNX\b|FIVE-?SEVEN|\bP90\b|\bSCAR\b|FN AMERICA|\bFN 502\b|\bFN 503\b/i,
      exclude: /\bAR[- ]?15\b|\bM16\b|P90 STYLE/i,
      models: ['509', '510', '545', '502', '503', 'FNX', 'FiveSeven', 'P90', 'SCAR'],
      modelLabels: {
        '509': '509',
        '510': '510',
        '545': '545',
        '502': '502',
        '503': '503',
        FNX: 'FNX',
        FiveSeven: 'Five-seveN',
        P90: 'P90',
        SCAR: 'SCAR'
      },
      parse: 'fn'
    },
    henry: {
      name: 'Henry',
      queries: ['Henry', 'Homesteader', 'Big Boy'],
      family: /HENRY/i,
      models: ['Homesteader', 'BigBoy', 'H001', 'Survival', 'H3030', 'H4570', 'H357'],
      modelLabels: {
        Homesteader: 'Homesteader',
        BigBoy: 'Big Boy',
        H001: 'H001 / .22',
        Survival: 'U.S. Survival',
        H3030: '30-30',
        H4570: '45-70',
        H357: '.357 / .38'
      },
      parse: 'henry'
    },
    iwi: {
      name: 'IWI',
      queries: ['IWI', 'Masada', 'Jericho', 'Tavor', 'X95'],
      family: /\bIWI\b|MASADA|JERICHO|TAVOR|\bX95\b/i,
      models: ['Masada', 'MasadaSlim', 'Jericho', 'Tavor'],
      modelLabels: {
        Masada: 'Masada',
        MasadaSlim: 'Masada Slim',
        Jericho: 'Jericho',
        Tavor: 'Tavor / X95'
      },
      parse: 'iwi'
    },
    kahr: {
      name: 'Kahr',
      queries: ['Kahr', 'PM9', 'CW9', 'MK9'],
      family: /KAHR|\bPM9\b|\bCW9\b|\bMK9\b/i,
      exclude: /CMMG|BUFFER ASSEMBLY/i,
      models: ['PM9', 'K9', 'MK9', 'P380', 'P9'],
      modelLabels: {
        PM9: 'PM9',
        K9: 'K9',
        MK9: 'MK9',
        P380: 'P380',
        P9: 'P9'
      },
      parse: 'kahr'
    },
    'kel-tec': {
      name: 'Kel-Tec',
      queries: ['Kel-Tec', 'Keltec', 'P3AT', 'PF9', 'PR57'],
      family: /KEL[- ]?TEC|KELTEC|\bP3AT\b|\bPF9\b|\bPR57\b|\bKP50\b/i,
      models: ['P3AT', 'PF9', 'P32', 'PR57', 'KP50'],
      modelLabels: {
        P3AT: 'P-3AT',
        PF9: 'PF-9',
        P32: 'P-32',
        PR57: 'PR57',
        KP50: 'KP50'
      },
      parse: 'keltec'
    },
    kimber: {
      name: 'Kimber',
      queries: ['Kimber', 'KDS9', 'Micro 9', '2K11', 'CDS9'],
      family: /KIMBER|KDS9|\b2K11\b|CDS9/i,
      exclude: /PEPPERBLASTER|PPERBLSTER|TEKMAT/i,
      models: ['1911', 'Micro9', 'Micro380', 'KDS9', 'CDS9', 'K2K11', 'K6s'],
      modelLabels: {
        '1911': '1911',
        Micro9: 'Micro 9',
        Micro380: 'Micro .380',
        KDS9: 'KDS9',
        CDS9: 'CDS9',
        K2K11: '2K11',
        K6s: 'K6s'
      },
      parse: 'kimber'
    },
    airguns: {
      name: 'Air guns',
      heading: 'Air guns',
      queries: ['Crosman', 'Umarex', 'UMX', 'Gamo', 'Daisy', 'Benjamin', 'Hatsan', 'JTS', 'air rifle', 'air pistol', '.177', 'PCP'],
      family: /CROSMAN|UMAREX|\bUMX\b|\bGAMO\b|DAISY|BENJAMIN|HATSAN|\bJTS\b|AIRGUN|AIR RIFLE|AIR PISTOL|\.177\b|177BB|\bPCP\b/i,
      exclude: /SLINGSHOT|SLINGSHT|M12AR|M12AK/i,
      models: ['Crosman', 'Umarex', 'Gamo', 'Daisy', 'Benjamin', 'JTS', 'Hatsan'],
      modelLabels: {
        Crosman: 'Crosman',
        Umarex: 'Umarex',
        Gamo: 'Gamo',
        Daisy: 'Daisy',
        Benjamin: 'Benjamin',
        JTS: 'JTS',
        Hatsan: 'Hatsan'
      },
      parse: 'airgun',
      headerFilters: ['type', 'model'],
      headerFilterLabels: { type: 'Type', model: 'Brand' },
      hideTypes: {
        holsters: 1, 'mag-extensions': 1, loaders: 1, magwells: 1, stocks: 1, 'buffer-tubes': 1,
        forends: 1, heatshields: 1, handguards: 1, 'charging-handles': 1, bcg: 1, 'gas-tubes': 1,
        'gas-blocks': 1, 'dust-covers': 1, pins: 1, pouches: 1, 'side-saddles': 1, lights: 1,
        grips: 1, sights: 1, plates: 1, mounts: 1, slides: 1, barrels: 1, compensators: 1,
        triggers: 1, recoil: 1, releases: 1, safeties: 1, internals: 1, tools: 1, mats: 1, 'end-plates': 1,
        bolts: 1, springs: 1, 'sling-mounts': 1, 'rail-covers': 1, hardware: 1
      },
      typeLabels: { other: 'Other air-gun gear' },
      quickTypes: ['air-pistols', 'air-rifles', 'magazines', 'ammo', 'other']
    },
    walther: {
      name: 'Walther',
      queries: ['Walther', 'WLTHR', 'PPK', 'PPQ', 'PDP', 'P99', 'MAG WAL'],
      family: /WALTHER|WLTHR|WHLTR|\bPPK|\bPPQ\b|\bPDP\b|\bMAG WAL\b/i,
      exclude: /ALL WTHR|ALL-WTHR|WEATHER|PEPPER GUN|CO2 CYL/,
      models: ['PDP', 'PPQ', 'PPK', 'PPKS', 'PPS', 'P99', 'P22', 'CCP', 'Q5', 'P38', 'WMP'],
      modelLabels: {
        PDP: 'PDP',
        PPQ: 'PPQ',
        PPK: 'PPK',
        PPKS: 'PPK/S',
        PPS: 'PPS',
        P99: 'P99',
        P22: 'P22',
        CCP: 'CCP',
        Q5: 'Q4 / Q5',
        P38: 'P38',
        WMP: 'WMP'
      },
      parse: 'walther'
    },
    savage: {
      name: 'Savage',
      queries: [
        'Savage', 'SAV 110', 'Savage Axis', 'MAG SAV',
        'A22', 'A17', 'B22', 'B17', 'Bmag', 'Mark II Savage'
      ],
      family: /SAVAGE|\bSAV\b|\bSVG\b|MAG SAV|\bAXIS\b/i,
      exclude: /HOWARD LEIGHT|TRI-STANCE|TRISTANCE|TRI STANCE|SAVAGE BIPOD|TEKMAT/,
      models: [
        'Axis', '110SA', '110LA', '110',
        'A17', 'A22', 'Bmag', '93', 'MarkII', '64', 'Rascal', '212'
      ],
      modelLabels: {
        Axis: 'Axis / Edge',
        '110SA': '110 short action',
        '110LA': '110 long action',
        '110': '110 / 10 / 12',
        A17: 'A17 / B17',
        A22: 'A22 / B22',
        Bmag: 'B.Mag',
        '93': '93',
        MarkII: 'Mark II',
        '64': '64',
        Rascal: 'Rascal',
        '212': '212 slug'
      },
      parse: 'savage',
      typeLabels: { mounts: 'Scope bases', other: 'All other parts' },
      hideTypes: { holsters: 1 }
    },
    tikka: {
      name: 'Tikka',
      queries: ['Tikka', 'TIKKA', 'T3X', 'T1X'],
      family: /TIKKA|T3\/X|TIKKAT3|\bT3X\b/i,
      exclude: /T1XI|T-1XI|T1-XI|STEINER T1|TEKMAT/i,
      models: ['T3', 'T1X'],
      modelLabels: {
        T3: 'T3 / T3X',
        T1X: 'T1X'
      },
      parse: 'tikka',
      typeLabels: { mounts: 'Rings & bases', other: 'All other parts' },
      hideTypes: { holsters: 1 }
    },
    marlin: {
      name: 'Marlin',
      queries: ['Marlin', 'MRLN', 'MRLIN'],
      family: /MARLIN|\bMRLN\b|\bMRLIN\b/i,
      exclude: /UMAREX|\bUMX\b|TEKMAT|RIFLE CASE|GUN CASE|RFL CASE/i,
      models: ['336', '1894', '1895', '39A'],
      modelLabels: {
        '336': '336',
        '1894': '1894',
        '1895': '1895',
        '39A': '39A'
      },
      parse: 'marlin',
      typeLabels: { mounts: 'Rails & mounts', other: 'All other parts' },
      hideTypes: { holsters: 1 }
    },
    browning: {
      name: 'Browning',
      queries: ['Browning', 'BRWNG', 'BRNG', 'X-Bolt', 'Buckmark', 'BCKMRK', 'Browning BAR'],
      family: /BROWNING|\bBRWNG\b|\bBRNG\b|X-?BOLT|BUCKMARK|BUCK MARK|BCKMRK/i,
      exclude: /KA-?BAR|VLTOR|\bA5 H[12]\b|A5 BUFFER|A5 SPRING|A5 RECEIVER|SOLGW|LOYAL 9|TEKMAT|DANIEL DEFENSE/i,
      models: ['XBolt', 'BAR', 'BLR', 'ABolt', 'BuckMark', 'HP'],
      modelLabels: {
        XBolt: 'X-Bolt',
        BAR: 'BAR',
        BLR: 'BLR',
        ABolt: 'A-Bolt',
        BuckMark: 'Buck Mark',
        HP: 'Hi-Power'
      },
      parse: 'browning',
      typeLabels: { mounts: 'Rings & bases', other: 'All other parts' }
    },
    parts: {
      name: 'Parts',
      heading: 'Shop by part',
      kind: 'firearm',
      models: [],
      queries: [''],
      hideTypes: { 'air-pistols': 1, 'air-rifles': 1, ammo: 1, tools: 1, mats: 1 },
      headerFilterLabels: { type: 'Type', gun: 'Gun', model: 'Model', brand: 'Brand' }
    },
    knives: {
      kind: 'knives',
      name: 'Knives',
      heading: 'Knives',
      queries: [
        'Spyderco', 'Kershaw', 'Cold Steel', 'SOG', 'KA-BAR', 'Outdoor Edge',
        'knife', 'sharpener', 'KBAR', 'Hogue', 'Stroup',
        'Camillus', 'Born Ready', 'Breslau', 'AccuSharp'
      ]
    },
    gear: {
      kind: 'gear',
      name: 'Gear',
      heading: 'Gear',
      queries: ['']
    },
    optics: {
      kind: 'gear',
      name: 'Optics',
      heading: 'Optics',
      queries: [''],
      lockedCat: 'optics',
      quickTypes: [
        'scopes', 'spotting', 'binoculars', 'red-dots', 'magnifiers', 'weapon-lights',
        'bore-sighters', 'rangefinders', 'thermal', 'lasers', 'rings', 'mounts', 'plates', 'accessories', 'other'
      ]
    }
  };
  function addGlockModels(found, text) {
    if (!text) return;
    var re = new RegExp('\\bG?(' + GLOCK_MOD + ')\\b', 'g');
    var m;
    while ((m = re.exec(text))) {
      var before = text.charAt(m.index - 1);
      var afterCh = text.charAt(m.index + m[0].length);
      if (/\d/.test(before) || /\d/.test(afterCh)) continue;
      var after = text.slice(m.index + m[0].length).replace(/^\s+/, '');
      if (m[1] === '19' && after.slice(0, 2) === '13') continue;
      if (m[1] === '40' && /^(S\s*&?\s*W|SW\b|S&W)/.test(after)) continue;
      if (m[1] === '45' && /^(ACP|AUTO)\b/.test(after)) continue;
      found[canonGlockModel(m[1])] = 1;
    }
  }

  function glockModelsOf(title, desc) {
    var u = (title || '').toUpperCase().replace('43 X', '43X').replace('19 X', '19X').replace(/G43\/X\/48/g, 'G43 G43X G48');
    var d = descHead(desc, 700);
    var found = {};
    var m;
    var sep = '(?:\\s*[\\/,]&?\\s*|\\s+AND\\s+|\\s*&\\s*)';
    var reG = new RegExp('\\bG(' + GLOCK_MOD + ')(?:GEN\\d|MOS|G[3-6])?\\b', 'g');
    while ((m = reG.exec(u))) found[canonGlockModel(m[1])] = 1;
    var reGlk = new RegExp('GLK\\s*((?:' + GLOCK_MOD + ')(?:' + sep + '(?:' + GLOCK_MOD + '))*)', 'g');
    while ((m = reGlk.exec(u))) addGlockModels(found, m[1]);
    var reGL = /\bGL\s*(17|19|20|21|22|23|26|27|30|34|43|45|47|48)\b/g;
    while ((m = reGL.exec(u))) found[m[1]] = 1;
    var reMos = /\bG(17|19|34)MOS\b/g;
    while ((m = reMos.exec(u))) found[m[1]] = 1;
    var reKit = new RegExp('(?:CONV KIT|KIT)\\s+(' + GLOCK_MOD + ')(?:\\s*[-/]\\s*(' + GLOCK_MOD + '))+', 'g');
    while ((m = reKit.exec(u))) addGlockModels(found, m[0]);
    var blob = u + ' ' + d;
    var dd = blob.replace(/GEN(?:ERATION)?\s*[1-6](?!\d)(?:\s*[\/,&-]\s*[1-6](?!\d))*/g, ' ');
    var reNamed = new RegExp('(?:FITS GLOCK|FOR GLOCK|FITS GLK|FOR GLK|GLOCK)\\s+((?:G?(?:' + GLOCK_MOD + ')(?:(?:\\s*[\\/,]\\s*|\\s+AND\\s+|\\s*&\\s+)G?(?:' + GLOCK_MOD + '))*)+)', 'g');
    while ((m = reNamed.exec(dd))) addGlockModels(found, m[1]);
    var reList = /GLOCK[^\n]{0,24}?((?:G\d{2}X?(?:\s*[,\/&]\s*G?\d{2}X?)+))/g;
    while ((m = reList.exec(dd))) addGlockModels(found, m[1]);
    var reGDesc = new RegExp('\\bG(' + GLOCK_MOD + ')(?:GEN\\d|MOS|G[3-6])?\\b', 'g');
    while ((m = reGDesc.exec(dd))) found[canonGlockModel(m[1])] = 1;
    var reParen = new RegExp('\\(\\s*((?:G?(?:' + GLOCK_MOD + ')(?:\\s*[\\/,]\\s*G?(?:' + GLOCK_MOD + '))+))\\s*\\)', 'g');
    while ((m = reParen.exec(dd))) addGlockModels(found, m[1]);
    var reSlash = new RegExp('(?:FITS|FOR|GLOCK)[^\\n]{0,64}?((?:' + GLOCK_MOD + ')(?:\\s*[\\/]\\s*(?:' + GLOCK_MOD + '))+)', 'g');
    while ((m = reSlash.exec(dd))) addGlockModels(found, m[1]);
    var reProse = /(?:FOR THE|FITS THE)\s+((?:G?\d{2}X?(?:\s*,\s*|\s+AND\s+|\s*\/\s*))+G?\d{2}X?)/g;
    while ((m = reProse.exec(dd))) addGlockModels(found, m[1]);
    if (found['40'] && /40\s*S\s*&?\s*W|40SW|\.40/.test(blob) && !/\bG40\b|GLOCK\s*40\b|GLK\s*40\b/.test(blob)) {
      delete found['40'];
    }
    if (found['45'] && /45\s*ACP|45ACP|\.45\b/.test(blob) && !/\bG45\b|GLOCK\s*45\b|GLK\s*45\b/.test(blob)) {
      delete found['45'];
    }
    applyGlockSharedFit(found, title, blob);
    applyGlockMosFit(found, title, blob);
    applyGlockRmrDotFit(found, title, blob);
    applyGlock1734(found, title, blob);
    return Object.keys(found);
  }

  // Pistol red dots on the Trijicon RMR footprint (RMR / SRO / RCR / RMR-pattern
  // C&H and Mepro). Not plates, mounts, RMRcc, or RMR-height iron sights.
  function isRmrFootprintPistolDot(title, vendor) {
    var u = String(title || '').toUpperCase();
    var v = String(vendor || '').toUpperCase();
    if (!u) return false;
    if (/RMRCC|RMR CC/.test(u)) return false;
    if (/ACOG|\bMRO\b|MAGNIFIER|VX-?5HD|UNITY FAST|\bROF-|\bROF /.test(u)) return false;
    if (/HEXCAP|BATTERY CAP|SEALING PLATE|HEIGHT SIGHT|HT SGT|HT SGTS|BLNK RMR|RMR HEIGHT|BACKUP SIGHT/.test(u)) return false;
    if (/GUARDIAN|RADIAN GRDN/.test(u)) return false;
    if (/\b(PLT|PLATE|ADP|ADAPTER|ADPTR|HOLSTER|HLSTR)\b/.test(u)) return false;
    if (/\b(MOUNT|MNT|MOUNTS|MNTS)\b/.test(u)) return false;
    if (/Q-LOC|QLOC|PICATINNY|CO-WIT|COWIT|OFFSET|RMR CAP|RMR RISER|RMR LIGHTWEIGHT|MK2 \d+MM RMR/.test(u)) return false;
    if (/\bRMR\b/.test(u) && /TYPE\s*2|TYPE2|\bHD\b|\bHRS\b/.test(u)) return true;
    if (/TRIJICON RMR ADJUSTABLE|TRIJICON RMR TYPE/.test(u)) return true;
    if (/\bSRO\b/.test(u) && /MOA|RED DOT|GREEN DOT|LED/.test(u)) return true;
    if (/\bRCR\b/.test(u) && /MOA|LED|ADJ/.test(u)) return true;
    if (/C&H\s+(DUTY|COMP)\b/.test(u) && /RED DOT/.test(u)) return true;
    if ((/^C&H\b/.test(u) || /C&H PRECISION/.test(v)) && /DUTY RED DOT|COMP RED DOT|DUTY XL RED DOT/.test(u)) return true;
    if (/MPO-DF|MPO DF/.test(u)) return true;
    if (/RMR FP|RMR FOOTPRINT/.test(u) && /MOA|RED DOT|MICRO|SLS/.test(u)) return true;
    return false;
  }

  function applyGlockRmrDotFit(found, title, blob) {
    if (!isRmrFootprintPistolDot(title, '')) return;
    found['17'] = 1;
    found['19'] = 1;
    found['34'] = 1;
    found['45'] = 1;
  }

  function applyGlockMosFit(found, title, blob) {
    var u = String(title || '').toUpperCase();
    var p = partType(title, '', blob);
    var plate = p === 'plates' || isFirearmOpticPlate(u);
    var mosMount = p === 'mounts' && /\bMOS\b/.test(u) && /RMR|SRO|HOLO|ACRO|EPS|\bDPP\b/.test(u);
    if (!plate && !mosMount) return;
    if (/43X|\bG48\b|48 MOS|G43X/.test(u) && !/\bG17\b|\bG19\b|\bG34\b|\bG45\b|FULL SIZE|FULL-SIZE/.test(u)) {
      return;
    }
    if (found['43'] || found['43X'] || found['48'] || found['42']) return;
    var generic = /\bMOS\b/.test(u) || /GLOCK MOS|FITS GLOCK MOS|FULL SIZE GLOCK MOS|FULL[- ]SIZE GLOCK/.test(blob);
    if (!generic && /GLOCK|\bGLK\b/.test(u) && /RMR|SRO|HOLO|ACRO|\bMOS\b/.test(u) && /\b(PLT|PLATE|ADP|ADAPTER|ADPTR)\b/.test(u)) {
      generic = true;
    }
    if (!generic && !found['17'] && !found['19'] && !found['34'] && !found['45']) return;
    found['17'] = 1;
    found['19'] = 1;
    found['34'] = 1;
    found['45'] = 1;
  }

  function applyGlock1734(found, title, blob) {
    var u = String(title || '').toUpperCase();
    var p = partType(title, '', blob);
    if (p === 'holsters' || p === 'barrels' || p === 'slides' || p === 'compensators') return;
    if (HOLSTER_RE.test(u) || /SCABBARD|\bSCBRD\b/.test(u)) return;
    if (found['17']) found['34'] = 1;
    if (found['34']) found['17'] = 1;
  }

  function applyGlockSharedFit(found, title, blob) {
    if (Object.keys(found).length) return;
    var p = partType(title, '', blob);
    if (p !== 'triggers' && p !== 'recoil' && p !== 'internals' && p !== 'springs' && p !== 'safeties') return;
    var slim = /43\/43X\/48|42\/43|43X\/48|GLOCK\s*42|GLOCK\s*43|\bG42\b|\bG43\b|\bG48\b|SLIMLINE|SINGLE[- ]STACK/.test(blob);
    var large = /LARGE FRAME|10MM|10 MM|\bG20\b|\bG21\b|\bG29\b|\bG30\b|\bG40\b|\bG41\b|20\/21\/29/.test(blob);
    var dsNamed = /\bG17\b|\bG19\b|GLOCK\s*17\b|GLOCK\s*19\b|STANDARD FRAME/.test(blob);
    if (slim && !dsNamed && !large) {
      GLOCK_SLIM.forEach(function (id) { found[id] = 1; });
      return;
    }
    if (large && !dsNamed) {
      GLOCK_LARGE.forEach(function (id) { found[id] = 1; });
      return;
    }
    if (/FITS GLOCK|FOR GLOCK|FITS GLK|FOR GLK|STANDARD GLOCK FRAME|GLOCK GEN|GLOCK FRAMES|GEN(?:ERATION)?\s*[1-6]/.test(blob)) {
      GLOCK_DS.forEach(function (id) { found[id] = 1; });
    }
  }

  function glockGensOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 900)).toUpperCase();
    var found = {};
    function add(n) {
      n = parseInt(n, 10);
      if (n >= 1 && n <= 6) found[String(n)] = 1;
    }
    function addRange(a, b) {
      a = parseInt(a, 10);
      b = parseInt(b, 10);
      if (a > b) { var t = a; a = b; b = t; }
      var i;
      for (i = a; i <= b; i++) add(i);
    }
    var m;
    var reGen = /GEN(?:ERATION)?\s*([1-6])(?![\d.])(?:\s*[\/,&-]\s*([1-6])(?![\d.]))?/g;
    while ((m = reGen.exec(blob))) {
      if (m[2]) addRange(m[1], m[2]);
      else add(m[1]);
    }
    var reGspan = /\bG([1-6])(?!\d)\s*-\s*G?([1-6])(?!\d)/g;
    while ((m = reGspan.exec(blob))) addRange(m[1], m[2]);
    var reGslash = /\bG([1-6])(?!\d)(?:\s*\/\s*G?([1-6])(?!\d))+/g;
    while ((m = reGslash.exec(blob))) {
      var chunk = m[0];
      var nre = /[1-6]/g;
      var n;
      while ((n = nre.exec(chunk))) add(n[0]);
    }
    return Object.keys(found).sort();
  }

  function hkModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = [];
    function add(id) { if (found.indexOf(id) < 0) found.push(id); }
    var uspCompact = /\bUSPC\b|USP-C|USP COMPACT|USP CMPCT|USP CMPT|USP CMP\b|USP COMP\b/.test(blob);
    var uspFull = /\bUSP-FS\b|USP FULL|USP TACT|USP-T\b|USP FS\b|FULL\/TACT/.test(blob);
    if (uspCompact) add('USPC');
    if (uspFull || (/\bUSP\b/.test(blob) && !uspCompact)) add('USP');
    if (uspCompact && uspFull) {
      add('USP');
      add('USPC');
    }
    if (/\bVP9|\bVP40|\bVP OR\b/.test(blob)) add('VP9');
    if (/\bP30/.test(blob)) add('P30');
    if (/\bP2000/.test(blob)) add('P2000');
    if (/HK45|\bHK 45\b|\b45C\b/.test(blob)) add('HK45');
    if (/\bCC9\b/.test(blob)) add('CC9');
    if (/\bMP5K\b|\bSP89\b|\bSP5K\b|\bSBT5K\b/.test(blob)) add('MP5K');
    if (/\bMP5\b|\bHK94\b|\bHK 94\b|\bSP5\b|\bMP5SD\b|\bSBT5(?:-22)?\b/.test(blob)) add('MP5');
    if (/\bHK91\b|\bHK 91\b|\bHK93\b|\bHK 93\b|\bG3\b/.test(blob)) add('HK91');
    if (/\bUMP\b|\bUSC\b/.test(blob)) add('UMP');
    if (/\bHK416\b|\bHK 416\b/.test(blob)) add('HK416');
    if (/\bMR762\b|\bMR 7\.62\b|\bMR556\b|\bMR 5\.56\b/.test(blob)) add('MR762');
    return found;
  }

  function rugerModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/10\/22|10-22|\b1022\b|RUG10-22/.test(blob)) add('10/22');
    var lcpMax = /LCP[- ]?MAX|LCPMAX|LCP RUG MAX/.test(blob);
    var lcpII = /LCP[- ]?II\b|LCPII\b|\bLCP2\b/.test(blob) &&
      !/LCP 2-?PK|LCP 2 ?PACK|LCP 2PK/.test(blob);
    if (lcpMax) add('LCP Max');
    if (lcpII) add('LCP II');
    if (/\bLCP\b/.test(blob) && !lcpMax && !lcpII) add('LCP');
    if (/LCP\/LCP\s*II|LCP\/LCPII/.test(blob)) {
      add('LCP');
      add('LCP II');
    }
    if (/LCP II\/LCP MAX|LCPII\/LCP MAX|LCP II\/LCPMAX/.test(blob)) {
      add('LCP II');
      add('LCP Max');
    }
    if (/\bLC9S?\b|\bLC380\b|\bEC9/.test(blob)) add('LC9');
    if (/MINI[- ]?14\s*\/\s*30|MINI[- ]?14\/30|MINI 14\/30|MINI-14\/MINI-30/.test(blob)) {
      add('Mini-14');
      add('Mini-30');
    } else {
      if (/MINI[- ]?14/.test(blob)) add('Mini-14');
      if (/MINI[- ]?30/.test(blob)) add('Mini-30');
    }
    if (/\bRXM\b/.test(blob)) {
      if (/SUB[- ]?CMPT|SUBCOMPACT/.test(blob)) add('RXMS');
      else if (/\bCOMPACT\b/.test(blob)) add('RXMC');
      else add('RXM');
    }
    if (/\bMAX-?9\b|\bMAX 9\b/.test(blob)) add('MAX-9');
    var markBlob = blob
      .replace(/M77\s*MKII/g, 'M77')
      .replace(/M77 MK II/g, 'M77')
      .replace(/LIB MK II/g, 'LIB');
    if (/22\/45|MK SERIES|MKI-IV|MK1-4|MK 1-4/.test(markBlob)) {
      add('Mark IV');
      add('Mark II');
    }
    if (/MKIV|MARK IV|MK IV|MKIII|MARK III|MK III/.test(markBlob)) add('Mark IV');
    if (/(?:\bMKI\b|MARK I\b|\bMKII\b|MARK II\b|MK II\b)/.test(markBlob) &&
        !/MKIII|MKIV|MARK III|MARK IV/.test(markBlob)) add('Mark II');
    if (/MKII III/.test(markBlob)) {
      add('Mark II');
      add('Mark IV');
    }
    if (/\bSR22\b|\bSR-22\b/.test(blob)) add('SR22');
    if (/\bSR1911\b|\bSR-1911\b/.test(blob)) add('SR1911');
    if (/\bGP100\b|\bGP-100\b/.test(blob)) add('GP100');
    if (/\bSP-?101/.test(blob)) add('SP101');
    if (/REDHAWK|\bRDHWK\b|\bRHWK\b/.test(blob)) add('Redhawk');
    if (/\bLCRX\b|\bLCR\b/.test(blob) && !/TLR/.test(blob)) add('LCR');
    var secCompact = /SEC[- ]?9\s*CMP|SECURITY[- ]?9 COMPACT|SEC[- ]?9 COMPACT/.test(blob);
    var sec9 = /SECURITY[- ]?9|\bSEC[- ]?9\b|\bSEC9\b/.test(blob);
    var sec380 = /SEC[- ]?380|SECURITY[- ]?380/.test(blob);
    if (secCompact) add('SEC9C');
    if (sec9 && !secCompact) add('SEC9');
    if (sec380) add('SEC380');
    if (/SEC SIX|SECURITY[- ]SIX|SEC[- ]?6\b/.test(blob)) add('Security-Six');
    if (/\bM77\b/.test(blob)) add('M77');
    if (/AMERICAN RIMFIRE|AMER RIMFIRE/.test(blob)) add('American RF');
    else if ((/\bAMERICAN\b|\bAMCN\b|\bAMER\b|\bAM RANCH\b|RUGER AM\b|RUG AM\b/.test(blob) ||
        /350 LEGEND/.test(blob)) && !/AMERIGLO/.test(blob)) add('American');
    if (/PRECISION RIMFIRE|PRECISIN RF|PRCSN RF/.test(blob)) add('Precision RF');
    else if (!/10\/22|10-22/.test(blob) &&
        (/\bRPR\b/.test(blob) ||
          /RUGER PRECISION|RUGER PRECISIN|RUGER PRCSN|RUGER PREC\b|RUG PRCSN|RUG PREC\b/.test(blob) ||
          (/AI STYLE|\bAICS\b/.test(blob) && /RUGER/.test(blob)))) add('Precision');
    if (/\bPCC\b|\bPC9\b|PC CARBINE|RUG PC\b|SEC-?9\/PC/.test(blob)) add('PC Carbine');
    if (/\bWRNGLR\b/.test(blob) || (/\bWRANGLER\b/.test(blob) && /RUGER|\bRUG\b/.test(blob))) add('Wrangler');
    if (/RUGER[- ]?5\.7|RUGER 57\b|\b57 OPTIC/.test(blob)) add('5.7');
    if (/\bP85\b|\bP89\b|\bP90\b|\bP91\b|\bP93\b|\bP94\b|\bP95\b|\bP97\b/.test(blob) &&
        /RUGER|\bRUG\b/.test(blob)) add('P-series');
    if (/\bSR9C?\b|\bSR40C?\b|\bSR45\b/.test(blob)) add('SR9');
    if (/BLKHWK|SUPER BLACKHAWK/.test(blob) ||
        (/\bBLACKHAWK\b/.test((title || '').toUpperCase()) && /RUGER|\bRUG\b/.test(blob))) add('Blackhawk');
    if (/GUNSITE/.test(blob)) add('Scout');
    return Object.keys(found);
  }

  function taurusModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    var gx4c = /GX4 CARRY|GX4 CRRY|GX4C\b/.test(blob);
    if (gx4c) add('GX4C');
    else if (/\bGX4\b/.test(blob) || /G3\/G4/.test(blob)) add('GX4');
    if (/\bG3C\b|\bG3X\b/.test(blob)) add('G3C');
    if (/\bG3\b/.test(blob) && !/\bG3C\b|\bG3X\b/.test(blob)) add('G3');
    if (/G3\/GX4|G3\/G4/.test(blob)) add('GX4');
    if (/G3\/G2/.test(blob)) {
      add('G3');
      add('G2C');
    }
    if (/\bG2C\b|\bG2S\b|\bG2X\b|\bG2\b/.test(blob)) add('G2C');
    var pub = /P-DEF|PUBLIC DFDR|PUBLIC DEFENDER|JUDGE PD\b/.test(blob);
    if (pub) add('PubDef');
    if (/\bJUDGE\b/.test(blob) && !pub) add('Judge');
    if (/TRACKER|\bTRKR\b/.test(blob)) add('Tracker');
    if (/RAGING BULL|RAGING HNTR|RAGING HUNTER/.test(blob)) add('Raging');
    if (/\bTX22\b/.test(blob)) add('TX22');
    if (/TX9 SUB/.test(blob)) add('TX9S');
    else if (/TX9 COMPACT/.test(blob)) add('TX9C');
    else if (/\bTX9\b/.test(blob)) add('TX9');
    if (/\bPT111\b/.test(blob)) add('PT111');
    if (/738TCP|\b738 TCP\b/.test(blob) || (/\bTCP\b/.test(blob) && /TAUR|738/.test(blob))) add('TCP');
    if (/\bGX2\b/.test(blob)) add('GX2');
    if (/\b856\b/.test(blob) && /TAUR|XS /.test(blob)) add('856');
    if (/\bTAURUS 85\b|\bTAURUS 85\b|MONOGRIP TAURUS 85/.test(blob) ||
        (/\b85\b/.test(blob) && /TAURUS/.test(blob) && !/\b856\b/.test(blob))) add('85');
    if (/SM FRAME/.test(blob) && /TAUR/.test(blob)) {
      add('85');
      add('856');
    }
    if (/MIL\/SLM|MILLENNIUM|\bMIL SLM\b/.test(blob)) add('Millennium');
    if (/\bCURVE\b/.test(blob) && /TAUR/.test(blob)) add('Curve');
    if (/\bRPC\b/.test(blob) && /TAUR/.test(blob)) add('TX9');
    if (/\b94\b/.test(blob) && /TAURUS 94/.test(blob)) add('85');
    return Object.keys(found);
  }

  function berettaModelsOf(title, desc) {
    var u = (title || '').toUpperCase();
    var d = descHead(desc, 700);
    var blob = u + ' ' + d;
    var found = {};
    function blocked(token) {
      var t = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return new RegExp(
        '(DOES NOT FIT|DO NOT FIT|NOT FIT|WONT FIT|WON\'T FIT|EXCLUDING|EXCLUDES)\\s+' + t + '\\b'
      ).test(blob);
    }
    function add(id) { if (!blocked(id.toUpperCase())) found[id] = 1; }
    if (/\b92FS\b|\b92X\b|\b92A1\b|\b92F\b|\b92C\b|\bM9A3\b|\bM9A1\b|\bM92\b|\bM9\b/.test(blob) ||
        /BERETTA 92\b|\bBER 92\b|92\/96|PX\/92|\b92\/APX/.test(blob)) add('92');
    if (/BERETTA 96\b|\bBER 96\b|92\/96|\bPX\/92\/96/.test(blob) || (/\b96\b/.test(u) && /BERETTA|\bBER\b|\bBRTTA\b/.test(u))) add('96');
    if (/\bPX4|\bPX4SC\b|BER PX\b|PX4 STORM|\bPX\/92/.test(blob)) add('PX4');
    if (/\bAPX\b/.test(blob) && !/APEX/.test(blob)) add('APX');
    if (/\b1301\b/.test(blob)) add('1301');
    if (/TOMCAT|\b3032\b/.test(blob)) add('Tomcat');
    if (/\bA300\b/.test(blob)) add('A300');
    if (/\bA400\b/.test(blob)) add('A400');
    if (/\b21A\b|BOBCAT|BERETTA 21\b|MAG BERETTA 21/.test(blob) && !/\bNAA\b/.test(u)) add('21');
    if (/\b950\b|JETFIRE/.test(blob)) add('950');
    if (/\bNANO\b/.test(blob)) add('Nano');
    return Object.keys(found);
  }

  function coltModelsOf(title, desc) {
    var u = (title || '').toUpperCase();
    var d = descHead(desc, 700);
    var blob = u + ' ' + d;
    var found = {};
    function add(id) { found[id] = 1; }
    var officer = (!/\bSPDLR\b|\bSPDLDR\b|SPEEDLOADER/.test(u) &&
      (/\bDEFENDER\b|MAG COLT OFFICER|MAG .*OFFICER|COLT OFFICER|1911 OFFICER|OFFICERS\/DEFENDER/.test(blob)));
    if (officer) add('Officer');
    if (/\b1911\b|GVT\/GC|\bGVT\b|\bGOVT\b|GOVERNMENT|\bCMDR\b|COMMANDER|GOLD CUP|DELTA ELITE|DBL EGL|DOUBLE EAGLE/.test(blob) && !officer) add('1911');
    if (!officer && /FITS 1911|FOR 1911|1911 PISTOL|1911 FULL/.test(blob)) add('1911');
    if (/\bPYTHON\b/.test(blob)) add('Python');
    if (/\bANACONDA\b/.test(blob)) add('Anaconda');
    if (/KING COBRA|\bK COBRA\b/.test(blob)) add('King Cobra');
    var cobraLeft = blob.replace(/KING COBRA/g, ' ').replace(/\bK COBRA\b/g, ' ');
    if (/\bCOBRA\b/.test(cobraLeft) && !(/DET SPL|DETECTIVE SPECIAL/.test(u) && !/COLT COBRA|FOR COLT COBRA|FITS COLT COBRA|COBRA\//.test(cobraLeft))) {
      add('Cobra');
    }
    if (/DETECTIVE SPECIAL|\bDET SPL\b|\bDET-SPL\b|\bDT SPL\b/.test(blob)) add('Detective Special');
    if (/\bVIPER\b/.test(blob) && !/GLOCK|\bAR[- ]?15\b/.test(blob)) add('Viper');
    if (/DIAMONDBACK|\bDBACK\b/.test(blob)) add('Diamondback');
    if (/\bSAA\b|SINGLE ACTION ARMY|PEACEMAKER/.test(blob)) add('SAA');
    return Object.keys(found);
  }

  function mossbergModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\b500\b|MAVERICK[- ]?88|\bSHOCKWAVE\b|\bSHKWV\b|\bSHCKWVE\b|\bSHK\/|\bFLEX\b/.test(blob)) add('500');
    if (/\b590\b|590A1|590M/.test(blob)) add('590');
    if (/\b835\b/.test(blob)) add('835');
    if (/\b702\b/.test(blob)) add('702');
    if (/\b930\b/.test(blob)) add('930');
    if (/\b940\b/.test(blob)) add('940');
    if (/\b990\b/.test(blob)) add('990');
    if (/PATRIOT/.test(blob)) add('Patriot');
    return Object.keys(found);
  }

  function remingtonModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\b870\b|REM870|REM 870/.test(blob)) add('870');
    if (/\b1100\b/.test(blob)) add('1100');
    if (/\b1187\b/.test(blob)) add('1187');
    var is700 = /\b700\b|REM700|\bR700|REM 700/.test(blob);
    if (/\bREM SA\b|\bREM LA\b/.test(blob)) is700 = true;
    var sa = /700SA|R700SA|R700 SA|700 SA\b|REM 700 SA|SHORT ACTION|\bREM SA\b|HUNTER LTE|HUNTER LITE|HUNTER 700 STK|CHASSIS SA\b/.test(blob);
    var la = /700LA|R700LA|R700 LA|700 LA\b|700L\b|LONG ACTION|\bREM LA\b|HUNTER 700L|CHASSIS LA\b/.test(blob);
    if (is700) add('700');
    if (is700 && sa && !la) add('700SA');
    else if (is700 && la && !sa) add('700LA');
    else if (is700) {
      add('700SA');
      add('700LA');
    }
    if (/\b597\b/.test(blob)) add('597');
    var pumpBlob = blob.replace(/\b[A-Z]{1,10}-?\d{2,5}(?:-[A-Z0-9]+)+\b/g, ' ');
    if (!/\b7400\b/.test(pumpBlob) &&
        (/REM(?:INGTON)?[- ]?(760|742|740)\b/.test(pumpBlob) ||
          /\b(740|742|760)\s*\/\s*(740|742|760)/.test(pumpBlob) ||
          /FITS REMINGTON (740|742|760)\b/.test(pumpBlob))) {
      add('760');
    }
    return Object.keys(found);
  }

  function sigModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    var xmacro = /XMACRO|X-MACRO|P365MACRO|365MACRO/.test(blob);
    var fuse = (/P365[- ]?FUSE|SIG 365 FUSE|SAUER FUSE/.test(blob) ||
      (/\bFUSE\b/.test(blob) && /SIG|SAUER|P365/.test(blob) && !/ULTRX|BIONIC/.test(blob)));
    var xl = /P365[- ]?XL|\b365XL\b|P365 XL|365X\/XL|WCP365 XL/.test(blob);
    var x = /P365X\b|\b365X\b|365X\//.test(blob) && !xmacro;
    var p365any = /P[- ]?365|SIGP365|SIG 365|WCP365/.test(blob) || xmacro || fuse;
    if (fuse) add('P365F');
    if (xmacro) add('P365M');
    if (xl) add('P365XL');
    if (x && !xl) add('P365X');
    if (x && xl) add('P365X');
    if (p365any && !fuse && !xmacro && !xl && !x) add('P365');
    if (/P365\/XL|P365\/P365XL|P365\/365XL/.test(blob)) {
      add('P365');
      add('P365XL');
    }
    if (/P365\/XMACRO|XL\/XMACRO/.test(blob)) {
      add('P365XL');
      add('P365M');
    }
    if (/P365\/FUSE/.test(blob)) add('P365');

    var xten = /X-TEN|\bXTEN\b|X TEN/.test(blob);
    var p320c = /P320C\b|P[- ]?320C|P320 COMPACT|WCP320 COMPACT/.test(blob) ||
      (/\bM18\b/.test(blob) && /SIG|SAUER|P320/.test(blob));
    var p320x = /P320X\b|P320 X\b|X-COMPACT|X-CARRY|XCOMPACT|XCARRY|WCP320 CARRY/.test(blob);
    var p320any = /P[- ]?320|SIGP320|SIG 320|WCP320|\bK320\b/.test(blob) ||
      ((/\bM17\b|\bM18\b/.test(blob)) && /SIG|SAUER|P320/.test(blob));
    if (xten) add('P320XT');
    if (p320c) add('P320C');
    if (p320x) add('P320X');
    if (p320any && !xten && !p320c && !p320x) add('P320');
    if (/P320 FULL|P320F\b/.test(blob)) add('P320');
    if (/\bM17\b/.test(blob) && /SIG|SAUER|P320/.test(blob)) add('P320');

    if (/P[- ]?226|SIGP226|SIG 226|\/226\b/.test(blob)) add('P226');
    if (/P[- ]?229|SIGP229|SIG 229|P[- ]?228|SIG 228|\/229\b/.test(blob)) add('P229');
    if (/P[- ]?220|SIGP220|SIG 220/.test(blob)) add('P220');
    if (/P[- ]?230|P[- ]?232/.test(blob)) add('P230');
    if (/P[- ]?938/.test(blob)) add('P938');
    if (/P[- ]?239/.test(blob)) add('P239');
    if (/P[- ]?238/.test(blob)) add('P238');
    if (/P[- ]?225/.test(blob)) add('P225');
    if (/P[- ]?250/.test(blob)) add('P250');
    if (/\bMPX\b/.test(blob)) add('MPX');
    if (/\bMCX\b/.test(blob)) add('MCX');
    if (/SIG CROSS|SIG-CROSS/.test(blob) || (/\bCROSS\b/.test(blob) && /SIG|SAUER/.test(blob))) add('Cross');
    if (/SIG[- ]?556|\bSIG556\b/.test(blob)) add('556');
    if (/P SERIES|P-SERIES/.test(blob) && !/P365|P320/.test(blob)) {
      add('P226');
      add('P229');
    }
    return Object.keys(found);
  }

  function springfieldModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    var hellPro = /HELLCAT PRO|HELLCT PRO|HLCT PRO/.test(blob);
    var hell = /HELLCAT|HELLCT|\bHLCT\b|H-CAT|\bHCAT\b/.test(blob);
    if (hellPro) add('Hellcat Pro');
    if (hell && !hellPro) add('Hellcat');
    if (/HELLCAT\/PRO|HELLCAT\/HELLCAT PRO|HELLCAT\/PRO\b/.test(blob)) {
      add('Hellcat');
      add('Hellcat Pro');
    }
    var echC = /ECHELON C\b|ECHELON 4\.0C|4\.0C|ECH CMPCT|ECH COMPACT|ECHELON COMPACT/.test(blob);
    if (echC) add('ECHC');
    else if (/\bECHELON\b/.test(blob)) add('Echelon');
    var xds = /\bXDS\b|\bXD[- ]?S\b|XDSM2/.test(blob);
    var xdm = /\bXDM\b|\bXD[- ]?M\b|XDME|XDM9|XDM45|XDM ELITE|XDM ELTE/.test(blob);
    var xde = /\bXDE\b|\bXD[- ]?E\b/.test(blob);
    if (xds) add('XDS');
    if (xdm) add('XDM');
    if (xde) add('XDE');
    if ((/\bXD\b|XD9|XD40|XD45|\bXDG\b|XD940/.test(blob)) && !xds && !xdm && !xde) add('XD');
    if (/XD\/XDM|XD\/XDS/.test(blob)) add('XD');
    if (/\bM1A\b|\bM14\b/.test(blob)) add('M1A');
    if (/\bEMP\b/.test(blob)) add('EMP');
    if (/\bPRODIGY\b/.test(blob)) add('Prodigy');
    if (/\b1911\b/.test(blob) || /SPG OPRT|SPRGFLD OPERATOR|SPRINGFIELD OPERATOR/.test(blob)) add('1911');
    if (/MAGAZINE SPRGFLD 45ACP [78]RD/.test(blob) && !xds && !xdm && !/\bXD\b/.test(blob)) add('1911');
    if (/MATCH RFL/.test(blob) && /SPRGFLD|SPRINGFIELD/.test(blob)) add('M1A');
    return Object.keys(found);
  }

  function swModelsOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    var plus = /SHIELD PLUS|SHLD PLUS|SHLD\+|SHIELD-PLS|SHIELD PLS|SHLDPLUS/.test(blob);
    var ez = /SHIELD EZ|SHLD EZ|380EZ|EZ380|9EZ|EZ-9|EZ\.380|EZ 380|EZ 9|SHIELD 380 EZ/.test(blob);
    var sx = /SHIELD X\b|SHLD X\b/.test(blob);
    var shieldArmsExt = /^SHIELD\b/.test((title || '').toUpperCase()) && /MAG EXT/.test(blob);
    var shield = !shieldArmsExt && (/\bSHIELD\b|\bSHLD\b/.test(blob) && !/HEATSHIELD|SHIELD ARMS|SHIELD SIGHTS/.test(blob));
    if (plus) add('Shield Plus');
    if (ez) add('Shield EZ');
    if (sx) add('Shield X');
    if (shield && !plus && !ez && !sx) add('Shield');
    if (/SHLD\/\s*SHLD\+|SHIELD\/SHIELD PLUS|SHLD\/ SHLD/.test(blob)) {
      add('Shield');
      add('Shield Plus');
    }
    var bg2 = /BDYGRD 2|BODYGUARD 2|BODYGRD 2|\bBG2\b|BDYGRD 2\.0|BODYGUARD 2\.0/.test(blob);
    var bg = /BODYGUARD|BDYGRD|BODYGRD|BDY GRD/.test(blob);
    if (bg2) add('BG2');
    if (bg && !bg2) add('Bodyguard');
    if (/\bEQUALIZER\b/.test(blob) || (/\/SHIELD EZ/.test(blob) && /\bEQ\b/.test(blob))) add('Equalizer');
    if (/\bEQ\/SHIELD/.test(blob)) {
      add('Equalizer');
      add('Shield EZ');
    }
    var shieldFam = !shieldArmsExt && (plus || ez || sx || /\bSHLD\b/.test((title || '').toUpperCase()) ||
      (/\bSHIELD\b/.test((title || '').toUpperCase()) && !/^SHLDS?\b/.test((title || '').toUpperCase())));
    var mpc = /M&PC\b|M&P COMPACT|2\.0 CMP|2\.0 COMPACT|M&P9 2\.0 CMP/.test(blob);
    var mp57 = /M&P 5\.7|M&P5\.7/.test(blob);
    var mp = (/M&P9|M&P40|M&P45|\bM&P\b|M2\.0|M&P 2\.0/.test(blob) && !/M&P15/.test(blob) && !mp57);
    if (!shieldFam) {
      if (mpc) add('MPC');
      if (mp && !mpc) add('MP');
    }
    if (/M&P15-?22/.test(blob)) add('MP1522');
    if (/M&P22\b/.test(blob) && !/15-?22/.test(blob)) add('MP22');
    if (/M&P 5\.7|M&P5\.7/.test(blob)) add('MP57');
    if (/\bCOMPETITOR\b/.test(blob)) add('MP');
    if (/\bSD9|\bSD9VE|\bSD40/.test(blob)) add('SD9');
    if (/\bCSX\b/.test(blob)) add('CSX');
    if ((/J-FR|J-FRM|J FRAME|JFR\b|J-FRAME|\b442\b|\b642\b|\b637\b/.test(blob)) &&
        /S&W|SMITH/.test(blob)) add('J-frame');
    if (/K\/L\/N/.test(blob)) {
      add('KL-frame');
      add('N-frame');
    } else if ((/K\/L|K-FR|L-FR|L FM|K FRAME|L FRAME|\b686\b|\b617\b|\b629\b/.test(blob)) &&
        /S&W|SMITH|\bSW\b/.test(blob)) add('KL-frame');
    if ((/N-FRM|N-FRAME|N FM|N FRAME/.test(blob)) && /S&W|SMITH|\bSW\b/.test(blob)) add('N-frame');
    if ((/X FRM|X-FRM|X-FRAME/.test(blob)) && /S&W|SMITH/.test(blob)) add('X-frame');
    if (/\b1854\b/.test(blob)) add('1854');
    if (/MDL 29|MODEL 29/.test(blob)) add('N-frame');
    if (/\bVICTORY\b/.test(blob)) add('Victory');
    if (/\bGOVERNOR\b/.test(blob)) add('Governor');
    if (/41\/422|MODEL 41|\bS&W 41\b/.test(blob)) add('41');
    return Object.keys(found);
  }

  function modelsOf(title, plat, desc, vendor) {
    plat = plat || null;
    if (!plat) return [];
    if (plat.parse === 'glock') return glockModelsOf(title, desc);
    if (plat.parse === 'hk') return hkModelsOf(title, desc);
    if (plat.parse === 'ruger') return rugerModelsOf(title, desc);
    if (plat.parse === 'taurus') return taurusModelsOf(title, desc);
    if (plat.parse === 'beretta') return berettaModelsOf(title, desc);
    if (plat.parse === 'colt') return coltModelsOf(title, desc);
    if (plat.parse === 'mossberg') return mossbergModelsOf(title, desc);
    if (plat.parse === 'remington') return remingtonModelsOf(title, desc);
    if (plat.parse === 'sig') return sigModelsOf(title, desc);
    if (plat.parse === 'springfield') return springfieldModelsOf(title, desc);
    if (plat.parse === 'sw') return swModelsOf(title, desc);
    if (plat.parse === '1911') return models1911Of(title, desc);
    if (plat.parse === 'ar15') return modelsAr15Of(title, desc);
    if (plat.parse === 'ar10') return modelsAr10Of(title, desc);
    if (plat.parse === 'ak') return modelsAkOf(title, desc);
    if (plat.parse === '1022') return models1022Of(title, desc);
    if (plat.parse === 'cz') return modelsCzOf(title, desc);
    if (plat.parse === 'walther') return modelsWaltherOf(title, desc);
    if (plat.parse === 'benelli') return modelsBenelliOf(title, desc);
    if (plat.parse === 'bersa') return modelsBersaOf(title, desc);
    if (plat.parse === 'canik') return modelsCanikOf(title, desc);
    if (plat.parse === 'cmmg') return modelsCmmgOf(title, desc);
    if (plat.parse === 'fn') return modelsFnOf(title, desc);
    if (plat.parse === 'henry') return modelsHenryOf(title, desc);
    if (plat.parse === 'iwi') return modelsIwiOf(title, desc);
    if (plat.parse === 'kahr') return modelsKahrOf(title, desc);
    if (plat.parse === 'keltec') return modelsKeltecOf(title, desc);
    if (plat.parse === 'kimber') return modelsKimberOf(title, desc);
    if (plat.parse === 'savage') return modelsSavageOf(title, desc);
    if (plat.parse === 'tikka') return modelsTikkaOf(title, desc);
    if (plat.parse === 'marlin') return modelsMarlinOf(title, desc);
    if (plat.parse === 'browning') return modelsBrowningOf(title, desc);
    if (plat.parse === 'airgun') return modelsAirgunOf(title, desc, vendor);
    var u = (title || '').toUpperCase();
    var found = [];
    (plat.models || []).forEach(function (id) {
      var token = id.toUpperCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re = id === '700'
        ? /\b700\b|REM700|\bR700/
        : id === '870'
          ? /\b870\b|REM870|REM 870/
          : (/^P\d/.test(id)
            ? new RegExp(token)
            : new RegExp('\\b' + token + '\\b'));
      if (!re.test(u)) return;
      var excluded = new RegExp(
        '(EXLDING|EXCLUDING|EXCLUDES|DOES NOT FIT|DO NOT FIT|NOT FIT|WONT FIT|WON\'T FIT)\\s+[^,]{0,48}' + token
      );
      if (excluded.test(u)) return;
      found.push(id);
    });
    return found;
  }

  function descHead(desc, max) {
    if (!desc) return '';
    return String(desc)
      .replace(/<[^>]+>/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .slice(0, max || 220)
      .toUpperCase();
  }

  var GLOCK_MOD = '43X|19X|17L|20L|30S|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31|32|33|34|35|36|37|38|39|40|41|42|43|44|45|47|48|49';
  var GLOCK_DS = ['17', '18', '19', '19X', '22', '23', '24', '25', '26', '27', '31', '32', '33', '34', '35', '37', '38', '39', '45', '47', '49'];
  var GLOCK_LARGE = ['20', '21', '29', '30', '36', '40', '41'];
  var GLOCK_SLIM = ['42', '43', '43X', '48'];

  function canonGlockModel(id) {
    if (id === '17L') return '17';
    if (id === '20L') return '20';
    if (id === '30S') return '30';
    return id;
  }

  function isAirgunFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/SLINGSHOT|SLINGSHT/.test(tv)) return false;
    if (/\bJTS\b/.test(tv) && /M12AR|M12AK|12GA|12 GA/.test(tv)) return false;
    if (/CROSMAN|UMAREX|\bUMX\b|\bGAMO\b|BENJAMIN|HATSAN|AIR VENTURI|SIG AIR/.test(tv)) return true;
    if (/\bJTS\b/.test(tv) && /AIRACUDA|AIRSTRYKE|BRAWN|PCP|AIR RIFLE|177CAL|\.177|\.22|\.25|\.30|PELLET|\bDCP\b/.test(tv)) return true;
    if (/^DAISY\b/.test(v) || /^DAISY\b/.test(u)) return true;
    if (/\b(AIRGUN|AIR RIFLE|AIR PISTOL|AIR RFL)\b/.test(tv)) return true;
    if (/\.177\b|177BB|177PEL|177CAL/.test(tv) && /\b(BB|PELLET|PCP|FPS|AIR)\b/.test(tv)) return true;
    if (/\bPCP\b/.test(tv) && /AIR|PELLET|GAMO|UMX|CROSMAN|BENJAMIN|JTS/.test(tv)) return true;
    return false;
  }

  function modelsAirgunOf(title, desc, vendor) {
    var blob = ((title || '') + ' ' + (vendor || '') + ' ' + descHead(desc, 400)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/CROSMAN/.test(blob)) add('Crosman');
    if (/UMAREX|\bUMX\b/.test(blob)) add('Umarex');
    if (/\bGAMO\b/.test(blob)) add('Gamo');
    if (/DAISY/.test(blob)) add('Daisy');
    if (/BENJAMIN/.test(blob)) add('Benjamin');
    if (/\bJTS\b/.test(blob) && !/M12AR|M12AK|12GA/.test(blob)) add('JTS');
    if (/HATSAN/.test(blob)) add('Hatsan');
    return Object.keys(found);
  }

  function airgunPartType(u) {
    if (/SLINGSHOT|SLINGSHT/.test(u)) return 'other';
    if (/HAND PUMP/.test(u)) return 'other';
    if (/TARGET|GALLERY|PELLET TRAP/.test(u) && !/\d+FPS/.test(u)) return 'other';
    if ((/^MAG\b/.test(u) || /\bMAGAZINE\b/.test(u) || /INERTIA MAG|QUICK-SHOT|SPARE CLIPS/.test(u)) &&
        !/AMMO BOX/.test(u) && !/MAG FIRE/.test(u)) {
      return 'magazines';
    }
    var isGun = /\d+FPS|AIR PISTOL|AIR RIFLE|AIR RFL|\bPSTL\b|BLOWBACK|SNUBNOSE|RVLVR|REVOLVER|CARBINE|BULLPUP|\bPCP\b|BREAK BARREL|PUMPMASTER|RED RYDER|W\/SCP|W\/SCOPE|W\/4X|W\/LSR|BB RIFLE|\bRFL\b|GEN3I|MULTI-?PUMP/.test(u);
    var ammoWord = /PELLET|PLLT|PELLTS|WADCUTTER|COPPERHEAD|RED FIRE|DESTROYER|\bBBS\b|STEEL BB|STL BB|LEAD BB|LETHAL|TOMAHAWK|LUXOR|HUNTER ROUND|SPIRE POINT|H-POINT|\bDOMED\b|TEST PACK|\bDCP\b|COMBO PACK|SHOT SHELL AMMO|HOLLOW POINT/;
    var ammoCount = /\d+\s*\/\s*(CD|CT|TIN|PK|BX|BTL|TUBE)|\bCOUNT\b|\d+\s*-?\s*(CT|PK|TIN)|BTL|\d+GR|\d{2,4}CT|\d{2,4}PK|\d{3,}\/?BTL|BLSTR/;
    if (/COMBO PACK|SHOT SHELL AMMO/.test(u)) return 'ammo';
    if (/DESTROYER/.test(u) && !isGun) return 'ammo';
    if (/\bPELLETS\b|\bPELLTS\b/.test(u) && !isGun) return 'ammo';
    if (/CO2 (CARTRIDGE|CYLINDER)|CO2 CYL|N2 NITROGEN CARTRIDGE/.test(u) && !isGun) return 'ammo';
    if (ammoWord.test(u) && ammoCount.test(u) && !isGun) return 'ammo';
    if (/\bBBS?\b/.test(u) && ammoCount.test(u) && !isGun) return 'ammo';
    if (/STL BB|STEEL BB/.test(u) && /\d{3,}/.test(u) && !isGun) return 'ammo';
    if (ammoCount.test(u) && /CAL|\.177|\.22|\.25|\.30|177CAL|22CAL/.test(u) && !isGun) return 'ammo';
    if (/HOLLOW POINT/.test(u) && !/\d+FPS|W\/SCP|GEN3I|PISTOL|RIFLE/.test(u)) return 'ammo';
    if (/RED RYDER/.test(u) && /PISTOL|RVLVR|REVOLVER/.test(u)) return 'air-pistols';
    if (/AIR RIFLE|\bPCP\b|CARBINE|BULLPUP|PUMPMASTER|OPTIMUS|VANTAGE|\bTYRO\b|1077|MAG FIRE|GAUNTLET|MARAUDER|SYNERGIS|NOTOS|JAVELIN|BREAK BARREL|\bRFL\b|AIRACUDA|AIRSTRYKE|BRAWN|RED RYDER|BB RIFLE|POWERLINE|SWARM|WILDCAT|MAXXIM|FUSION 10X|GRIZZLY|MULTI-?PUMP|MULTIPUMP|LVR ACT|LEVER ACT|TRAIL NP|SURGEMAX|WINCHESTER 1866|KOMPLETE|AIR SABER|URBANA|\bARROW\b|PELLET RIFLE|\bAH COMBO\b/.test(u) ||
        (/FULL AUTO/.test(u) && /RFL|RIFLE|SBR|AK1|\bR1\b/.test(u)) ||
        /\bR1 BB\b|\bM1 BB\b/.test(u)) {
      return 'air-rifles';
    }
    if (/AIR PISTOL|\bPSTL\b|BLOWBACK|SNUBNOSE|RVLVR|REVOLVER|\bC11\b|MK45|\bP1\b|PFAM9|MAKO|VIGILANTE|SNR357|MK IV|BB PISTOL|AMERICAN CLASSIC|\bP-?900\b|\bP-?430\b|GP-20|PT-85|\bC-15\b|HDP50|\bXBG\b|MODEL 415|MODEL 426|MODEL 340|\bP2P\b|\bAPX\b/.test(u) ||
        (/\bPISTOL\b/.test(u) && !/CONV|CONVERSION/.test(u))) {
      return 'air-pistols';
    }
    if (/\.177\b|177BB|177PEL|177CAL/.test(u) && !ammoCount.test(u)) return 'air-pistols';
    if (/\.22\b|22CAL|\.25\b|25CAL|\.30\b|30CAL/.test(u) && !ammoCount.test(u)) return 'air-rifles';
    return 'other';
  }

  function isGlock(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 480);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (skipFirearmFamily(title, vendor)) return false;
    if (/EOTECH|\bHHS\b|MAGNIFIER|VX-?5HD|VX5HD|LEUPOLD|UNITY FAST/.test(tv)) return false;
    if (/FLASH HIDER|ASR FLASH|\bM13\.5X1LH\b/.test(u) && !/GLOCK|GLK/.test(u)) return false;
    if ((/\bBCG\b|BOLT CARRIER/.test(tv) || /\bBCG\b/.test(d)) &&
        /\b(AR[- ]?15|AR15|AR[- ]?9|AR9|AR PLATFORM|\bPCC\b)\b/.test(blob)) return false;
    if (/\b(AR[- ]?15|AR15|AR[- ]?9|AR9|\bPCC\b)\b/.test(blob) &&
        /GLOCK (STYLE |PATTERN )?(MAGAZINE|MAG\b)|COLT AND GLOCK|GLOCK AND COLT|GLOCK MAGAZINE/.test(blob) &&
        !/FITS GLOCK \d/.test(d)) return false;
    if (/\b(P365|RXM|OZ9|HELLCAT)\b/.test(u) && !/GLOCK \d|\bG(?:19|17|43)/.test(u)) return false;
    if (/GLOCK PATTERN|GLOCK STYLE/.test(blob) && /1913|PICATINNY/.test(blob) && !/FITS GLOCK \d/.test(blob)) return false;
    if (/FITS GLOCK AND 1913|GLOCK AND 1913 RAIL/.test(d) && !/FITS GLOCK \d/.test(d)) return false;
    if (isRmrFootprintPistolDot(title, vendor)) return true;
    if (/\b(RED DOT|RIFLE SCOPE|HOLOGRAPHIC)\b/.test(u) && !/FITS GLOCK \d/.test(d)) return false;
    if (/GLOCK|\bGLK\b|GLCK|GLK\d|\bGL ?(?:17|19|20|21|22|23|26|27|29|30|34|43|45)/.test(tv)) return true;
    if (new RegExp('\\bG(?:' + GLOCK_MOD + ')\\b').test(u)) return true;
    if (/\bG(?:17|19|20|21|22|23|26|27|29|30|31|32|34|35|40|41|42|43|45|47|48)(?:L|X|MOS|GEN)/.test(u)) return true;
    if (/(FITS GLOCK|FOR GLOCK|GLOCK GEN|\bGLOCK G\d|YOUR GLOCK|GLOCK SERVICE PISTOL|GLOCK PISTOLS?\b)/.test(d)) return true;
    if (/\bGLOCK\b/.test(d) && new RegExp('\\bG?(' + GLOCK_MOD + ')\\b').test(d) && !/GLOCK STYLE|GLOCK PATTERN RAIL|GLOCK AND 1913/.test(d)) return true;
    return false;
  }

  function isMossbergFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (/PEAT MOSS/.test(blob)) return false;
    if (/(BERETTA|\bBRTTA\b)/.test(tv) && /ADPT|ADAPTER/.test(tv)) return false;
    if (/\b870\b/.test(u) && !/\b(500|590|835|930|940)\b/.test(u)) return false;
    if (/MOSSBERG|\bMSBRG\b|\bMSSBRG\b|MOSSBRG/.test(blob)) return true;
    if (/\bMOSS\b/.test(tv) && /\b(500|590|835|930|940|702|990|PATRIOT|SHOCKWAVE|SHKWV)\b/.test(blob)) return true;
    if (/\bMSS\b/.test(tv) && /\b(500|590)\b/.test(tv)) return true;
    if (/\bMOS\b/.test(tv) && /\b(500|590)\b/.test(tv)) return true;
    if (/\b(SHOCKWAVE|SHKWV|SHCKWVE)\b/.test(tv) && /12GA|SHOTGUN|\bSG\b|MOSSBERG|MSBRG/.test(blob)) return true;
    if (/FITS MOSSBERG|FOR MOSSBERG|MOSSBERG 500|MOSSBERG 590/.test(d)) return true;
    return false;
  }

  function isHk(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/HKS\b/.test(tv) && !/HECKLER|\bH&K\b/.test(tv.replace(/HKS/g, ''))) return false;
    if (/H&R\b|HARRINGTON/.test(tv)) return false;
    if (/UMAREX|\bUMX\b/.test(tv) && /\b(BB|AIRGUN|AIR RIFLE|AIR PISTOL|400FPS|\.177)\b/.test(blob)) return false;
    if ((/SIGHT|SGHT|BATTLE/.test(u) || /SIGHT/.test(d)) && /\bHK\b/.test(u) &&
        /FRONT|REAR|STYLE|TYPE|FLIP|FOLDING|FLDNG/.test(u) &&
        !/MP5|USP|VP9|P30|HK94|HK91|HK93|SP89|UMP|H&K/.test(blob)) return false;
    if (/HK STYLE HOOK|HK HOOK/.test(u) && /WEBBING|SLING/.test(blob)) return false;
    if (/HECKLER|\bH&K\b|\bH & K\b|\bHK\b|\bHK\d{2}\b/.test(tv)) return true;
    if (/\bHK45\b|\bVP9|\bP2000|\bP30\b|\bCC9\b|\bMP5|\bSP89\b|\bUMP\b|\bUSP\b/.test(tv) &&
        /HECKLER|H&K|\bHK\b|KOCH/.test(blob)) return true;
    if (/\bMP5|\bSP89\b|\bHK94\b|\bHK91\b|\bHK93\b|\bUMP\b|\bSBT5/.test(tv)) return true;
    if (/FITS (HK|H&K|HECKLER)|HECKLER\s*&\s*KOCH|FITS MP5|HK PATTERN|HK SPEC/.test(d)) return true;
    return false;
  }

  function isColtFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/COLETAC|COLE-TAC|COLE TAC/.test(tv)) return false;
    if (/DURAMAG/.test(v) && /COLT PATTERN|AR[- ]?9|\bAR9\b|AR RIFLES/.test(blob)) return false;
    if (/\b(AR[- ]?15|AR15|M4|M16)\b/.test(blob) && !/1911|PYTHON|COBRA|ANACONDA|DETECTIVE/.test(tv)) return false;
    if (/\b(BCG|BOLT CARRIER|CARBINE HANDGUARD|LOWER RECEIVER PARTS|FIELD REPAIR|BOLT REPAIR|HIGH WEAR PARTS)\b/.test(tv)) return false;
    if (/\bCOLT\b/.test(tv)) return true;
    if (/FITS COLT|FOR COLT|COLT GOVERNMENT|COLT COMMANDER|COLT 1911|COLT PYTHON|COLT DETECTIVE|COLT SAA/.test(d)) return true;
    if (/PYTHON|ANACONDA|KING COBRA|DIAMONDBACK|\bDBACK\b|DETECTIVE SPECIAL|\bDET SPL\b/.test(tv)) return true;
    if (/\b(COBRA|VIPER)\b/.test(tv) && /COLT|XS SIGHT/.test(blob)) return true;
    return false;
  }

  function isBerettaFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (skipFirearmFamily(title, vendor)) return false;
    if (/UMAREX|\bUMX\b/.test(tv) && /\b(177BB|\.177|\bBB\b|AIR PISTOL|AIRGUN|AIR RIFLE)\b/.test(blob)) return false;
    if (/DERYA MELIK/.test(tv)) return false;
    if (/APEX TACTICAL|^APEX$/.test(v) && !/BERETTA/.test(blob)) return false;
    if (/\bBEN M4\b|BENELLI M4/.test(tv) && !/BERETTA|\bBRTTA\b|\bBER\b/.test(tv)) return false;
    if (/HIGH SPEED GEAR|\bHSGI\b/.test(v) && !/BERETTA/.test(d)) return false;
    if (/HOGUE HANDALL UNIV/.test(u)) return false;
    if (/HANDALL/.test(u) && !/BERETTA/.test(tv) && !/BERETTA/.test(d.slice(0, 280))) return false;
    if (/\bBERETTA\b|\bBRTTA\b/.test(blob)) return true;
    if (/\bBER\b/.test(tv) &&
        /\b(92|96|PX4|PX4SC|21|3032|TOMCAT|1301|A300|A400|M9|950|NANO|BOB)\b/.test(tv)) return true;
    if (/\b(92FS|PX4|1301|A300|A400|TOMCAT)\b/.test(tv) && !/APEX/.test(tv)) return true;
    if (/FITS BERETTA|FOR BERETTA|BERETTA 92|BERETTA PX|BERETTA APX|BERETTA TOMCAT|BERETTA NANO|BERETTA M9|BERETTA 1301|BERETTA A300/.test(d)) return true;
    return false;
  }

  function isRemingtonFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (skipFirearmFamily(title, vendor)) return false;
    if (/\bAR[- ]?15\b|\bAR15\b|\bAR[- ]?10\b|\bAR10\b|\bAR RIFLES?\b|\bAR PATTERN\b|\bM4\b|\bM16\b|\bL5AWM\b|\bHEXMAG\b/.test(blob)) {
      return false;
    }
    if (/REM-?OIL|ACTION CLEANER|BRITE BORE|DEHUMIDIFIER|GUN SACK|MOISTUREGUARD|SPORTSMAN CLEANING|DRILUBE|POP-UP WIPE|WIPES \d/.test(u)) return false;
    if (/WINCHESTER[- ]?70|\bWIN 70\b/.test(tv) && !/\b(870|700|1100|1187)\b/.test(u)) return false;
    if (/(BERETTA|\bBRTTA\b)/.test(u) && /ADPT|ADAPTER/.test(u)) return false;
    if (/SCABBARD/.test(u) && !/\b(870|1100|1187|REMINGTON)\b/.test(u)) return false;
    if (/RMNGTN/.test(blob)) return true;
    // 870 / 1100 / 1187 / 597 are distinctive. Do not treat .750 barrel
    // journals or bare 740/750/760 as Remington pump rifles.
    if (/\b(870|1100|1187|597)\b/.test(blob)) return true;
    if (/(?:REMINGTON|RMNGTN|\bREM)[- ]?(?:760|750|7400|742|740)\b/.test(blob)) return true;
    if (/\b(760|750|7400|742|740)\b/.test(blob) && /REMINGTON|RMNGTN/.test(blob)) return true;
    if (/\bR700\b|\bREM700\b|\bREM 700\b|REMINGTON 700/.test(blob)) return true;
    if (/FITS REMINGTON|FOR REMINGTON/.test(blob) && !/223 REMINGTON\/5\.56|5\.56 NATO/.test(d)) return true;
    if (/^REMINGTON\b/.test(v) && /\b(870|700|1100|1187|597|760|R700|REM700)\b/.test(blob)) return true;
    if (/\bREMINGTON\b/.test(u) && !/\b(17|222|223|22-250|25-06)\s+REMINGTON\b/.test(u)) return true;
    return false;
  }

  function isRugerFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/\b(PISTOL RUG|PSTL RUG|GUN RUG)\b/.test(tv)) return false;
    if (/\bRGR\b/.test(tv) && /SLING|PARACLIP|\bMS[134]\b/.test(tv) &&
        !/RUGER|\bM77\b|\bAMER\b|10\/22/.test(tv)) return false;
    if (/COLETAC|COLE-TAC|COLE TAC/.test(tv) && /WRANGLER/.test(tv) && !/RUGER/.test(tv)) return false;
    if ((/UMAREX|\bUMX\b/.test(tv)) &&
        /\b(\.177|\.22|177PEL|PELLET|\bBB\b|AIRGUN|AIR RIFLE|AIR PISTOL|\d+FPS)\b/.test(blob)) return false;
    if (/\bTSG-?22\b/.test(tv) && !/\b10\/22\b|\b10-22\b|\bRUGER\b|\bRUG\b/.test(tv)) return false;
    if (/\b(AR[- ]?15|AR15|SR-?556|BUFFER TUBE|UPPER PARTS KIT|\bLPK\b|AR SMALL PARTS|AR PATTERN|ELITE 452|\bMSR TRIGGER\b)\b/.test(tv) &&
        !/10\/22|10-22|\bLCP\b|MINI[- ]?14/.test(tv)) return false;
    if (/H&R|\bNEF\b|HARRINGTON/.test(tv) && !/RUGER|\bRUG\b/.test(tv)) return false;
    if (/\d+-\d+X/.test(u) && !/RUGER|\bRUG\b|10\/22|10-22/.test(u)) return false;
    if (/HKS/.test(tv) && /S&W|SMITH|COLT|TAU/.test(tv) &&
        !/GP100|SP101|REDHAWK|SEC[- ]?6|LCR|SP-?101/.test(tv)) return false;
    if (/\b204\s*RUG(?:ER)?\b/.test(tv) &&
        !/\bRUGER\b/.test(tv.replace(/204\s*RUG(?:ER)?/g, ' '))) return false;
    if (/\b(336|1894)\b/.test(tv) && /MARLIN|MRLN|MRLIN/.test(tv) && !/10\/22|\bLCP\b/.test(tv)) return false;
    if (/\bSAV(AGE)?\b/.test(tv) && /MKII/.test(tv) && !/RUGER/.test(tv)) return false;
    if (/\bRUGER\b/.test(tv)) return true;
    if (/^RUGER\b/.test(v) && !/UMAREX/.test(v)) return true;
    if (/10\/22|10-22|\b1022\b|RUG10-22/.test(tv)) return true;
    if (/\bLCP\b|\bLC9S?\b|\bLC380\b|\bEC9/.test(tv)) return true;
    if (/MINI[- ]?14|MINI[- ]?30/.test(tv)) return true;
    if (/\bRXM\b/.test(tv)) return true;
    if (/\bMAX-?9\b|\bMAX 9\b/.test(tv)) return true;
    if (/\bGP100\b|\bGP-100\b/.test(tv)) return true;
    if (/\bSP-?101/.test(tv)) return true;
    if (/REDHAWK|\bRDHWK\b|\bRHWK\b/.test(tv)) return true;
    if (/\bSR1911\b/.test(tv)) return true;
    if (/\bSR22\b/.test(tv)) return true;
    if (/\bLCRX\b|\bLCR\b/.test(tv) && !/TLR/.test(tv)) return true;
    if (/SECURITY[- ]?9|\bSEC[- ]?9\b|\bSEC9\b|SEC[- ]?380|SECURITY[- ]?380/.test(tv)) return true;
    if ((/SEC SIX|SECURITY[- ]SIX|SEC[- ]?6\b/.test(tv)) && /RUG|RUGER|HOGUE|HKS/.test(tv)) return true;
    if (/\bWRNGLR\b/.test(tv) || (/\bWRANGLER\b/.test(tv) && /\bRUG/.test(tv))) return true;
    if (/\bRUG\b/.test(tv)) return true;
    if (/\bRGR\b/.test(tv) && /\b(AMER|AMERICAN|M77|10\/22|10-22|LCR|SP101)\b/.test(tv)) return true;
    if (/FITS RUGER|FOR RUGER|RUGER 10\/22|RUGER LCP|RUGER AMERICAN|RUGER MARK|RUGER MINI/.test(d)) return true;
    return false;
  }

  function isSigFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/HOGUE/.test(tv) && HOGUE_KNIFE.test(tv)) return false;
    if (/MASTERLOCK|MASTER LOCK/.test(tv)) return false;
    if (/ULTRX FUSE|BIONIC FUSE/.test(tv)) return false;
    if (/MAGPUMP|MAG PUMP/.test(tv) && !/P[- ]?365|P[- ]?320|P[- ]?226|SAUER/.test(tv)) return false;
    if (/HEXCAP/.test(tv) && !/P[- ]?3[26]5|P[- ]?320|SAUER/.test(tv)) return false;
    if (/\b1911\b/.test(tv) && !/SIG|SAUER|P238|P938/.test(tv)) return false;
    if (/\b(ROMEO|TANGO|SIERRA|WHISKEY|OSCAR|ZULU|KILO)\b/.test(tv) &&
        !/P[- ]?3[26]5|P[- ]?320|P[- ]?22[69]|MPX|MCX/.test(tv)) return false;
    if (/\d+-\d+X/.test(u) && !/P[- ]?3[26]5|P[- ]?320|MPX|MCX|SAUER/.test(u)) return false;
    if (/(\.357|357)\s*SIG/.test(tv) &&
        !/P[- ]?\d{3}|SAUER|P365|P320/.test(tv.replace(/\.?357\s*SIG/g, ' '))) return false;
    if (/\bAR[- ]?15\b|\bAR15\b/.test(tv) && /TRIGGER|LPK|BOLT CATCH/.test(tv) &&
        !/SIG|SAUER|\bMPX\b|\bMCX\b/.test(tv)) return false;
    if (/SAUER/.test(tv)) return true;
    if (/P[- ]?365|SIGP365|WCP365|XMACRO|P365XL|P365X/.test(tv)) return true;
    if (/P[- ]?320|SIGP320|WCP320|\bK320\b|X-TEN|\bXTEN\b/.test(tv)) return true;
    if (/P[- ]?226|P[- ]?229|P[- ]?228|P[- ]?220|P[- ]?230|P[- ]?232|P[- ]?938|P[- ]?239|P[- ]?238|P[- ]?225|P[- ]?250|P[- ]?227/.test(tv)) return true;
    if (/\bSIG\s*(365|320|226|229|228|220|250|938|239|225|230|556)/.test(tv)) return true;
    if (/\bMPX\b|\bMCX\b/.test(tv)) return true;
    if (/SIG[- ]?CROSS|SIG CROSS/.test(tv)) return true;
    if (/SIG[- ]?556|\bSIG556\b/.test(tv)) return true;
    if (/\bSIG\b/.test(tv) && /P SERIES|P-SERIES/.test(tv)) return true;
    if (/\bSIG\b/.test(tv) && /P[- ]?\d{3}|P365|P320|MPX|MCX|CROSS|556|SAUER/.test(blob)) return true;
    if (/FITS SIG|FOR SIG|SIG SAUER|SIG P365|SIG P320|SIG 365|SIG 320/.test(blob)) return true;
    if (/^SIG SAUER\b/.test(v)) return true;
    return false;
  }

  function isSpringfieldFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/30-?06|3006SPFLD|30-06SPFG|30-06SGP/.test(tv) &&
        !/HELLCAT|ECHELON|XDS|XDM|\bXD\b|M1A|EMP|PRODIGY/.test(tv)) return false;
    if (/GOLD DOT|\d+GR HP|100-COUNT|\b100CT\b/.test(tv) &&
        (/SPEER/.test(v) || /GOLD DOT/.test(u))) return false;
    if (/KLEEN-BORE|KLEEN BORE|^KLEEN-?BR\b/.test(v) || (/KLEEN/.test(v) && /PATCH|DEGREASER|GUNK OUT/.test(u))) return false;
    if (/WALKER/.test(v) && /MUFF|HEARING/.test(u)) return false;
    if (/KERSHAW/.test(v) && /POINT|KINDRED|KNIFE|BLADE/.test(u)) return false;
    if (/BIRCHWOOD|^B\/C\b/.test(tv) && /TGT|TARGET|SHPNG/.test(u)) return false;
    if (/ATHLON|ATN CORP|^ATN\b/.test(v)) return false;
    if (/^SPEER\b/.test(v)) return false;
    if (/LEUPOLD/.test(v) && /\d+-\d+X|FIREDOT|MARK [34]/.test(u) &&
        !/HELLCAT|ECHELON|\bXD\b|M1A|PRODIGY|\bMOUNTS?\b|\bRINGS?\b|\bBASES?\b/.test(u)) return false;
    if (/ARMASPEC/.test(tv) && /LITE|LIGHT TKDWN|TAKEDOWN|PIVOT|GUN BLDRS|BUILDER/.test(u) &&
        !/HELLCAT|ECHELON|\bXD\b|M1A|PRODIGY/.test(u)) return false;
    if (/M77|REDHAWK/.test(u) && /BURRIS|RGR TO WVR/.test(tv) &&
        !/HELLCAT|ECHELON|\bXD\b|M1A/.test(u)) return false;
    if (/\bKUNA\b/.test(tv)) return false;
    if (/HEX DRAGONFLY|HEX REFLEX/.test(tv) && !/HELLCAT|ECHELON|\bXD\b/.test(tv)) return false;
    if (/\bSAINT\b/.test(tv) && !/HELLCAT|ECHELON|\bXD\b|M1A/.test(tv)) return false;
    if (/\bAR[- ]?15\b|\bAR15\b/.test(tv) && !/HELLCAT|ECHELON|\bXD\b|M1A/.test(tv)) return false;
    if (/SPRINGFIELD|SPRGFLD|SPGFLD|SPGFD|SPNGFLD|SPRNGFLD|\bSPFLD\b|\bSPFD\b/.test(tv)) return true;
    if (/HELLCAT|HELLCT|\bHLCT\b|H-CAT/.test(tv)) return true;
    if (/\bECHELON\b/.test(tv)) return true;
    if (/\bPRODIGY\b/.test(tv)) return true;
    if (/\bXDS\b|\bXDM\b|\bXD[- ]?M\b|\bXD[- ]?S\b|\bXDE\b|\bXD[- ]?E\b|XDSM2|XD9|XD45|XDM9|XDM45|\bXDG\b/.test(tv)) return true;
    if (/\bXD\b/.test(tv) || /XD940/.test(tv)) return true;
    if (/\bM1A\b/.test(tv)) return true;
    if (/\bEMP\b/.test(tv) && /SPRINGFIELD|SPRGFLD|SPGFLD/.test(tv)) return true;
    if (/\bSPG\b/.test(tv) && /OPRT|OPERATOR|XD|HELLCAT|M1A/.test(tv)) return true;
    if (/^SPRINGFIELD\b/.test(v)) return true;
    return false;
  }

  function isSwFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/M-PRO|M PRO 7/.test(tv)) return false;
    if (/HEATSHIELD|HEAT SHIELD|HTSHLD/.test(tv)) return false;
    if (/PEPPER SPRAY|PEPPER SPRY/.test(tv)) return false;
    if (/HANDCUFF|\bCUFF\b/.test(tv)) return false;
    if (/KNIFE\/WATCH|KNIFE WATCH/.test(tv)) return false;
    if ((/UMAREX|\bUMX\b/.test(tv)) && /177BB|\.177|\bBB\b|AIRGUN/.test(blob)) return false;
    if (/40S&W|40SW|40\s*S&W|\.40 S&W/.test(tv) &&
        !/SMITH|\bS&W\b|\bM&P\b|SHIELD|SHLD/.test(tv.replace(/40S&W|40SW|40\s*S&W|\.40 S&W/g, ' '))) return false;
    if (/SHIELD ARMS/.test(tv) && !/S&W|\bM&P\b|442/.test(tv)) return false;
    if (/SHIELD SIGHTS/.test(v) && !/S&W|\bM&P\b/.test(tv)) return false;
    if (/\bSHLDR\b/.test(tv)) return false;
    if (/M&P15\b|M&P 15\b/.test(tv) && !/15-?22/.test(tv)) return false;
    if (/SMITH\s*&\s*WESSON|SMITH WESSON/.test(tv)) return true;
    if (/\bS&W\b/.test(tv)) return true;
    if (/M&P9|M&P40|M&P45|M&P22|M&P15-?22|\bM&P\b|\bM&PC\b/.test(tv)) return true;
    if (/\bMP SHIELD\b/.test(tv)) return true;
    if (/BODYGUARD|BDYGRD|BODYGRD|BDY GRD|\bBG2\b/.test(tv)) return true;
    if (/\bEQUALIZER\b/.test(tv)) return true;
    if (/\bSD9|\bSD9VE|\bSD40/.test(tv)) return true;
    if (/\bCSX\b/.test(tv)) return true;
    if (/(?:\bSHIELD\b|\bSHLD\b|SHIELD-PLS|SHLD\+)/.test(tv) &&
        !/HEATSHIELD|SHIELD ARMS|SHIELD SIGHTS/.test(tv)) return true;
    if (/SHIELD ARMS/.test(tv) && /S&W|\bM&P\b|442/.test(tv)) return true;
    if (/\bSW\b/.test(tv) && /L FM|N FM|J FM|EQ\/|M2\.0|SHLD/.test(tv)) return true;
    if (/^SMITH & WESSON\b|^S&W\b/.test(v)) return true;
    return false;
  }

  function isTaurusFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (/HKS/.test(tv) && /S&W|RUGER|COLT|ROSSI|H&R/.test(tv) &&
        !/TAURUS|JUDGE|TRACKER|\b856\b/.test(tv)) return false;
    if (/TAURUS|\bTAUR\b|TARUS/.test(tv)) return true;
    if (/\bGX4\b|\bGX2\b/.test(tv)) return true;
    if (/\bG2C\b|\bG3C\b|\bG2S\b|\bG2X\b|\bG3X\b/.test(tv)) return true;
    if (/\bJUDGE\b/.test(tv)) return true;
    if (/\bTX22\b|\bTX9\b/.test(tv)) return true;
    if (/\bPT111\b|\b738TCP\b/.test(tv)) return true;
    if (/TRACKER|RAGING BULL|RAGING HNTR|RAGING HUNTER/.test(tv)) return true;
    if (/TAURUS 856|TAURUS 85\b|XS TAURUS 856/.test(tv)) return true;
    if (/\bTCP\b/.test(tv) && /TAUR|738/.test(blob)) return true;
    if (/^TAURUS\b/.test(v)) return true;
    if (/FITS TX22|FITS TAURUS|FOR TAURUS/.test(blob)) return true;
    return false;
  }

  function modelsCzOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    var p10c = /\bP-?10\s*C\b|\bP10C\b|\bP-10C\b/.test(blob);
    var p10f = /\bP-?10\s*F\b|\bP10F\b|\bP-10F\b/.test(blob) || /P-10 C\/\s*FS/.test(blob);
    var p10s = /\bP-?10\s*S\b|\bP10S\b|\bP-10S\b/.test(blob);
    if (/P-10S\/C\/F|P-?10 S\/C\/F/.test(blob)) {
      p10c = true;
      p10f = true;
      p10s = true;
    }
    if (p10c) add('P10C');
    if (p10f) add('P10F');
    if (p10s) add('P10S');
    if (/\bP-?10\/P-?10C/.test(blob)) add('P10');
    if (/\bP-?10\b/.test(blob) && !p10c && !p10f && !p10s) add('P10');
    if (/\bP-?07\b|\bP07\b/.test(blob)) add('P07');
    if (/\bP-?09\b|\bP09\b/.test(blob)) add('P09');
    if (/\bP-?01\b|\bP01\b/.test(blob)) add('P01');
    if (/SHADOW\s*2|SHDW\s*2|SHDW2/.test(blob)) add('Shadow2');
    else if (/\bCZ\b/.test(blob) && /SHADOW|SHDW/.test(blob) &&
        !/75 SHADOW|SHADOW SP|SHADOW SYSTEMS/.test(blob)) add('Shadow2');
    if ((/SCORPION|SCRPN|\bEVO3\b|EVO 3/.test(blob) || (/\bEVO\b/.test(blob) && /\bCZ\b/.test(blob))) &&
        !/G-CODE|GCODE|EMPEROR/.test(blob)) add('Scorpion');
    var compact75 = /75 COMPACT|75C\b|75 D PCR|75 PCR/.test(blob);
    if (compact75) add('75C');
    if ((/CZ[- ]?75\b|CZ75\b|SP-?01|75 FULL/.test(blob) || /75\/85|75\/85\/97|CZ 75\//.test(blob)) &&
        !compact75) add('75');
    if (/CZ[- ]?457|\b457\b/.test(blob) && /CZ/.test(blob)) add('457');
    if (/CZ[- ]?455|\b455\b/.test(blob) && /CZ/.test(blob)) add('455');
    if (/CZ[- ]?452|\b452\b/.test(blob) && /CZ/.test(blob)) add('452');
    if (/CZ[- ]?512|\b512\b/.test(blob) && /CZ/.test(blob)) add('512');
    if (/CZ[- ]?527|\b527\b/.test(blob) && /CZ/.test(blob)) add('527');
    if (/CZ[- ]?600|\b600\b/.test(blob) && /CZ/.test(blob)) add('600');
    if (/\bBREN\b/.test(blob) && /CZ/.test(blob)) add('Bren');
    return Object.keys(found);
  }

  function isCzFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (/SHADOW SYSTEMS/.test(tv) && !/\bCZ\b/.test(tv)) return false;
    if (/^SHDW /.test(u) && !/\bCZ\b/.test(tv)) return false;
    if (/CR920|CR-P\b|MR\/XR|XR-P/.test(tv) && !/\bCZ\b/.test(tv)) return false;
    if (/G-CODE SCORPION|GCODE SCORPION/.test(tv)) return false;
    if (/EMPEROR SCORP/.test(tv)) return false;
    if (/PARA P10|P10 P12|P12 WRTHG/.test(tv) && !/\bCZ\b/.test(tv)) return false;
    if (/TEKMAT|PSTL MAT|PISTOL MAT|RIFLE MAT/.test(tv)) return false;
    if (/CLEANING KIT|CLN KIT/.test(tv)) return false;
    if (/\d+-\d+X/.test(u) && !/\bCZ\b|MOUNT|RING|BASE/.test(u)) return false;
    if (/^CZ\b/.test(v) || /CZ-USA|CZ USA/.test(v)) return true;
    if (/\bCZ\b/.test(tv)) return true;
    if (/CZ[- ]?\d{2,3}/.test(tv)) return true;
    if (/FITS CZ|FOR CZ |CZ P-?10|CZ P-?0[179]|CZ SCORP|CZ SHADOW|CZ SHDW|CZ EVO|CZ SCRPN/.test(blob)) return true;
    return false;
  }

  function modelsWaltherOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bPDP\b/.test(blob)) add('PDP');
    if (/\bPPQ\b/.test(blob)) add('PPQ');
    var ppks = /PPK\/S|PPKS\b|PPK-S/.test(blob);
    if (ppks) add('PPKS');
    if (/\bPPK\b/.test(blob) && !ppks) add('PPK');
    if (/PPK\/PPKS|PPK\/PPK/.test(blob)) add('PPK');
    if (/\bPPS\b/.test(blob)) add('PPS');
    if (/\bP-?99\b/.test(blob)) add('P99');
    if (/\bP22\b/.test(blob) && !/PT22/.test(blob)) add('P22');
    if (/\bCCP\b/.test(blob)) add('CCP');
    if (/\bQ4\b|\bQ5\b/.test(blob)) add('Q5');
    if (/\bP38\b/.test(blob)) add('P38');
    if (/\bWMP\b/.test(blob)) add('WMP');
    return Object.keys(found);
  }

  function isWaltherFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/ALL WTHR|ALL-WTHR|WEATHER/.test(tv)) return false;
    if (/PEPPER GUN|CO2 CYL/.test(tv)) return false;
    if (/TEKMAT|PSTL MAT|PISTOL MAT|RIFLE MAT/.test(tv)) return false;
    if (/WINCHESTER SUPREME|BINOCULAR/.test(tv)) return false;
    if (/^WALTHER\b/.test(v) || /WALTHER ARMS/.test(v)) return true;
    if (/WALTHER|WLTHR|WHLTR/.test(tv)) return true;
    if (/\bWTHR\b/.test(tv) && /\bPDP\b|\bPPQ\b|\bQ4\b|\bQ5\b/.test(tv)) return true;
    if (/\bWLT\b/.test(tv) && /\bPDP\b/.test(tv)) return true;
    if (/WALT PDP|WALT PPQ|WALT Q4|WALT Q5/.test(tv)) return true;
    if (/\bMAG WAL\b|^MAG WAL /.test(u)) return true;
    if (/\bPPK/.test(tv)) return true;
    if (/\bPPQ\b/.test(tv)) return true;
    if (/\bPDP\b/.test(tv)) return true;
    if (/\bP-?99\b/.test(tv)) return true;
    if (/\bP38\b/.test(tv)) return true;
    if (/PK380/.test(tv)) return true;
    if (/\bWMP\b/.test(tv) && /WALTHER|VIRIDIAN|PDP/.test(blob)) return true;
    if (/\bPPS\b/.test(tv) && /WALTHER|WLTHR|PPS M2|M2 PPS/.test(blob)) return true;
    if (/\bCCP\b/.test(tv) && /WALTHER|WLTHR|DXT2|SIGHT|SGHT|HOLSTER|HLSTR|\bMAG\b/.test(blob)) return true;
    if ((/\bQ4\b|\bQ5\b/).test(tv) && /WALTHER|WLTHR|WALT |PPQ/.test(blob)) return true;
    if (/\bP22\b/.test(tv) && !/PT22|TAURUS/.test(tv) &&
        /WALTHER|WLTHR|MAG WAL|WAL P22|FITS P22|FOR P22/.test(blob)) return true;
    if (/FITS WALTHER|FOR WALTHER|FITS PPK|FITS PPQ|FITS PDP/.test(blob)) return true;
    return false;
  }

  function modelsBenelliOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bM4\b/.test(blob)) add('M4');
    if (/\bSBE\b|SUPER BLACK EAGLE|BLACK EAGLE/.test(blob)) add('SBE');
    return Object.keys(found);
  }
  function isBenelliFirearm(title, vendor, desc) {
    var tv = ((title || '') + ' ' + (vendor || '')).toUpperCase();
    if (/TEKMAT|PSTL MAT/.test(tv)) return false;
    return /BENELLI/.test(tv);
  }

  function modelsBersaOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bBP9\b/.test(blob)) add('BP9');
    if (/THUN|THNDR|THUNDER/.test(blob)) add('Thunder');
    return Object.keys(found);
  }
  function isBersaFirearm(title, vendor, desc) {
    var tv = ((title || '') + ' ' + (vendor || '')).toUpperCase();
    if (/TEKMAT/.test(tv)) return false;
    if (/BERSA/.test(tv)) return true;
    if (/^BERSA\b/.test((vendor || '').toUpperCase())) return true;
    return false;
  }

  function modelsCanikOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bMETE\b/.test(blob)) add('METE');
    if (/\bMC9\b/.test(blob)) add('MC9');
    if (/RIVAL/.test(blob)) add('Rival');
    if (/\bTTI\b/.test(blob) && /CANIK/.test(blob)) add('TTI');
    if (/\bTP9/.test(blob)) add('TP9');
    return Object.keys(found);
  }
  function isCanikFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/TEKMAT|PSTL MAT|TP9N FOREGRIP|B&T TP9N|METERING|\bMETERS?\b/.test(tv)) return false;
    if (/CANIK/.test(tv)) return true;
    if (/^CANIK\b|^CENTURY ARMS\b/.test(v) && /TP9|METE|MC9|SFX/.test(u)) return true;
    if (/MAG CENT ARMS TP9|MAG CENT ARMS MC9/.test(u)) return true;
    if (/\bTP9/.test(tv) && /CANIK|CENT ARMS|CENTURY/.test(tv)) return true;
    if (/\bMETE\b/.test(tv) && /CANIK/.test(tv)) return true;
    return false;
  }

  function modelsCmmgOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bMK3\b|LPK 308/.test(blob)) add('Mk3');
    if (/\b22AR\b/.test(blob) ||
        (/22\s*LR|22LR|\.22/.test(blob) && /CONV(?:ER|R)|BRAVO/.test(blob) && !/22ARC|22 ARC/.test(blob))) {
      add('22AR');
    }
    if (/\b9AR\b/.test(blob)) add('9AR');
    if (/ZEROED/.test(blob)) add('Zeroed');
    if (/RESOLUTE/.test(blob)) add('Resolute');
    if (/BANSHEE/.test(blob)) add('Banshee');
    if (/\bMK4\b/.test(blob) ||
        (/AR[- ]?15|\bAR15\b|5\.56|\bM16\b|LPK 556/.test(blob) &&
          !found.Mk3 && !found['22AR'] && !found['9AR'])) {
      add('Mk4');
    }
    return Object.keys(found);
  }
  function isCmmgFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/TACTICAL SNACK/.test(tv)) return false;
    if (/TEKMAT|PSTL MAT|PISTOL MAT|RIFLE MAT/.test(tv)) return false;
    if (/CMMG/.test(tv)) return true;
    if (/^CMMG\b/.test(v)) return true;
    if (/\b22AR\b|\b9AR\b/.test(tv) && /CONVER|MAG|ADAPTER|ADPTR/.test(tv)) return true;
    return false;
  }

  function modelsFnOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\b509\b|FN509/.test(blob)) add('509');
    if (/\b510\b/.test(blob)) add('510');
    if (/\b545\b/.test(blob)) add('545');
    if (/\b502\b/.test(blob)) add('502');
    if (/\b503\b/.test(blob)) add('503');
    if (/\bFNX\b/.test(blob)) add('FNX');
    if (/FIVE-?SEVEN|5\.7X28|FN 5\.7/.test(blob) && !/\bP90\b/.test(blob)) add('FiveSeven');
    if (/\bP90\b/.test(blob) && !/P90 STYLE/.test(blob)) add('P90');
    if (/\bSCAR\b/.test(blob)) add('SCAR');
    return Object.keys(found);
  }
  function isFnFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/P90 STYLE/.test(tv)) return false;
    if ((/\bAR[- ]?15\b|\bAR15\b|\bM16\b/).test(tv) && !/\bSCAR\b|\bP90\b|509|FNX/.test(tv)) return false;
    if (/TEKMAT/.test(tv)) return false;
    if (/^FN AMERICA\b|^FNH\b/.test(v)) return true;
    if (/\bFN 509\b|\bFN509\b|FN 510|FN 545|FN 502|FN 503/.test(tv)) return true;
    if (/\bFNS\b|\bFNX\b/.test(tv)) return true;
    if (/FIVE-?SEVEN/.test(tv)) return true;
    if (/\bP90\b/.test(tv) && /FN|FNH|MAG FN/.test(tv)) return true;
    if (/\bSCAR\b/.test(tv)) return true;
    if (/MAG FN\b|\bFNH\b/.test(tv)) return true;
    if (/FN 5\.7|5\.7X28/.test(tv) && /FN|DEAD AIR|ADPTR/.test(tv)) return true;
    return false;
  }

  function modelsHenryOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/HOMESTEADER/.test(blob)) add('Homesteader');
    if (/BIG BOY|GOLDN BOY|GOLDEN BOY/.test(blob)) add('BigBoy');
    if (/US SURVIVAL|SURVIVAL RIFLE/.test(blob)) add('Survival');
    if (/30-30|30\/30|\bH009\b/.test(blob)) add('H3030');
    if (/45-70|\.45-70/.test(blob)) add('H4570');
    if (/38\/357|\.357|\.38/.test(blob) && /HENRY|HNDGRD|HANDGUARD/.test(blob)) add('H357');
    if (/\bH001\b|22 LR|22LR|\.22/.test(blob) && /HENRY/.test(blob) &&
        !/HOMESTEADER|SURVIVAL|30-30|45-70/.test(blob)) add('H001');
    if (/RIMFIRE/.test(blob) && /HENRY/.test(blob)) add('H001');
    return Object.keys(found);
  }
  function isHenryFirearm(title, vendor, desc) {
    var tv = ((title || '') + ' ' + (vendor || '')).toUpperCase();
    if (/TEKMAT/.test(tv)) return false;
    return /HENRY/.test(tv);
  }

  function modelsIwiOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/MASADA SLIM/.test(blob)) add('MasadaSlim');
    else if (/MASADA/.test(blob)) add('Masada');
    if (/JERICHO/.test(blob)) add('Jericho');
    if (/TAVOR|\bX95\b|SABRA/.test(blob)) add('Tavor');
    return Object.keys(found);
  }
  function isIwiFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/TEKMAT/.test(tv)) return false;
    if (/^IWI\b/.test(v)) return true;
    if (/\bIWI\b|MASADA|JERICHO|TAVOR|\bX95\b/.test(tv)) return true;
    if (/SUPER SABRA/.test(tv)) return true;
    return false;
  }

  function modelsKahrOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bPM9\b|\bPM40\b/.test(blob)) add('PM9');
    if (/\bMK9\b/.test(blob)) add('MK9');
    if (/\bK9\b/.test(blob) && /KAHR/.test(blob)) add('K9');
    if (/\bP380\b/.test(blob) && /KAHR/.test(blob)) add('P380');
    if (/\bP9\b/.test(blob) && /KAHR|PM9/.test(blob)) add('P9');
    if (/\bCW9\b/.test(blob)) add('PM9');
    return Object.keys(found);
  }
  function isKahrFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/CMMG|BUFFER ASSEMBLY|TEKMAT/.test(tv)) return false;
    if (/KAHR/.test(tv)) return true;
    if (/^KAHR\b/.test(v)) return true;
    if (/\bPM9\b/.test(tv) && !/PMAG/.test(tv)) return true;
    if (/\bMK9\b/.test(tv) && /KAHR/.test(tv)) return true;
    return false;
  }

  function modelsKeltecOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bP3AT\b|PR-3AT|PR3AT/.test(blob)) add('P3AT');
    if (/\bPF9\b|\bPF-9\b/.test(blob)) add('PF9');
    if (/\bP-32\b|\bP32\b/.test(blob)) add('P32');
    if (/\bPR57\b|\bPR-57\b/.test(blob)) add('PR57');
    if (/\bKP50\b|\bKP-50\b/.test(blob)) add('KP50');
    return Object.keys(found);
  }
  function isKeltecFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/TEKMAT/.test(tv)) return false;
    if (/KEL[- ]?TEC|KELTEC/.test(tv)) return true;
    if (/^KEL-TEC\b|^KELTEC\b/.test(v)) return true;
    if (/\bP3AT\b|\bPF9\b|\bPR57\b|\bKP50\b/.test(tv)) return true;
    if (/\bP-32\b/.test(tv) && /KEL/.test(tv)) return true;
    return false;
  }

  function modelsKimberOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/MICRO 9|MICRO9|MCRO 9/.test(blob)) add('Micro9');
    if (/MICRO 380|MICRO380/.test(blob)) add('Micro380');
    if (/KDS9/.test(blob)) add('KDS9');
    if (/CDS9/.test(blob)) add('CDS9');
    if (/\b2K11\b/.test(blob)) add('K2K11');
    if (/\bK6S\b/.test(blob)) add('K6s');
    if (/\b1911\b/.test(blob) ||
        (/MAG KIMBER/.test(blob) && /45ACP|10MM|38SUPER|9MM/.test(blob) &&
          !/MICRO|KDS9|CDS9|2K11/.test(blob))) add('1911');
    return Object.keys(found);
  }
  function isKimberFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var tv = u + ' ' + v;
    if (/PEPPERBLASTER|PPERBLSTER|TEKMAT|PSTL MAT/.test(tv)) return false;
    if (/KIMBER/.test(tv)) return true;
    if (/^KIMBER\b/.test(v)) return true;
    if (/KDS9|\b2K11\b|CDS9/.test(tv) && /KIMBER|PLT |PLATE/.test(tv)) return true;
    return false;
  }

  function modelsSavageOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/\bAXIS\b/.test(blob) && /SAVAGE|\bSAV\b|\bSVG\b|EDGE/.test(blob) && !/TRI-STANCE|TRISTANCE/.test(blob)) add('Axis');
    if (/\bEDGE\b/.test(blob) && /SAVAGE|\bSAV\b|AXIS/.test(blob)) add('Axis');
    if (/\b110\b|\b10\/110\b|\b10\/100\b/.test(blob) && /SAVAGE|\bSAV\b|\bSVG\b/.test(blob)) {
      var sa = /\bSA\b|SHORT ACTION/.test(blob);
      var la = /\bLA\b|LONG ACTION/.test(blob);
      if (sa && !la) add('110SA');
      else if (la && !sa) add('110LA');
      else if (sa && la) { add('110SA'); add('110LA'); }
      else add('110');
    }
    if ((/\b10 SA\b|SAVAGE 10\b|\bSAV 10\b/.test(blob)) && !/\b110\b/.test(blob)) add('110SA');
    if (/10\/11\/12|\b10\/12\/16\b/.test(blob) && /SAVAGE|\bSAV\b/.test(blob)) add('110');
    if ((/\b112\b|\b116\b/.test(blob)) && /SAVAGE|\bSAV\b/.test(blob)) add('110LA');
    if (/A17|B17/.test(blob) && /SAVAGE|\bSAV\b/.test(blob)) add('A17');
    if (/A22|B22/.test(blob) && /SAVAGE|\bSAV\b/.test(blob)) add('A22');
    if (/\bBMAG\b|B\.MAG|B-MAG/.test(blob)) add('Bmag');
    if (/\b93\b/.test(blob) && /SAVAGE|\bSAV\b/.test(blob)) add('93');
    if (/MARK II|\bMKII\b|\bMK II\b|17HM2/.test(blob) && /SAVAGE|\bSAV\b/.test(blob)) add('MarkII');
    if (/\b64 SER\b|SAVAGE 64\b|\bSAV 64\b/.test(blob)) add('64');
    if (/\bRASCAL\b/.test(blob) && /SAVAGE|\bSAV\b/.test(blob)) add('Rascal');
    if (/\b212\b/.test(blob) && /SAVAGE|\bSAV\b|SLUG/.test(blob)) add('212');
    if (!found.Axis && !found['110SA'] && !found['110LA'] && !found['110'] &&
        /SAVAGE/.test(blob) && /\bSA\b/.test(blob) &&
        !found.A17 && !found.A22 && !found['93'] && !found.MarkII && !found['64'] && !found.Rascal) {
      add('110SA');
    }
    return Object.keys(found);
  }
  function isSavageFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (/TEKMAT|PSTL MAT|PISTOL MAT|RIFLE MAT/.test(tv)) return false;
    if (/HOWARD LEIGHT/.test(tv)) return false;
    if (/TRI-STANCE|TRISTANCE|TRI STANCE/.test(tv)) return false;
    if (/\bBIPOD\b/.test(tv)) return false;
    if (/^SAVAGE\b/.test(v) || /SAVAGE ARMS/.test(v)) return true;
    if (/SAVAGE/.test(tv)) return true;
    if (/\bMAG SAV\b|^MAG SAV /.test(u)) return true;
    if (/\bSAV\b/.test(tv) && /110|AXIS|93|A17|A22|B17|B22|BMAG|MKII|MARK II|RASCAL|64 SER/.test(tv)) return true;
    if (/\bSVG\b/.test(tv) && /AXIS|110/.test(tv)) return true;
    if (/FITS SAVAGE|FOR SAVAGE/.test(blob)) return true;
    return false;
  }

  function modelsTikkaOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if ((/T3X|T3\/X|TIKKAT3|\bT3\b/.test(blob)) && /TIKKA|FITS TIKKA|FOR TIKKA/.test(blob) && !/T1XI/.test(blob)) {
      add('T3');
    }
    if (/\bT1X\b/.test(blob) && !/T1XI/.test(blob) && /TIKKA|FITS TIKKA|FOR TIKKA/.test(blob)) {
      add('T1X');
    }
    return Object.keys(found);
  }
  function isTikkaFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/TEKMAT|PSTL MAT|PISTOL MAT|RIFLE MAT|RIFLE CASE|GUN CASE|RFL CASE/.test(tv)) return false;
    if (/T1XI|T-1XI|T1-XI/.test(tv) && !/TIKKA/.test(tv)) return false;
    if (/STEINER/.test(tv) && /T1X/.test(tv) && !/TIKKA/.test(tv)) return false;
    if (/TIKKA/.test(tv)) return true;
    if (/FITS TIKKA|FOR TIKKA/.test(blob)) return true;
    return false;
  }

  function modelsMarlinOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (!/MARLIN|\bMRLN\b|\bMRLIN\b|FITS MARLIN|FOR MARLIN/.test(blob)) return [];
    if (/\b1895\b|MARLIN1895/.test(blob)) add('1895');
    if (/\b1894\b|MARLIN1894/.test(blob)) add('1894');
    if (/\b336\b|MARLIN336|\b308MX\b/.test(blob)) add('336');
    if (/\b39A\b|\b39D\b|MARLIN 39/.test(blob)) add('39A');
    if (/\b36\b/.test(blob) && /MARLIN/.test(blob) && !/\b336\b/.test(blob) && !/\d+MM/.test(blob)) add('336');
    return Object.keys(found);
  }
  function isMarlinFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/TEKMAT|PSTL MAT|PISTOL MAT|RIFLE MAT|RIFLE CASE|GUN CASE|RFL CASE/.test(tv)) return false;
    if (/MARLIN|\bMRLN\b|\bMRLIN\b/.test(tv)) return true;
    if (/FITS MARLIN|FOR MARLIN/.test(blob)) return true;
    return false;
  }

  function modelsBrowningOf(title, desc) {
    var blob = ((title || '') + ' ' + descHead(desc, 700)).toUpperCase();
    var found = {};
    function add(id) { found[id] = 1; }
    if (/X-?BOLT|\bXBOLT\b/.test(blob)) add('XBolt');
    if ((/\bBAR\b/.test(blob) && /BROWNING|\bBRWNG\b|\bBRNG\b|BROWN BAR/.test(blob)) || /BROWN BAR/.test(blob)) add('BAR');
    if (/\bBLR\b/.test(blob) && /BROWNING|\bBRWNG\b|BROWN|DNZ/.test(blob)) add('BLR');
    if (/A-?BOLT|\bABOLT\b/.test(blob) && /BROWNING|WARNE|MAXIMA/.test(blob)) add('ABolt');
    if (/BUCKMARK|BUCK MARK|BCKMRK/.test(blob)) add('BuckMark');
    if ((/\bHP\b|HI-?POWER|HIPOWER/.test(blob)) && /BROWNING|MEC-GAR/.test(blob)) add('HP');
    return Object.keys(found);
  }
  function isBrowningFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (skipFirearmFamily(title, vendor)) return false;
    if (/TEKMAT|PSTL MAT|PISTOL MAT|RIFLE MAT|RIFLE CASE|GUN CASE|RFL CASE/.test(tv)) return false;
    if (/KA-?BAR/.test(tv)) return false;
    if (/VLTOR/.test(tv)) return false;
    if (/DANIEL DEFENSE/.test(tv)) return false;
    if ((/SOLGW|LOYAL 9/.test(tv)) && /\bA5\b/.test(tv)) return false;
    if (/BROWNING|\bBRWNG\b|\bBRNG\b/.test(tv)) return true;
    if (/X-?BOLT|\bXBOLT\b/.test(tv)) return true;
    if (/BUCKMARK|BUCK MARK|BCKMRK/.test(tv)) return true;
    if (/BROWN X-?BOLT|BROWN XBOLT|BROWN BAR/.test(tv)) return true;
    if (/\bBLR\b/.test(tv) && /BROWN|DNZ|BROWNING/.test(tv)) return true;
    if (/A-?BOLT|\bABOLT\b/.test(tv) && /BROWNING|WARNE|MAXIMA/.test(tv)) return true;
    if (/FITS BROWNING|FOR BROWNING/.test(blob)) return true;
    if (/^BROWNING\b/.test(v)) return true;
    return false;
  }

  function promagFitsPlatform(title, vendor, desc, plat) {
    if (!plat || !plat.family) return false;
    var tv = ((title || '') + ' ' + (vendor || '')).toUpperCase();
    if (!/PROMAG|ARCHANGEL/.test(tv)) return false;
    var d = descHead(desc, 480);
    var blob = tv + ' ' + d;
    if (plat.exclude && plat.exclude.test(blob)) return false;
    return plat.family.test(blob);
  }

  function models1911Of(title, desc) {
    var u = (title || '').toUpperCase();
    var d = descHead(desc, 700);
    var blob = u + ' ' + d;
    var found = {};
    function add(id) { found[id] = 1; }
    var officer = /OFFICERS?|\bOFC\b|\bOFCR\b|1911 CMP\b|1911 COMPACT|COMPACT 1911|ETM [0-9]+MM COMPACT|KIMBER ULTRA|\bULTRA 1911\b|OFF\/COM/.test(u);
    if (/KIMBER/.test(u) && /COMPACT|CMPCT|TACMAG/.test(u) && !/MICRO|MCRO|CDS9|KDS9/.test(u)) officer = true;
    if (/CMC/.test(u) && /OFFICER|\bOFF\s|\bOFF\//.test(u)) officer = true;
    if (/3-4 1911|FOR 3-4/.test(u)) officer = true;
    if (/COLT DEFENDER|MAG COLT DEFENDER/.test(u)) officer = true;
    if (/OFFICER[- ]SIZE|OFFICERS? MODEL|FITS OFFICER|FOR OFFICER/.test(d)) officer = true;
    if (/SPEEDLOADER|SPDLR|SPDLDR/.test(u) && !/OFFICER|\bOFC\b/.test(u)) officer = false;

    var commander = /COMMANDER|\bCMDR\b|GVT\/CMD|1911 CMD|GC\/CC|GVT\/GC\/CC|OFF\/COM/.test(u);
    if (/FITS COMMANDER|COMMANDER[- ]SIZE|COMMANDER MODEL|FOR COMMANDER/.test(d)) commander = true;
    var is2011 = /\b2011\b|\b2311\b|\b2K11\b|STACCATO|STACAT|\bSTACC\b/.test(u);
    var government = /GOVERNMENT|\bGOVT\b|\bGVT\b|GOV'?T|\bGOV 45\b|\bGOV 9\b|FULL SIZE|FULL-SIZE|\bFS 1911\b|1911 FS\b|10MM FS|DELTA ELITE|GOLD CUP|DOUBLE EAGLE|DBL EGL|GVT\/GC/.test(u);
    if (/FULL-SZ|FULL SZ/.test(u)) government = true;
    if (/FULL SIZE 1911|GOVERNMENT MODEL|FITS GOVERNMENT|FOR GOVERNMENT|FULL-SIZE 1911/.test(d)) government = true;
    if (/\bFULL SIZE\b|\bFULL-SIZE\b/.test(d) && (/\b1911\b/.test(u) || /WILSON/.test(u))) government = true;
    if (!is2011 && /WILSON/.test(u) && /ETM|MATCH|FULL SIZE/.test(u) && !officer && !/COMPACT/.test(u)) government = true;
    if (!is2011 && /^MAG(?:AZINE)? WILSON\b/.test(u) && !officer && !/COMPACT/.test(u) &&
        !/\b12GA\b|\b12\s*GAUGE\b|\b870\b|EXT TUBE|EXT TB/.test(u)) government = true;
    if (!is2011 && (/^MAG(?:AZINE)? COLT\b/.test(u) || /MEC-GAR MAG(?:AZINE)? COLT/.test(u)) &&
        !officer && !/DEFENDER/.test(u)) government = true;
    if (!is2011 && (/^MAG(?:AZINE)? CMC\b/.test(u) || /^MAG(?:AZINE)? ED BROWN\b/.test(u) ||
        /^MAG(?:AZINE)? KIMBER\b/.test(u)) && !officer && !/COMPACT|CMPCT|MICRO|MCRO|CDS9|KDS9/.test(u)) {
      government = true;
    }
    if (/1911 5\/|1911 5["”]|1911 5 INCH|\b5["”] 1911|1911 5\b|1911GOV|1911 GOV\b/.test(u) && !officer) government = true;
    if (/1911 COMM\b/.test(u)) commander = true;
    if (/1911 OFF\b|1911 3 OFF|\b3 OFF\b/.test(u) && /\b1911\b/.test(u)) officer = true;
    if (/4\.25/.test(u) && /\b1911\b/.test(u)) commander = true;
    if (/4\.25-5/.test(u) && /\b1911\b/.test(u)) government = true;
    if (officer && !/GOVT|GOVERNMENT|\bGVT\b|FULL SIZE|FULL-SIZE|FS 1911|1911 FS|1911GOV/.test(u)) government = false;

    if (officer) add('Officer');
    if (commander) add('Commander');
    if (government) add('Government');
    if (is2011) add('2011');
    if (/3-4 1911|FOR 3-4/.test(u)) add('Commander');
    return Object.keys(found);
  }

  function is1911Wilson(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc);
    var blob = u + ' ' + v + ' ' + d;
    if (!/WILSON/.test(u + ' ' + v)) return false;
    if (/P365|WCP365|XMACRO|P320|WCP320|\bAR[- ]?15\b|\bAR15\b|\bAR[- ]?10\b|\bAR10\b|\bBCM\b|556NATO|\b5\.56\b|\b223 REM|\b300BLK\b|\b300 BLACKOUT\b|\b308WIN\b|\b308 WIN|\b870\b|\b1100\b|\b1187\b|\b12GA\b|\b12 GAUGE\b|SIG P365|SIG P320|SIG SAUER P|ANTI-WLK|\bTTU\b|\bGAS TUBE\b|FLASH HIDER|BOLT CARRIER|MUZZLE BRAKE|BLAST DIVERTER|SIDE SADDLE|JUMBO HEAD|RECEIVER KT|\bRT MB\b|RAPID THREAD|WHISPER|\bRECON\b|\bSNPR\b|SUPER SNIPER|GUNFIGHTER/.test(blob)) {
      return false;
    }
    if (/\b1911\b/.test(blob)) return true;
    if (/FITS 1911|1911 FULL|1911 COMPACT|1911 AUTO|WILSON COMBAT MAGAZINE/.test(d)) return true;
    if (/^MAG(?:AZINE)? WILSON\b/.test(u) && !/\b12GA\b|\b12\s*GAUGE\b|\b870\b|EXT TUBE|EXT TB/.test(u)) return true;
    if (/\bETM\b|\bOFC\b|GOV'?T|GOVERNMENT|OFFICER|COMMANDER|BEAVERTAIL|BVR TAIL|GRIP SFTY|THUMB SAFETY|THUMB SFTY|AMBI SAFETY|SLIDE RELEASE|MAINSPRING|MAGWELL|EXTRACTOR|SHOK-BUFF|BUSHING|\bSEAR\b|\bHAMMER\b|GUIDE ROD|GRIP SCREWS|HEX HEAD|UL MATCH TRIGGER|VALUE LINE|BULLET PRF/.test(u)) {
      return true;
    }
    return false;
  }

  function is1911Firearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/1911 FOLDER|COLD STL 1911|COLD STEEL 1911/.test(tv) && /FOLDER|FLDR|KNIFE/.test(tv)) return false;
    if (/KIMBER MICRO|MICRO 380|MICRO 9|RAPIDE MCRO|\bMCRO 9\b/.test(tv) && !/\b1911\b/.test(tv)) return false;
    if (/\b(CDS9|KDS9)\b/.test(tv) && !/\b1911\b/.test(tv)) return false;
    if (/WILSON/.test(tv) && /P365|WCP365|XMACRO|P320|WCP320/.test(tv)) return false;
    if (/\b(AR[- ]?15|AR15|AR[- ]?10|AR10|\bBCM\b|556NATO|5\.56|223 REM|300BLK|300 BLACKOUT|308WIN|308 WIN)\b/.test(tv) &&
        !/\b1911\b|\b2011\b|STACCATO/.test(tv)) return false;
    if (/WILSON/.test(tv) && /\b(12GA|12 GAUGE|870|1100|1187|EXT TUBE|EXT TB|SIDE SADDLE)\b/.test(tv) &&
        !/\b1911\b/.test(tv)) return false;
    if (/SOPMOD|MIL-SPEC/.test(tv) && /\bGOV\b|GOVT/.test(tv) && !/\b1911\b/.test(tv)) return false;
    if (/CMC TRIGGERS/.test(v)) return false;
    if (/DURAMAG/.test(tv) && /COLT/.test(tv) && !/\b1911\b/.test(tv)) return false;
    if (/COLT AR15|MAG PCH COLT AR/.test(tv)) return false;
    if (/KAK INDUSTRY/.test(v) && !/\b1911\b|\b2011\b|STACCATO/.test(tv)) return false;
    if (/B5 SYSTEMS/.test(v) && /SOPMOD|STK GOV/.test(tv)) return false;

    if (/\b1911\b/.test(tv)) return true;
    if (/\b2011\b|\b2311\b|\b2K11\b|STACCATO|STACAT|\bSTACC\b/.test(tv)) return true;

    var holster = /HOLSTER|HLSTR|\bIWB\b|\bOWB\b|\bSERPA\b|\bCQC\b|\bINCOG\b/.test(u) ||
      /SAFARILAND|DESANTIS|BLACKHAWK|G-CODE|GCODE|BRAVO CONCEAL|BULLDOG|HOFTAC|STICKY|CRUCIAL CONCEAL|1791/.test(v);
    if (holster) return false;

    if (/FITS 1911|FOR 1911|1911 FULL SIZE|1911 COMPACT|1911 AUTO/.test(d) &&
        !/CLASSIC 1911|1911 PISTOL FOR THE|ANGLE OF THE.{0,12}1911/.test(d)) return true;
    if (is1911Wilson(title, vendor, desc)) return true;
    if (/^MAG(?:AZINE)? KIMBER\b/.test(u) && !/MICRO|MCRO|CDS9|KDS9|EVO/.test(u)) return true;
    if (/^MAG(?:AZINE)? CMC\b/.test(u) && /CMC PRODUCTS/.test(v)) return true;
    if (/^MAG(?:AZINE)? ED BROWN\b/.test(u)) return true;
    if ((/^MAG(?:AZINE)? COLT\b/.test(u) || /MEC-GAR MAG(?:AZINE)? COLT/.test(u)) && !/AR[- ]?15|AR15/.test(u)) return true;
    if (/MEC-GAR MAG 2011/.test(u)) return true;
    if (/TTI BP FITS 2011/.test(u)) return true;
    return false;
  }

  function modelsAr15Of(title, desc) {
    var u = (title || '').toUpperCase();
    var d = descHead(desc, 700);
    var found = {};
    function add(id) { found[id] = 1; }
    if (/CARBINE|\bCARB\b|CARB STK|HNDGRD CARB|CARBINE LENGTH|CARBINE BUFFER|\bCAR 15\b|MOE RL CARB|MOE TR CARB|DT-PR CARB/.test(u) ||
        /CARBINE LENGTH|CARBINE[- ]LENGTH/.test(d)) add('Carbine');
    if (/\bM4\b/.test(u) && /STK|STOCK|HNDGRD|HANDGUARD|BUFFER|CARB/.test(u)) add('Carbine');
    if (/SOPMOD/.test(u) && /STK|STOCK/.test(u)) add('Carbine');
    if (/MIL-SPEC/.test(u) && /STK|STOCK/.test(u) && !/RIFLE/.test(u)) add('Carbine');
    if (/MID[- ]LENGTH|\bMID LENGTH\b|HNDGRD MID|GAS TUBE MID|\bMID GOV\b|\bSPR MID\b/.test(u) ||
        (/MID[- ]LENGTH/.test(d) && /GAS|HANDGUARD|HNDGRD/.test(u + ' ' + d))) add('Mid');
    if (/AR[- ]?15\/M4|AR15\/M4/.test(u) && /PAD|STK|STOCK|HNDGRD/.test(u)) add('Carbine');
    if (/RIFLE LENGTH|RIFLE-LENGTH|RIFLE BUFFER|RIFLE GAS|A2 STOCK|A2 BUTT/.test(u)) add('Rifle');
    if (/\bAR[- ]?9\b|\bAR9\b/.test(u) && !/RAIL.{0,12}\b9\b|\b9\s*(BLK|FDE|MLOK|MLK)/.test(u)) add('9mm');
    if (/\b9MM\b/.test(u) && /AR[- ]?15|AR15|BCG|BUFFER|LPK|PCC|AR[- ]?9|\bAR9\b/.test(u)) add('9mm');
    if (/300BLK|300 BLK|300 BLACKOUT|\.300 BLK|\.300BLK/.test(u)) add('300BLK');
    if (/(5\.56|\.223\b|223 REM|223 WYLDE|223WYLDE|556NATO|5\.56 NATO)/.test(u) && !found['9mm']) add('556');
    if (/\bBCG\b|BOLT CARRIER/.test(u) && !found['9mm'] && !found['300BLK']) add('556');
    return Object.keys(found);
  }

  function isAr15Firearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/\bAR[- ]?10\b|\bAR10\b|\bSR[- ]?25\b|\bLR[- ]?308\b|\bLR308\b|\bAR[- ]?308\b|L7AWM/.test(tv) &&
        !/\bAR[- ]?15\b|\bAR15\b/.test(tv)) return false;
    if (/\b(308WIN|\.308\b|7\.62X51|6\.5 ?CM|6\.5 CREED)\b/.test(tv) &&
        !/\bAR[- ]?15\b|\bAR15\b|5\.56|223|300BLK|9MM/.test(tv)) return false;
    if (isAr762x39Mag(title, vendor, desc)) return true;
    if (/\b(AK[- ]?47|AK47|AKM|AK74|7\.62X39)\b/.test(tv) && !/\bAR[- ]?15\b|\bAR15\b/.test(tv)) return false;
    if (/(AICS|SIG CROSS)/.test(tv) && !/AR[- ]?15|5\.56|223REM|300BLK/.test(tv)) return false;
    if (/10\/22|10-22/.test(tv)) return false;
    if (/HK94|MP5|HK91|HK93/.test(tv) && !/AR[- ]?15|\bAR15\b/.test(tv)) return false;
    if (/\b(12GA|12 GAUGE|870|1100)\b/.test(tv) && !/\bAR[- ]?15\b|\bAR15\b/.test(tv)) return false;
    if (/SN-ACH/.test(tv)) return false;
    if (/HORNADY|HRNDY/.test(tv) && /DIE|RELOAD/.test(tv)) return false;
    if (/\bTLR-?1\b/.test(tv) && /300 LUMEN/.test(tv)) return false;
    if (/BORESIGHT/.test(tv) && !/AR[- ]?15|\bAR15\b/.test(tv)) return false;

    if (/\bAR[- ]?15\b|\bAR15\b|\bAR 15\b/.test(tv)) return true;
    if (/L5AWM/.test(tv) && !/L7AWM/.test(tv)) return true;
    if (/\bPMAG\b/.test(tv) && /5\.56|223|300BLK|GEN M3|\bM3\b|AR\/M4|AR M4/.test(tv) &&
        !/\bAK\b|AICS|7\.62X51|\b7\.62\b|\b762\b|CROSS/.test(tv)) return true;
    if (/\bLPK\b/.test(tv) && /556|5\.56|223|\bAR\b|MIL-SPEC|STANDARD|ENHANCED|ULTRA DUTY/.test(blob) &&
        !/\b308\b|AR[- ]?10|AR10/.test(tv)) return true;
    if (/MIDWEST/.test(tv) && /SIDE FOLDER|BEAM SIDE FOLDER/.test(tv) && !/\bAK\b|\bAR[- ]?10\b/.test(tv)) return true;
    if (/BCM GUNF|BCM GUNFIGHTER|BCM STOCK|BCM MK2|BCM GUNFTR/.test(tv)) return true;
    if (/^B5 /.test(u) && /STK|STOCK|GRIP|HANDGUARD|HNDGRD|CAR15|CAR 15|SOPMOD|BRAVO|P-GRIP|VERTICAL GRIP/.test(u) &&
        !/\bAK\b/.test(tv)) return true;
    if (/MAGPUL/.test(tv) &&
        /CARB STK|MIL-SPEC|MIAD|MBUS|MAG ASSIST 5\.56|MOE |DT CARB|STR CARB|SL-M STK|ACS |CTR |DT-PR/.test(tv) &&
        !/\bHK\b|\bAK\b|10\/22|870|MP5|AICS|CROSS|BIPOD/.test(tv)) return true;
    if (/BALLISTIC/.test(tv) && /\b(BARREL|BBL)\b/.test(tv) &&
        /5\.56|556NATO|223WYLDE|\.223\b|300BLK|6MMARC|6\.5GREN/.test(tv) && !/308WIN|\.308\b/.test(tv)) return true;
    if (/FAXON/.test(tv) && /5\.56|556NATO|223WYLDE|9MM PCC|300BLK|M16 BCG|GAS TUBE|AR GAS|LOW[- ]?PRO(?:FILE)? GB|\bGAS BLOCK\b/.test(tv) && !/\b308\b|6\.5 CM/.test(tv)) return true;
    if ((/\bBARRELS?\b|\bBBL\b/.test(tv)) &&
        /(5\.56|556NATO|\.223\b|223 WYLDE|223WYLDE|300BLK)/.test(tv) &&
        !/\bAR[- ]?10\b|\bAR10\b|\.308\b|308WIN|6\.5\s*CM/.test(tv) &&
        !/GLOCK|GLK|P320|P365|P226/.test(tv)) return true;
    if (/ALG (COMBAT|QUALITY MIL-SPEC) TRIGGER/.test(tv)) return true;
    if (/GEISSELE/.test(v) && /LPK|SMR |MK16|CHRG HNDL|CHARGING HANDLE|BFR\/SPR|TRIGGER|SSA/.test(tv) &&
        !/\b308\b|AR[- ]?10/.test(tv)) return true;
    if (/NOVESKE/.test(v) && /SML FRM|SMALL FRM|SMALL FRAME|556|5\.56|300BLK|6ARC|\bN4\b|\bNSR\b|BUFFER|CHARGING HANDLE|LPK|LOWER PARTS/.test(tv)) return true;
    if (/ARMASPEC/.test(v) && /BUFFER|CHARGING HANDLE|SAFETY SELECT|\bLPK\b|\bAR9\b|\bAR-9\b|RECOIL SPRG|GAS TUBE|A5 SPACER|ANTIWALK|TKDWN|TAKEDOWN|PIVOT|GUN BLDRS|BUILDER/.test(tv)) return true;
    if (/SPIKE'?S/.test(tv) && /BUFFER|CHARGING|LPK|ST-T1/.test(tv) && !/\b308\b/.test(tv)) return true;
    if (/(^MFT |\bMFT\b|MISSION FIRST)/.test(tv) &&
        /FREE FLT|FREE FLOAT|PSTL GRP|ENGAGE|TEKKO|\bMLOK\b/.test(tv) &&
        !/HOLSTER|HLSTR|\bIWB\b|\bOWB\b/.test(tv)) return true;
    if (/\bBFR\/SPR\b/.test(tv) && /GEISSELE|AR[- ]?15|AR15/.test(blob)) return true;
    if (/\bAR[- ]?9\b|\bAR9\b/.test(tv) && !/RAIL.{0,12}\b9\b/.test(u)) return true;
    if (/CMMG LPK 556|DD LPK 556|SPIKE'S LPK/.test(tv)) return true;
    if (/^CMMG\b/.test(v) && !/TACTICAL SNACK/.test(tv)) {
      if (/\bP90\b|\bPS90\b/.test(tv)) return false;
      if (/\bMK3\b|LPK 308|\b308\b|\.308/.test(tv) &&
          !/\bAR[- ]?15\b|\bAR15\b|5\.56/.test(tv)) return false;
      return true;
    }
    if (/FITS AR[- ]?15|FOR AR[- ]?15|AR15\/M4|AR-15\/M4|MIL-SPEC CARBINE/.test(blob) &&
        !/\bAR[- ]?10\b|\bAR10\b/.test(tv)) return true;
    if (/MIL[- ]?SPEC/.test(tv) && /STOCK|STK/.test(tv) && /RISER|COLLAPSIBLE|CARB/.test(tv) &&
        !/\bAR[- ]?10\b|\b308\b/.test(tv)) return true;
    if (/MAGPUL/.test(tv) && /CHEEK RISER/.test(tv) && /MOE|CTR |ACS |SL-M/.test(tv) && !/\bAK\b/.test(tv)) return true;
    if (/LUTH/.test(tv) && /MBA-?\d/.test(tv) && !/\b308\b|\bAR[- ]?10\b|\bAR10\b/.test(tv)) return true;
    if (/\bM16\b/.test(tv) && /BUFFER|BCG|GAS TUBE|CHARGING|LPK|STOCK|A2 /.test(tv) &&
        !/\bAR[- ]?10\b/.test(tv)) return true;
    return false;
  }

  function modelsAkOf(title, desc) {
    var u = (title || '').toUpperCase();
    var d = descHead(desc, 700);
    var blob = u + ' ' + d;
    var found = {};
    function add(id) { found[id] = 1; }
    if (/YUGO|ZASTAVA|\bM70\b|\bNPAP\b|\bPAP\b/.test(blob)) add('Yugo');
    if (/AK[- ]?74|\bAK74\b|AK47\/74|AK-47\/74|5\.45/.test(blob) && !/7\.62X51/.test(u)) add('AK74');
    if (/AK[- ]?47|\bAK47\b|\bAKM\b|7\.62X39|762X39/.test(blob)) add('AKM');
    if (!found.AKM && !found.AK74 && !found.Yugo && /\bAK\b/.test(blob)) add('AKM');
    return Object.keys(found);
  }

  function isAr762x39Mag(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var blob = u + ' ' + v + ' ' + descHead(desc, 400);
    if (!/7\.62X39|762X39/.test(u + ' ' + v)) return false;
    if (/MINI[- ]?30/.test(blob)) return false;
    if (/\bAK[- ]?47\b|\bAK47\b|\bAKM\b|\bAK\b/.test(u) && !/\bAR\b/.test(u.replace(/ARSENAL/g, ''))) return false;
    if (/DURAMAG/.test(blob)) return true;
    if (/\bASC AR\b|^MAG(?:AZINE)? ASC AR\b/.test(u)) return true;
    if (/FITS AR RIFLE|\bAR RIFLES?\b/.test(blob)) return true;
    if (/MAG/.test(u) && /\bAR\b/.test(u) && !/ARSENAL/.test(u)) return true;
    return false;
  }

  function isAkFirearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (isAr762x39Mag(title, vendor, desc)) return false;
    if (/\bAR[- ]?15\b|\bAR15\b|\bAR[- ]?10\b|\bAR10\b|\bSR[- ]?25\b/.test(tv) &&
        !/\bAK[- ]?47\b|\bAK47\b|\bAKM\b|\bAK\b/.test(tv)) return false;
    if (/7\.62X51|\.308\b|308WIN|6\.5 ?CM/.test(tv) && !/7\.62X39|AK/.test(tv)) return false;
    if (/10\/22|10-22/.test(tv)) return false;
    if (/SIDE FOLDER|BEAM SIDE FOLDER/.test(tv) && /MIDWEST|ALPHA M4/.test(tv) && !/\bAK\b/.test(tv)) return false;

    if (/\bAK[- ]?47\b|\bAK47\b|\bAK[- ]?74\b|\bAK74\b|\bAKM\b/.test(tv)) return true;
    if (/\bAK\b/.test(tv) &&
        /MAG|GRIP|GRP|STOCK|STK|HANDGUARD|HNDGRD|TRIGGER|TRIG|BRAKE|SLING|RAIL|SIGHT|PMAG|MOE|ZHUKOV|ZHKV|CHEEK RISER/.test(tv)) {
      return true;
    }
    if (/7\.62X39|762X39|7\.62 ?X ?39/.test(tv) && /MAG|PMAG|AK/.test(tv)) return true;
    if (/ZHUKOV|ZHKV/.test(tv)) return true;
    if (/WASR|ZASTAVA|YUGO AK|\bSAM7\b|\bSLR-?107\b|\bKRINK\b|\bVEPR\b/.test(tv)) return true;
    if (/14X1LH|14X1 LH|M14X1/.test(tv) && /BRAKE|COMP|FH|FLASH|HIDER|SLANT/.test(tv)) return true;
    if (/^B5 /.test(u) && /\bAK\b/.test(tv)) return true;
    if (/FITS AK|FOR AK[- ]?47|AK-47\/AK-74|AK47\/74|AK 47\/74/.test(blob)) return true;
    if (/MAGPUL/.test(tv) && /\bAK\b|AKM|AK-47|AK47/.test(tv)) return true;
    return false;
  }

  function models1022Of(title, desc) {
    var u = (title || '').toUpperCase();
    var d = descHead(desc, 700);
    var blob = u + ' ' + d;
    var found = {};
    function add(id) { found[id] = 1; }
    if ((/\bTD\b/.test(u) && !/MEPROLT/.test(u)) ||
        /TAKEDOWN|10\/22TD|10-22TD|10\/22 TD|10-22 TD/.test(blob)) {
      add('Takedown');
    }
    if (/CHARGER|\bCHRGR\b/.test(blob)) add('Charger');
    return Object.keys(found);
  }

  function is1022Firearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/\b(RIFLE CASE|RFL CASE|RFL CAS|GUN CASE)\b/.test(tv) ||
        (/\bCASE\b/.test(tv) && /ALLEN/.test(tv))) return false;
    if (/TEKMAT|RIFLE MAT|CLEANING MAT|BENCH BLOCK/.test(tv)) return false;
    if (/CLEANING KIT|CLN KIT/.test(tv)) return false;
    if (/\d+-\d+X/.test(u) && !/MOUNT|RAIL|BASE|RING/.test(u)) return false;
    if (/SWEET 22/.test(tv)) return false;
    if (/\bAR223\b|\bAR[- ]?15\b|\bAR15\b/.test(tv) && !/\b10\/22\b|\b10-22\b/.test(tv)) return false;
    if (/MINI[- ]?14|MKIII|MKIV|MARK IV|\bSR22\b|\bLCP\b|BUCK MARK|MK SERIES/.test(tv) &&
        !/\b10\/22\b|\b10-22\b/.test(tv)) return false;
    if (/M&P15-22|MP15-22/.test(tv)) return false;
    if (/BX-1 MCKENZIE|\bBINO|\bBINOC/.test(tv)) return false;
    /* TacSol TSG-22 is its own .22 rifle, not a 10/22. */
    if (/\bTSG-?22\b/.test(tv) && !/\b10\/22\b|\b10-22\b|\bRUG10-22\b/.test(tv)) return false;

    if (/MAGPUL/.test(tv) && /X-?22|HTR X22|BCKPCKR|\bBPKR\b/.test(tv)) return true;
    if (/\bBX-TRIGGER\b|\bBX TRIGGER\b/.test(tv)) return true;
    if (/\b10\/22\b|\b10-22\b|\bRUG10-22\b/.test(tv)) return true;
    if (/\b1022\b/.test(tv) && /RUGER|\bRUG\b|\bRGR\b/.test(tv)) return true;
    if (/(TACSOL|TAC SOL|TACTICAL SOLUTIONS)/.test(tv)) {
      if (/X-?RING|XRING|\.920 COMP|\bXRT\b/.test(tv) && !/BUCK MARK|MK SERIES|\bTSG-?22\b/.test(tv)) return true;
    }
    if (/\b10\/22\b|\b10-22\b|\bRUG10-22\b/.test(d)) return true;
    if (/\b1022\b/.test(d) && /RUGER|FITS|FOR /.test(d) && !/\b10-223\b/.test(d)) return true;
    if (/FITS RUGER 10\/22|FOR RUGER 10\/22|FITS 10\/22|FOR 10\/22/.test(blob)) return true;
    return false;
  }

  function modelsAr10Of(title, desc) {
    var u = (title || '').toUpperCase();
    var d = descHead(desc, 700);
    var blob = u + ' ' + d;
    var found = {};
    function add(id) { found[id] = 1; }
    if (/CARBINE|\bCARB\b|CARB BFR|CARBINE LENGTH|CARBINE BUFFER|A5 LENGTH/.test(u) ||
        (/\bA5\b/.test(u) && /RCVR|RECEIVER|BUFFER|EXT/.test(u)) ||
        /CARBINE LENGTH|CARBINE[- ]LENGTH|CARBINE BUFFER|CARBINE\/SR25|CARBINE\/SR-25|COMPATIBLE WITH CARBINE/.test(d)) {
      add('Carbine');
    }
    if ((/RIFLE LENGTH|RIFLE-LENGTH|RFL\/FXD|RIFLE BUFFER|RIFLE GAS|\bRFL\b/.test(u) ||
        ((/BBL|BARREL/.test(u)) && /\bRIFLE\b/.test(u))) &&
        !/RIFLE MAT/.test(u)) add('Rifle');
    if (/RIFLE[- ]LENGTH|RIFLE BUFFER TUBE|RIFLE RECEIVER EXT/.test(d)) add('Rifle');
    if (/\bSR[- ]?25\b|\bSR25\b|L7AWM/.test(blob)) add('SR25');
    if (/\bLR[- ]?308\b|\bLR308\b|\bDPMS\b|\bAR308\b|\bAR-308\b/.test(u) ||
        /DPMS PATTERN|FITS DPMS|DPMS\/SR25|DPMS\/SR-25|LR-308 PATTERN/.test(d)) add('DPMS');
    if (/HIGH PRO/.test(u) && /308|AR10|AR-10/.test(blob)) add('DPMS');
    if (/6\.5\s*CM|6\.5 CREED|6\.5CREED|\b65CM\b/.test(blob)) add('65CM');
    return Object.keys(found);
  }

  function isAr10Firearm(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var d = descHead(desc, 700);
    var tv = u + ' ' + v;
    var blob = tv + ' ' + d;
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/10\/22|10-22/.test(tv)) return false;
    if (/L5AWM/.test(tv) && !/L7AWM/.test(tv)) return false;
    if (/AICS/.test(tv) && !/AR[- ]?10|SR-25|LR-308/.test(tv)) return false;
    if (/6MM ?ARC|6MMARC/.test(tv)) return false;
    if (/7\.62X39/.test(tv) && !/AR[- ]?10|SR-25|L7AWM/.test(tv)) return false;
    if (/SIG CROSS/.test(tv)) return false;
    if (/\bSCAR\b/.test(tv) && !/AR[- ]?10|AR10/.test(tv)) return false;
    if (/338LAP|338 LAPUA|\.338\b/.test(tv)) return false;
    if (/APOLLO LR/.test(tv) && !/AR[- ]?10|AR10/.test(tv)) return false;
    if (/BANISH/.test(tv) && !/AR[- ]?10|AR10/.test(tv)) return false;
    if (/SHIM KIT|3[- ]?LUG|FIXED MOUNT/.test(tv) && !/AR[- ]?10|AR10/.test(tv)) return false;
    if (/5\/8X24|5\/8-24/.test(tv) && /5\.56|6\.8SPC|\b9MM\b|\b6MM\b/.test(tv) &&
        !/AR[- ]?10|AR10|308|7\.62/.test(tv)) return false;
    if (/\b(SAVAGE 110|BURRIS|BORESIGHT|TIKKA|HOWA|BERGARA|REMINGTON 700|\bR700\b)\b/.test(tv) && !/AR[- ]?10|AR10/.test(tv)) return false;
    if (/DPMS/.test(tv) && /CAR-15|AR15|AR-15/.test(tv) && !/308|AR10|AR-10/.test(tv)) return false;
    if (/\bAR[- ]?15\b|\bAR15\b/.test(tv) &&
        !/\bAR[- ]?10\b|\bAR10\b|AR15\/AR10|AR15\/10|AR15\/AR-10|SR-25|LR-308|L7AWM/.test(tv)) return false;

    if (/\bAR[- ]?10\b|\bAR10\b|\bAR 10\b/.test(tv)) return true;
    if (/\bSR[- ]?25\b|\bSR25\b/.test(tv)) return true;
    if (/\bLR[- ]?308\b|\bLR308\b/.test(tv)) return true;
    if (/\bAR-308\b|\bAR308\b/.test(tv)) return true;
    if (/L7AWM/.test(tv)) return true;
    if (/CMMG LPK 308|LPK MK3|ZEROED LPK MK3|MK3 FIRING PIN/.test(tv)) return true;
    if (/CMMG/.test(tv) && /\bMK3\b/.test(tv)) return true;
    if (/FAXON/.test(tv) && /308WIN|6\.5 CM|8\.6/.test(tv) && !/5\.56|223WYLDE/.test(tv)) return true;
    if (/BALLISTIC BBL/.test(tv) && /308WIN/.test(tv)) return true;
    if (/NOVESKE/.test(v) && /LRG FRM|LARGE FRAME/.test(tv)) return true;
    if (/AERO M5|\bM5\b/.test(tv) && /AR10|AR-10|308/.test(blob)) return true;
    if (/DPMS/.test(tv) && /308|G2 |AR10|AR-10/.test(tv)) return true;
    if (/\bPMAG\b/.test(tv) && /7\.62|\b762\b/.test(tv) && !/5\.56|223|\bAK\b|AICS|CROSS/.test(tv)) return true;
    if (/DURAMAG/.test(tv) && /308|6\.8X51/.test(tv)) return true;
    if (/MAG MFT/.test(u) && /\.308|7\.62/.test(u)) return true;
    if (/^MAG(?:AZINE)? ASC\b/.test(u) && /AR308|308/.test(u)) return true;
    if (/HF AR15\/10|AR15\/AR10|AR15\/10 /.test(tv)) return true;
    if (/FITS AR[- ]?10|FOR AR[- ]?10|DPMS PATTERN|SR-25 PATTERN/.test(blob)) return true;
    if (/MIDWEST/.test(tv) && /308|AR10|AR-10/.test(tv) && /ROD|HANDGUARD|RAIL/.test(tv)) return true;
    if (/LUTH/.test(tv) && /\b308\b/.test(tv)) return true;
    if (/\bLBE\b/.test(tv) && /308/.test(tv)) return true;
    if (/BOOTLEG/.test(tv) && /308/.test(tv)) return true;
    if (/KYNSHOT/.test(tv) && /308|AR10|AR-10/.test(tv)) return true;
    if (/DST CVR|DUST COVER/.test(tv) && /308|AR10|AR-10/.test(tv)) return true;
    if (/GAS TUBE|GAS RING/.test(tv) && /308/.test(tv)) return true;
    if (/LR\/10|\bAR LR\/10\b/.test(tv)) return true;
    if (/\bMLOK\b/.test(tv) && /308/.test(tv) && /ODIN|HANDGUARD|FOREND|RAIL|HIGH PRO/.test(tv)) return true;
    if (/MBA-?\d/.test(tv) && /308|AR[- ]?10|AR10/.test(tv)) return true;
    if (/5\/8\s*X\s*24|5\/8-24|5\/8X24/.test(tv) &&
        /FH|FLASH|MB\b|BRAKE|COMP|BIRDCAGE|PRONG|SOCOM|DYNACOMP|PEGASUS|APOLLO|SUPPRESSOR/.test(tv) &&
        /308|7\.62|\b762\b|762NATO|6\.5\s*CM|AR10|AR-10|SR-25|SR25/.test(tv) &&
        !/1\/2X28|5\.56|9MM|338|SCAR|CROSS|\b6MM\b/.test(tv)) return true;
    if (/FLASH SUPPRESSOR|BIRDCAGE|DYNACOMP/.test(tv) && /308|7\.62/.test(tv)) return true;
    if (/6\.5\s*CM|6\.5 CREED/.test(tv) && /BBL|BARREL|BCG|MB\b|BRAKE|COMP|5\/8/.test(tv) && !/GRENDEL/.test(tv)) return true;
    return false;
  }

  function partTypeFromDesc(desc) {
    var head = descHead(desc, 500);
    if (!head) return '';
    if (/\b(MAGAZINE EXTENSION|MXT EXTENSION|EXTENSION PACKAGE|EXTENSION COVER|EXTENSION NUT)\b/.test(head)) return 'mag-extensions';
    if (/\b(FOLLOWER|MAGAZINE FOLLOWER)\b/.test(head) && !/\bMAGAZINE\b.{0,12}\b(FOR|FITS)\b/.test(head)) return 'other';
    if (/\bBARREL CLAMP\b/.test(head)) return 'other';
    if (/\bRECOIL PAD\b/.test(head)) return 'stocks';
    if (/\bMAGAZINE\b/.test(head) && !/\b(COUPLER|MAGLINK|HOLSTER|POUCH|MAGWELL|FLOORPLATE|RELEASE|CATCH|BUTTON|SPACER|BASE PAD|SLEEVE|ADAPTER|LOADER|BRUSH|PAD|VISE|EXTENSION|FOLLOWER)\b/.test(head)) return 'magazines';
    if (/\b(MAGAZINE LOADER|MAG LOADER|LULA|MAGPUMP|STRIPLULA|MOON CLIP|FULL MOON CLIP)\b/.test(head)) return 'loaders';
    if (/\bCHARGING HANDLE\b/.test(head) && !/\b(KIT|BCG|BOLT CARRIER)\b/.test(head)) return 'charging-handles';
    if ((/\bLOWER PARTS KIT\b|\bLOWER RECEIVER PARTS\b|\bLPK\b/.test(head)) && !/\bUPPER\b/.test(head)) return 'triggers';
    if ((/\bBOLT CARRIER\b|\bBCG\b/.test(head)) && !/\b(KIT|CATCH|CHARGING HANDLE|SCRAPER|BRUSH|BUFFER|FIRING PIN)\b/.test(head)) return 'bcg';
    if (/\bHOLSTER\b/.test(head)) return 'holsters';
    if (/\bSIDE SADDLE\b|\bSIDESADDLE\b|\bSURESHELL\b/.test(head) && !/HARD HAT|\bHAT\b/.test(head)) return 'side-saddles';
    if (/\b(FLASHLIGHT|WEAPON LIGHT|TACTICAL LIGHT|LASER)\b/.test(head) && !/\bHOLSTER\b/.test(head)) return 'lights';
    if (/\b(FLASH HIDER|FLASH SUPPRESSOR|MUZZLE BRAKE|MUZZLE DEVICE)\b/.test(head)) return 'compensators';
    if (/\bDUST COVER\b/.test(head)) return 'other';
    if (/\bHAMMER\b/.test(head) && !/\bTRIGGER\b/.test(head)) return 'other';
    if (/\bTRIGGER\b/.test(head) && !/TRIGGER GUARD/.test(head) && !/\bHAMMER\b/.test(head)) return 'triggers';
    if (/\bBEAVERTAIL\b|\bBVR TAIL\b|\bBVRTL\b/.test(head) && !/HANDALL/.test(head)) return 'other';
    if (/\bGRIP SCREW/.test(head) || (/\bHEX HEAD\b/.test(head) && /SCREW|SET/.test(head))) return 'other';
    if (/\bLASERGRIPS?\b|\bLASER GRIPS?\b/.test(head) ||
        (/\bGRIP\b/.test(head) && !/\bSTOCK\b/.test(head))) return 'grips';
    if (/\bSIGHT\b/.test(head) && !/\b(PLATE|MOUNT|ADAPTER)\b/.test(head)) return 'sights';
    if (/\bBORE LIGHT\b/.test(head)) return '';
    if (/\bBARREL\b/.test(head) &&
        !/\b(BUSHING|WRENCH|TAKE-?DOWN|NUT|RAIL|MOUNT|CLAMP|DIAMETER|SPACER|IMPERFECTION|FOULING|INSPECT)\b/.test(head)) return 'barrels';
    if (/\bHANDGUARD\b/.test(head)) return 'handguards';
    if (/\bFOREND\b/.test(head)) return 'forends';
    if (/\bHEATSHIELD\b|\bHEAT SHIELD\b/.test(head)) return 'heatshields';
    if (/\b(FIRING PIN|FRNG PIN|STRIKER)\b/.test(head)) return 'other';
    if ((/\bSTOCK\b/.test(head) || /\bCHASSIS\b/.test(head)) &&
        !/\bWRENCH\b/.test(head) && !/\bSTOCK DUST\b/.test(head) &&
        !/\b(FIRING PIN|STRIKER|FLASH HIDER|MUZZLE BRAKE|DUST COVER)\b/.test(head)) return 'stocks';
    if (/\bSLIDE\b/.test(head) && !/\b(CATCH|RELEASE|CAP|STOP|STP|LOCK|LCK)\b/.test(head)) return 'slides';
    if (/\bCOMPENSATOR\b/.test(head)) return 'compensators';
    return '';
  }

  // MOS / optic-cut adapter plates. Mag floorplates, AR end plates, Glock
  // back plates, and sight-pusher shoe plates stay out.
  function isFirearmOpticPlate(u) {
    if (!u) return false;
    if (/\bMAG PLATE\b|\bMAGPLATE\b|\bBASE PLATE\b|\bBASE PLT\b|\bBSE PLT\b|\bFLOORPLATE\b|\bFLOOR PLATE\b|\bEND PLATE\b|RANGER PLT|RANGER PLATE/.test(u)) {
      return false;
    }
    if (/\bBACK PLT\b|\bBACK PLATE\b/.test(u)) return false;
    if (/PLATE CARRIER|SHOE PLATE|ARMOR PLATE|SLING (ATTCH )?PLT|SLING ATTACH/.test(u)) return false;
    if (/TO RMR|TO SRO|TO HOLO|MOS TO |TO ACRO|TO 509|TO EPS|TO DPP|TO 407|TO 507|TO RMS|OR TO RMR|OR TO HOLO/.test(u)) {
      return true;
    }
    if (!/\bPLT\b|\bPLATES?\b/.test(u)) return false;
    if (/RMR|\bSRO\b|\bHOLO|\bEPS\b|\bACRO\b|\bMOS\b|\bDPP\b|EFLX|ELFX|407K|507K|407C|507C|509T|RMSC|RMS-C|RMS C|RMRCC|\bRCR\b|\bOPTIC|\bDOT\b|ROMEO|FASTFIRE|AMPNT|AIMPOINT|TRIJ|LEU DPP|K\/RMSC|K\/RMS/.test(u)) {
      return true;
    }
    if (/OPTICS? PLATE|MOUNTING PLATE|MOUNT PLATE|ADP PLATE|ADAPTER PLATE|DT PLATE|DT PLT|DOVETAIL PLATE/.test(u)) {
      return true;
    }
    return false;
  }

  // Scope rails, Weaver/Picatinny bases, and rings on the gun page.
  // Sling mounts, mag floorplates, and handguard rail systems stay out.
  function isFirearmScopeMount(u) {
    if (!u) return false;
    if (/\b(HANDGUARDS?|HNDGRD|HANDGRD|FORENDS?|FORND|RAIL SYSTEMS?|RL SYSTM|INT RL|MLOK HG|FREE FLT|FREE FLOAT)\b/.test(u)) {
      return false;
    }
    if (/\b(SLING|SLNG) (MNT|MOUNT|ATTCH|ATTACH)\b|\bFRNT SLNG MNT\b|\bSLNG MNT\b/.test(u) &&
        !/SCOPE|PICATINN|PIC RAIL|\bRINGS?\b/.test(u)) {
      return false;
    }
    if (/TEKMAT|CLEANING|CLEAN KIT|\bCASE\b|PLATE CARRIER|\bCHOKE\b|\bFOLLOWER\b|\bBIPOD\b/.test(u)) {
      return false;
    }
    if (/\bEND PLATE\b|\bMAG PLATE\b|\bFLOORPLATE\b|\bBACK PLT\b/.test(u)) return false;
    if (/PICATINN?Y|PIC RAIL|PIC BASE|PICATINY/.test(u)) return true;
    if (/SCOPE (MOUNT|MNT|RAIL|BASE)|SCP (BASE|RAIL)|OPTICS? MOUNT/.test(u)) return true;
    if (/BASE SYS|BASE PAIR|2PC BSE|\b2PC BASE\b|\b1PC BASE\b/.test(u)) return true;
    if (/\b\d+\s*MOA\b/.test(u) && /RAIL|BASE|BSE|\b1PC\b|\bRL\b|REM ?700|REM700|REMINGTON|RUGER|BERGARA|SEEKINS|10\/22|M77/.test(u)) return true;
    if (/RCVR MOUNT|RECEIVER MOUNT|RECEIVER SCOPE|MULT SLOT|MULTI SLOT|MULTI-SLOT/.test(u)) return true;
    if (/PIC ANTICNT|PIC ANTI/.test(u)) return true;
    if (/^DNZ\b/.test(u) && /PIC|RAIL|MNT|\bMT\b|30MM|34MM|HIGH|MED|LOW/.test(u)) return true;
    if (/^TALLEY\b/.test(u) && /PIC|RINGS|\bRNG\b|\bRNGS\b|BASE|ANTICNT/.test(u)) return true;
    if (/\bRINGS?\b|\bRNGS\b|\bRNG\b/.test(u) &&
        !/GAS RING|LOCK RING|CASTLE|KEY RING|D RING|PISTON RING|DELTA RING|SLIP RING|FRNG|GHOST RING/.test(u)) {
      return true;
    }
    if (/\b(30MM|34MM)\b/.test(u) && /MNT|MOUNT|HIGH|HGH|MED|LOW|\bHI\b|RING|RNG/.test(u)) return true;
    if (/LW RINGS|MAXIMA|QRW |RFLMN|RIFLEMAN|SEE-THRU|SEE THRU/.test(u)) return true;
    if (/WEAVER #\d+|WEAVER EXT(?:ENDED)? MULT|WEAVER \d+[- ]1PC/.test(u)) return true;
    if (/\bSHOTGUN RAIL\b/.test(u)) return true;
    if (/VAPR RL|VAPOR RAIL|VAPOR RL|TACTICAL 1PC|TACT 1PC/.test(u)) return true;
    if (/\bXTB\b/.test(u)) return true;
    if (/RGR TO WVR|RGR TO WEAVER|RUGER TO WEAVER/.test(u)) return true;
    if (/^RUGER\b/.test(u) && /\b(30MM|1)\b/.test(u) && /HIGH|MED|LOW|X-HI|OFFSET|SLD INDV|SOLD INDV|SET BLUE|SET MBL|2PK/.test(u)) {
      return true;
    }
    if (/\bHNNIBL\b|\bHNBL\b/.test(u) && /\bRL\b|RAIL/.test(u)) return true;
    if (/\b1(?:PC|-PIECE)\b/.test(u) && /REM|RUG|700|SA\b|LA\b/.test(u)) return true;
    if (/\bRAIL\b/.test(u) && /REM ?700|REM700|\b700 (SA|LA)\b|10\/22|10-22|M77|MINI-?14/.test(u)) return true;
    if (/\bMNT\b/.test(u) && /(30MM|34MM|\b1\b).{0,16}(MED|HIGH|HI\b|LOW)|SEE-THRU/.test(u)) return true;
    if (/LEUP (QRW|RM |BC RM|RFLMN|RIFLEMAN|CNTRY|COUNTRY)/.test(u)) return true;
    if (/LEUPOLD/.test(u) && /CNTRY|COUNTRY SLOT|QRW |RIFLEMAN|\bBC SAV|\bBC REM|\bBC\b|\bRM\b|2-PIECE|2PC|1-PIECE|1PC|\bHGH\b/.test(u)) return true;
    if (/FASTFIRE (MNT|MOUNT)|RED DT MNT|RED DT MOUNT|MNLST/.test(u) && /GLOCK|GLK|M&P|BERETTA|PX/.test(u)) return true;
    if (/TACTICAL 1(?:PC|-PIECE)|TACT 1PC/.test(u)) return true;
    if (/\b(MNT|MOUNT)\b/.test(u) && /RMR|ACRO|FASTFIRE|HOLO|EPS|SRO|MOS|RED DT/.test(u) &&
        !/SLING|LIGHT MOUNT|WML|WEAPON LIGHT/.test(u)) return true;
    if (/CANTILEVER|CNTLVR/.test(u) && /30MM|34MM|SCOPE|SRS/.test(u)) return true;
    if (/SPR PRCSN|SUPER PRECISION/.test(u) && /\d+MM/.test(u)) return true;
    if (/SLOT BASE/.test(u)) return true;
    return false;
  }

  function isFirearmMat(u, v) {
    v = v || '';
    if (/CERUS GEAR/.test(v)) return true;
    return /TEKMAT|SMART MAT|ULTRA PSTL MAT|PSTL MAT|PISTOL MAT|RIFLE MAT|GUN MAT|SCHEMATIC|\bCOMBO MAT\b/.test(u) &&
      !/STAR CHMBR|CHAMBER PAD/.test(u);
  }

  function isFirearmTool(u, v) {
    v = v || '';
    if (isFirearmMat(u)) return false;
    if (/SIGHT TOOL|SIGHT ADJ|SIGHT ADJSTR/.test(u) && !/ARMORER|WRENCH|PUNCH|VISE/.test(u)) return false;
    if (/REAL AVID/.test(v) && /GUN BOSS|SMART WRENCH|SMART-FIT|SMARTFIT|ARMORER|MASTER KIT|SCRAPER|CHAMBER BOSS|CARBON BOSS|BRUSH COMBO|CLNING PAD|STAR CHMBR/.test(u)) {
      return true;
    }
    return /WRENCH|CROWS ?FT|CROWFOOT|CROW FULLSET|VISE BLOCK|VICE BLOCK|VISE BLCK|VISE CLAMP|BEV BLOCK|BENCH BLOCK|REACTION ROD|ARMORERS?|DISASSEMBLY|\bPUNCH\b|TAKE[- ]?DOWN TOOL|GUN BOSS|FIELD REPAIR|MISSING PARTS|FIX-IT-KIT|BORE GUIDE|CHAMBER BRUSH|MAGAZINE BRUSH|CARBON SCRAPER|FOULNG RMVL|CLNG KIT|CLN KIT|CLEANING KIT|MASTER KIT|ARMORER|QUICK REPAIR|SURVIVAL KIT|HIGH WEAR PARTS|SPARE AR[- ]?15 PARTS|BOX KIT AR[- ]?15|BRUSH SET|RECEIVER BLOCK|RECEIVER WEDGE/.test(u) ||
      (/\bTOOLS?\b/.test(u) && !/\bSIGHT/.test(u) && !/MULTI[- ]?TOOL/.test(u));
  }

  function isArBolt(u) {
    if (/BOLT CATCH|BOLT CARRIER|\bBCG\b/.test(u)) return false;
    return /\bBOLT ASSEMBLY\b|\bBOLT REFURB\b|\bBOLT REHAB\b|\bBOLT REPAIR\b|\bBOLT COMPONENT\b/.test(u) ||
      (/\bBOLT\b/.test(u) && /AR[- ]?15|AR15|10\/22|10-22|5\.56|556|300BLK|6ARC|6\.5GREN|GRENDEL/.test(u));
  }

  function isSpringsDetents(u) {
    if (/BUFFER SPRING|RECOIL SPRING|MAINSPRING HOUSING|SEAR SPRING/.test(u)) return false;
    return /RECEIVER DETENT|DETENT KIT|PIN AND DETENT|PINS\/SPRING|PIVOT\/TD DETENT|EJCTN PORT CVR SPRING/.test(u) ||
      (/\bDETENT\b/.test(u) && /AR[- ]?15|AR15/.test(u));
  }

  function isSlingMount(u) {
    return /SLING SWIVEL|SLING MOUNT|SLNG MNT|SLING MNT|QD SLING|QD SLNG|QD SLING SWIVEL|SWIVEL SET|LCK SWIVEL|QD SWIVEL/.test(u);
  }

  function isRailCover(u) {
    if (/QUAD RAIL|MCMR RAIL|\bN4\b|HANDGUARD|HNDGRD|FREE FLT|CARBN RAIL/.test(u)) return false;
    return /RAIL PNL|RL PNL|RAIL PANELS|KMOD RAIL PANELS|KEYMOD NYLON|KEYMOD ALUM/.test(u) ||
      (/GUNFTR (NYLON|ALUM) RAIL/.test(u) || /GUNFIGHTER (NYLON|ALUM(?:INUM)?) RAIL/.test(u));
  }

  function isSmallHardware(u) {
    return /CRUSH WASHER|\bC WSHR\b|\bBARREL NUT\b|\bBBL NUT\b|\bBRL NUT\b|\bJAM NUT\b|A5 SPACER/.test(u);
  }

  function isEndPlate(u) {
    if (/MAG PLATE|FLOORPLATE|RANGER PLT|BACK PLT|OPTIC PLATE/.test(u)) return false;
    return /\bEND PLATES?\b|\bENDPLATE\b|\bCASTLE NUTS?\b/.test(u);
  }

  function isFirearmSafety(u) {
    if (/FIRING PIN SFTY|FRNG PIN SFTY|CABLE LOCK|TRIGGER LOCK|GUN LOCK|MASTERLOCK/.test(u)) return false;
    // Complete drop-in triggers often say "with safety". Those stay triggers.
    if (/\bTRIGGERS?\b|\bTRIGGER\b|\bTRIG\b|TRIGGERTECH|TRIGRTECH/.test(u)) return false;
    if (/BEAVERTAIL|BVR TAIL|BVRTL/.test(u) && !/HANDALL/.test(u)) return true;
    return /THUMB SAFETY|THUMB SFTY|GRIP SFTY|GRIP SAFETY|AMBI SAFETY|SAFETY SELECTOR|SELECTOR|\bSLCTR\b|MAN SAFETY|\bSAFTEY\b/.test(u) ||
      (/\bTALON\b/.test(u) && /45\/90|90\/60/.test(u)) ||
      (/90\/60|45\/90/.test(u) && /AMBI|AMBIDEXTROUS|\bSFY\b|\bSFTY\b/.test(u)) ||
      (/\b(SAFETY|SFTY|SAFTEY|SFY)\b/.test(u) && !/FIRING PIN|FRNG PIN/.test(u));
  }

  function isFirearmInternal(u) {
    if (isFirearmTool(u, '') || isFirearmSafety(u) || isFirearmMat(u)) return false;
    if (/FIELD REPAIR|ARMORER|WRENCH|PUNCH/.test(u)) return false;
    return /SEAR|DISCONNECT|EXTRACTOR|FIRING PIN|FRNG PIN|STRIKER|LOCKING BLOCK|MAINSPRING HOUSING|CONNECTOR|SPRING CUPS|REBUILD KIT|COMPLETION KIT|UPPER PARTS KIT|LOWER PRTS KIT|PIN SET FOR 1911|SPRING CUP|PLNGR W\/RDCD|TAKEDOWN LEVER|SLIDE CAP|FORWARD ASSIST|FRWD ASSIST|FWD ASSIST/.test(u) ||
      (/\bHAMMERS?\b/.test(u) && !/WRENCH|PUNCH|TOOL/.test(u)) ||
      (/PARTS KIT/.test(u) && /UPPER|LOWER|PINS\/SPRNG/.test(u) && !/FIELD REPAIR|SURVIVAL|FIX-IT/.test(u));
  }

  function isFirearmRelease(u) {
    if (!u || /\bTOOL\b/.test(u)) return false;
    if (/\bPINS?\b/.test(u)) return false;
    if (/\bMAG CATCH\b|\bMAGAZINE CATCH\b|\bMAG CTCH\b|\bMAG RLS\b|\bMAG REL\b|\bMAG RELEASE\b|\bMAG RLESE\b|\bMAG RLSE\b/.test(u)) {
      return true;
    }
    if (/\b(SLIDE|SLD) (REL|RLS|RELEASE|CATCH|CTCH)\b/.test(u)) return true;
    if (/\bBOLT CATCH\b|\bBOLT CTCH\b/.test(u)) return true;
    if (/\bEMMR\b/.test(u) && /MAG/.test(u)) return true;
    if (/\bVCKR\b/.test(u) && /RLS|RELEASE/.test(u)) return true;
    return false;
  }

  function partType(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var holsterBrand = /HOLSTER|GUNHIDE|CONCEALMENT|SAFARILAND|1791|DESANTIS|G-CODE|GCODE|BLACKHAWK|BLACKPOINT|BLACK POINT|BLK PNT|CROSSBREED|VEDDER|PHLSTER|STEALTH OPERATOR|COMP-TAC|COLE-?TAC|GALCO|BIANCHI|BRAVO CONCEAL|ALIEN GEAR|L\.?A\.?G|MISSION FIRST|^MFT |ANR DESIGN|RAPID FORCE|^STICKY HOLSTERS/;
    if ((holsterBrand.test(v) || /\bKENAI\b/.test(u) || /TECHNA CLIP|TECHNA CC/.test(u) || /TECHNA CLIP/.test(v) ||
        (/BULLDOG/.test(v) && /EXTREME|RAPID RELEASE|TOMCAT/.test(u))) &&
        !/^MAG\b/.test(u) && !/\bMAGAZINE\b/.test(u) &&
        !/\bMAG PCH\b|\bMAG POUCH\b|\bMAG CARRIER\b/.test(u) &&
        !/\b(GRIPS?|GRP|HNDGRD|HANDGRD|HANDGUARD|RAIL|STOCK|STK|FOREND|FORND|RL SYSTM|INT RL|FREE FLT|FREE FLOAT|MLOK HG)\b/.test(u)) {
      return 'holsters';
    }
    if (/\bBORE LIGHT\b/.test(u)) return 'other';
    if (/\bGRP PAD\b|\bGRIP PAD\b|RUB GRP PAD/.test(u)) return 'grips';
    if (/\bMAGLULA\b|\bUPLULA\b|\bSTRIPLULA\b|\bMAGPUMP\b|\bMAG LOADER\b|\bMAG CHARGER\b|\bLOADR\b|\bLDR\/UNLDR\b|\bLOADER\b/.test(u)) {
      return 'loaders';
    }
    if (/\bSPDLR\b|\bSPDLDR\b|\bSPD LDR\b|\bSPEEDLOADERS?\b|\bSPEED LOADERS?\b|\bSPEEDLOADER\b|\bMAGLDR\b|NINE-RELOADED|NINE RELOADED/.test(u) ||
        (/HKS SPEED LOADERS|PACHMAYR/.test(v) && /SPEEDLOAD/.test(u))) {
      return 'loaders';
    }
    if (/\bMOON CLIPS?\b/.test(u) || (/\bFMC\b/.test(u) && /RUGER|REDHAWK|\bLCR\b/.test(u))) {
      return 'loaders';
    }
    if (isCompleteMag(u, v)) return 'magazines';
    if (isMagFloorplate(u) || MAG_ACC_RE.test(u) || /\bMAGAZINE SPACERS?\b|\bMAGAZINE EXTENSIONS?\b|\bMAGAZINE SLEEVES?\b/.test(u) ||
        (/\bSLEEVE\b/.test(u) && /MAGAZINE|\bMAG\b/.test(u)) ||
        (/\b\d+EXT\b/.test(u) && /MAGAZINE|\bMAG\b/.test(u))) {
      if (/MAGAZINE POUCH|MAG POUCH|MAGAZINE CARRIER|MAG CARRIER/.test(u) && !/EXTENSION|SPACER|SLEEVE|X-GRIP|XGRIP/.test(u)) {
        return 'pouches';
      }
      if (/MAGAZINE RELEASE|EXTENDED REL\b|EXTENDED MAGAZINE RELEASE|MAG RELEASE/.test(u) && !/EXTENSION|SPACER/.test(u)) {
        return 'releases';
      }
      return 'mag-extensions';
    }
    if (/\bRELEASE\b/.test(u) && /MAGAZINE|\bMAG\b|\d+\s*-?\s*ROUND/.test(u) && !/EXTENSION|SPACER/.test(u) && !/^MAG\b/.test(u)) {
      return 'releases';
    }
    if (isAirgunFirearm(title, vendor, desc)) return airgunPartType(u);
    if (isFirearmMat(u, v)) return 'mats';
    if (isFirearmTool(u, v)) return 'tools';
    if (isEndPlate(u)) return 'end-plates';
    if (isFirearmSafety(u)) return 'safeties';
    if (isFirearmInternal(u)) return 'internals';
    if (isArBolt(u)) return 'bolts';
    if (isSpringsDetents(u)) return 'springs';
    if (isSlingMount(u)) return 'sling-mounts';
    if (isRailCover(u)) return 'rail-covers';
    if (isSmallHardware(u)) return 'hardware';
    if (/\b(FLOORPLATE|FLRPLT|FLOORPLT|FINGER EXTNSN|FINGER EXTENSION)\b/.test(u) && !/^MAG\b/.test(u) && !/^MAGAZINE\b/.test(u)) {
      return 'mag-extensions';
    }
    if (/\bMAG CATCH\b|\bMAGAZINE CATCH\b|\bBOLT CATCH\b|\bMAG CTCH\b/.test(u) && !/\bPINS?\b/.test(u)) return 'releases';
    if (/\bMAG (REL|RLS|RLESE|RLSE|RELEASE)\b/.test(u) && !/\bTOOL\b/.test(u)) return 'releases';
    if (/\bMAG-WRENCH\b|\bMAG WRENCH\b/.test(u)) return 'tools';
    if (/\bMAG PLATE\b|\bMAGPLATE\b|\bMAG XTENSION\b|\bXTENSION\b|\d+RND EXT\b/.test(u)) return 'mag-extensions';
    if (/\bMAGAZINE BRUSH\b|\bMAG BRUSH\b/.test(u)) return 'other';
    if (/\bVISE BLOCK\b|\bVICE BLOCK\b|\bBEV BLOCK\b/.test(u)) return 'tools';
    if (/LAPPING TOOL|REACTION ROD|RECEIVER ROD/.test(u)) return 'tools';
    if (/\bGAS BLOCK\b|\bGAS BLCK\b/.test(u) || /LOW[- ]?PRO(?:FILE)? GB\b|\bADJSTBLE GAS\b/.test(u)) return 'gas-blocks';
    if (/\bGAS TUBE\b/.test(u)) return 'gas-tubes';
    if (/\bDST CVR\b|\bDUST COVER\b|\bDUST CVR\b|EJECTION PORT COVER/.test(u)) return 'dust-covers';
    if (/SHIM KIT/.test(u)) return 'other';
    if (/RANGER PLT|RANGER PLATE/.test(u)) return 'mag-extensions';
    if (/\bRCVR KT\b/.test(u) && /LOWER|SM PRT/.test(u)) return 'triggers';
    if (/\bAR[- ]?15 TOOL\b|\bAR15 TOOL\b/.test(u)) return 'tools';
    if (/\bVERTICAL (FOREND )?GRIP\b|\bVERT GRIP\b|\bVFG\b/.test(u)) return 'grips';
    if (/\bBUFF\/SPRNG\b|\bBUFFER SPRING\b|\bBUFF SPRNG\b|\bBFR\/SPR\b|SPRING ACTION/.test(u)) return 'recoil';
    if (/\bARMORERS? WRENCH\b|\bCROWS FT\b/.test(u)) return 'tools';
    if (/\bEND PLATE ADAPT/.test(u) && /MP5|HK/.test(u)) return 'stocks';
    if (isEndPlate(u)) return 'end-plates';
    if (isFirearmRelease(u)) return 'releases';
    if (isFirearmOpticPlate(u)) return 'plates';
    if (/\bCASTLE NUT\b/.test(u) && !/\bBUFFER TUBE\b/.test(u)) return 'end-plates';
    if ((/\b(TAKEDOWN|TAKE-?DOWN|TDWN|PIVOT|PVT)\b/.test(u) && /\bPINS?\b/.test(u) && !/\bFIRING\b/.test(u)) ||
        /\bTDWN PVT\b|\bPVT PIN\b|\bTD PIN\b|\bROLL PIN\b|\bPIN SET\b|\bCAM PIN\b|PIVOT LOCK/.test(u) ||
        /TAKEDOWN\/PIVOT|TAKE[- ]?DOWN\/PIVOT|TKDWN.{0,12}PIVOT|LGHT TKDWN|LIGHT TKDWN/.test(u) ||
        /HAMMER\/TRIGGER PIN|TRIGGER\/HAMMER PIN/.test(u)) {
      return 'pins';
    }
    // Recoil pads, not rifle stocks. LIMBSAVER PAD REM700 was landing in 700 stocks.
    if (/^LIMBSAVER\b/.test(u) || /LIMBSAVER/.test(v)) {
      if (/\bHOLSTER\b|\bHLS\b|CLIP-ON/.test(u)) return 'holsters';
      return 'stocks';
    }
    if (/RECOIL PADS?\b|\bRECOIL PD\b/.test(u)) return 'stocks';
    if (/\bRECOIL\b/.test(u) && !/PAD|STOCK/.test(u)) return 'recoil';
    if ((/KYNSHOT/.test(u) || /KYNSHOT/.test(v)) && /\bBUFF/.test(u)) return 'buffer-tubes';
    if (/^ARCHANGEL\b/.test(u) && !/\b(OWB|IWB|HOLSTER|HLSTR|MAG CARRIER)\b/.test(u)) {
      if (POS_MAG.test(u) || /\b\d+RD\b/.test(u)) return 'magazines';
      if (/\bRAIL\b/.test(u) && !/\bSTOCK\b/.test(u)) return 'other';
      return 'stocks';
    }
    if (/\bSTOCKS?\b|\bSTK\b/.test(u) && !/\bMAGAZINE\b/.test(u) && !/\bMAG FOR\b/.test(u) && !/\bBUFF/.test(u) &&
        !/DBL STK|DOUBLE STACK|DBLSTK|DB STK/.test(u)) return 'stocks';
    if (/SIDE FOLDER|BEAM SIDE FOLDER|T-FLDNG|FOLDING STOCK/.test(u) && !/\bKNIFE\b/.test(u)) return 'stocks';
    if (/\bLASERSADDLE\b/.test(u)) return 'lights';
    if (!/SL-SIDESADDLE|HARD HAT/.test(u) && !/\bSDL MNT\b/.test(u) &&
        /\bSIDE SADDLES?\b|\bSIDESADDLE\b|\bSDE SDDLE\b|\bSIDE SDL\b|\bSADDLERAIL\b|\bSURESHELLS?\b|\bSURESHL\b|\bSURSHL\b|\bSRSHL\b|\bSHELL HLDR\b|\bSHL CARRIER\b|\bSHELL CARRIER\b/.test(u)) {
      return 'side-saddles';
    }
    if (/\b(EXT TUBE|EXT TB|SHOT EXT|SHOT EXTENDED|MAG EXTENSIONS?)\b/.test(u) || /\b\d+\s*SHOT EXT/.test(u)) {
      return 'mag-extensions';
    }
    if (/\bMAG CAP\b|\bMAG CLAMP\b|\b12GA NUT\b/.test(u)) return 'other';
    if (/\b(BRL CLMP|BBL CLAMP|BARREL CLAMP)\b/.test(u)) return 'other';
    if (/\bMUZZLE DEVICE\b/.test(u)) return 'compensators';
    if (/\b(MOUNT ASSY|MNT ASSY|OPTIMA MOUNT|MOBIL MOUNT)\b/.test(u)) return 'mounts';
    if (/\bMAG FLLWR\b|\bMAG FOLLOWER\b|\bFLLWR\b|\bFOLLOWERS?\b/.test(u)) return 'magazines';
    if (/\bSCABBARD\b/.test(u)) return 'other';
    if (/\bUD6\b/.test(u)) return 'stocks';
    if (/CHEEK RISER|CHK RISER|CHK RISR|COMB RISER/.test(u)) return 'stocks';
    if (/\b(TAC PACK|TACT KIT)\b/.test(u) && /NORDIC|BERETTA|1301|A300|MXT/.test(u)) return 'mag-extensions';
    if (/\bGRIP EXT\b|\bGRIP EXTENSION\b|\bGRIP PLUS EXT\b/.test(u)) return 'mag-extensions';
    if (/\bJET FUNNEL\b/.test(u)) return 'magwells';
    if (/\b(PSTL BRACE|PISTOL BRACE|ARM BRACE)\b/.test(u)) return 'stocks';
    if (/\bEXTENDED HANDLE\b/.test(u) && /MP5|HK/.test(u)) return 'charging-handles';
    if (/\b3[- ]?LUG\b/.test(u) && !/\bBARREL\b/.test(u)) return 'other';
    if (/\bPLUS[- ]?ONE EXT\b|\bPLUS FOR GLOCK\b|\bPLUS FOR G3\b|\bPLUS 2 ADPTR\b|\+2 ADPTR|PLUS 2 ADAPTER|\+2 ADAPTER|FRPWR BD|FRPWR BP|FIREPOWER BD|EXT MG PLT|QUICK CHNG ADPTR|QUICK CHNG ADAPTER|TAC\+2/.test(u)) return 'mag-extensions';
    if (/\bMOAB\b/.test(u)) return 'mag-extensions';
    if (/\b(FRPWR BP|FIREPOWER BP|FIREPOWER BD|CARRY BP|BSE PLT|BSE PLATE|BASE PLT)\b/.test(u) ||
        (/\+\d/.test(u) && /\b(BP|BASE PAD|BASE PLATE|BSE PLATE)\b/.test(u))) return 'mag-extensions';
    if (/\bSPEED FEED\b/.test(u)) return 'magwells';
    if (/\bANCHOR\+?MW\b|\bANCHOR MW\b/.test(u)) return 'magwells';
    if (/\bRECOIL KIT\b/.test(u)) return 'recoil';
    if (/\bMAG PCH\b|\bMAG POUCH\b|\bMAGPCH\b|\bMAG CARRIER\b|\bTACO\b|BRASS CATCHER/.test(u)) return 'pouches';
    if (/\b(\d+-IN-1 )?TOOLS?\b/.test(u) && /GLOCK|GLK/.test(u) && !/SIGHT/.test(u)) return 'other';
    if (/\b(MNT KIT|MOUNT KIT)\b/.test(u) && /RMR|SRO|MOS|ACRO/.test(u)) return 'mounts';
    if ((/KYNSHOT/.test(u) || /KYNSHOT/.test(v)) && /GLOCK|GLK/.test(u)) return 'recoil';
    if (/\bTRUCKEE\b/.test(u)) return 'forends';
    if (/^KICK-EEZ\b/.test(u) || /KICK-EEZ/.test(v)) return 'stocks';
    if (/\b(FRNT SLNG MNT|SLNG MNT|SLING MNT|SLING MOUNT)\b/.test(u)) return 'sling-mounts';
    if (isFirearmScopeMount(u)) return 'mounts';
    if (POS_MAG.test(u) && !NEG_MAG.test(u) && !/\bSTOCKS?\b/.test(u) && !/^ARCHANGEL\b/.test(u)) return 'magazines';
    if (/\bMAGWELLS?\b|\bMAG WELL\b|\bMW HOUSING\b|\bMAGWELL HOUSING\b/.test(u)) return 'magwells';
    if (/\bMAG EXT\b|\bMAGEXT\b|\bMAGEX\b|\bBASE PLATE\b|\bBASE PAD\b|\bEXTND BASE\b|\bMAG SPACER\b|\bMAG SLEEVE\b|\bXGRIP\b/.test(u) ||
        (/\+\d/.test(u) && /MAG/.test(u))) return 'mag-extensions';
    if ((/\bBUFFER TUBES?\b|\bBFR TUBE\b|\bBFFR TUBE\b|\bBUFF TB\b|\bBUFF THREAD|\bBUFFR KIT\b|\bRECEIVER EXTS?\b|\bRECEIVER EXTENSION\b|\bRECEIVER EXTENDED\b|\bRCVR EXT\b|\bMIL TUBE ASSEMBLY\b|\b6 POS\b.{0,24}TUBE/.test(u) ||
        (/\bBUFFER KIT\b/.test(u) && !/RETAINER/.test(u))) &&
        !/\b(GAS TUBE|CASTLE NUT|TOOL|WRENCH)\b/.test(u) &&
        !(/\b(STOCKS?|STK|BUTTSTK|BUTTSTOCKS?|BRACE)\b/.test(u) && /INCLUDED|W\/|WITH/.test(u))) {
      return 'buffer-tubes';
    }
    if (/\bBUFFER ASSEMBLY\b/.test(u) && /\bBUFFER TUBE\b/.test(descHead(desc)) &&
        !/\bCASTLE NUT\b/.test(u)) return 'buffer-tubes';
    if (/\bBUFFER FOR\b/.test(u)) return 'recoil';
    if (/\bBUFFERS?\b/.test(u) && !/\bBUFFER TUBE\b/.test(u) && !/\bSTK\b/.test(u) &&
        !/STOCK KIT/.test(u) && !/\bCHASSIS\b/.test(u) && !/\bSTOCKS?\b/.test(u)) return 'recoil';
    var isForend = /\bFORENDS?\b|\bFORND\b|\bFOREARM\b|\bFRND\b/.test(u) ||
      /\bRAIL SYSTEMS?\b|\bRL SYSTM\b|\bINT RL\b/.test(u);
    var isMdtStock = (/^MDT\b/.test(v) || /\bMDT\b/.test(u)) &&
      !/MUZZLE BRAKE|BIPOD|BARRICADE/.test(u) &&
      /\bCHASSIS\b|\bHNT-?26\b|\bLSS\b|\bXRS\b|ACC ELITE|ACC PREM|HUNTER BM|FLDNG ARCA/.test(u);
    if (/\bFIRING PINS?\b|\bFRNG PIN\b|\bSTRIKERS?\b/.test(u) &&
        !/\bSTOCKS?\b|\bSTK\b|\bCHASSIS\b/.test(u)) return 'internals';
    var isStock = (/\bSTOCKS?\b|\bBUTTSTK\b|\bBTSTCK\b|\bBUTTSTOCKS?\b|\bSGA\b|\bSTK\b|TACTLITE|CLLPSBL|BUTT-PAD|BUTTPAD|BUTT PAD|\bMBA-1\b/.test(u) &&
      !/DBL STK|DOUBLE STACK|DBLSTK|DB STK/.test(u) &&
      !/\bFIRING PIN\b|\bSTRIKER\b/.test(u)) ||
      /\bCHASSIS\b/.test(u) ||
      /\bHEATSEEKER\b/.test(u) ||
      (/MAGPUL/.test(u) && /\bPRS\b/.test(u)) ||
      (/MAGPUL/.test(u) && /HUNTER LITE|HUNTR LT|HUNTER LTE|HUNTER 700/.test(u)) ||
      isMdtStock;
    if (isStock) return 'stocks';
    if (/\bHEATSHIELDS?\b|\bHEAT SHIELDS?\b|\bHTSHLD\b|\bHT SHIELD\b/.test(u)) return 'heatshields';
    if (isForend) return 'forends';
    if (/\bHANDGUARDS?\b|\bHNDGRD\b|\bHANDGRD\b|\bHNDGUARD\b|\bHNGRD\b|\bHNDGD\b|\bZHKV\b/.test(u)) return 'handguards';
    if (/\bMLOK RL\b|\bM-LOK RAIL\b|\bMLOK RAIL\b|\bFREE FLT\b|\bFREE FLOAT\b|\bMLOK HG\b|\bSMR\b|\bMCMR RAIL\b|\bQUAD RAIL\b|CARBN RAIL|CARBINE RAIL|RAIL N4|N4 4TH GEN|\bNSR\b.{0,12}RAIL|\bMRF\b.{0,24}RAIL|ENHANCED RAIL \d|DROP IN.{0,16}RAIL/.test(u) &&
        !/\b(MOUNT|ADAPTER|ADPTR)\b/.test(u) && !isRailCover(u)) {
      return 'handguards';
    }
    if (/\bMLOK\b/.test(u) && /308|AR10|AR-10/.test(u) && !/\b(MOUNT|ADAPTER|ADPTR)\b/.test(u)) {
      return 'handguards';
    }
    if (/M-LOK TO MOE ADAPTER/.test(u)) return 'handguards';
    if (/\bCHARGING HANDLES?\b|\bCHARGE[- ]HANDLES?\b|\bCHARGING HNDLS?\b|\bCHRGNG\s+HNDLS?\b|\bCHRG\s+HNDLS?\b|\bCHRG HANDLE\b|\bCHARG HANDLE\b|\bCHARG HNDL\b|\bC HNDL\b|CHARGE-HANDLE|SLDGHMR|WRHMR|SLEDGEHAMMER|WARHAMMER|\bRAPTOR\b/.test(u)) {
      return 'charging-handles';
    }
    if ((/\bBCGS?\b|\bBOLT CARRIERS?\b|\bBOLT CARRIER GROUPS?\b|\bBLT CARRIER\b/.test(u)) &&
        !/\bBOLT CATCH\b/.test(u)) return 'bcg';
    if ((/\bLPK\b|\bLOWER PARTS KITS?\b|\bLWR PARTS KITS?\b|\bLOWER RECEIVER PARTS\b/.test(u)) &&
        !/\bUPPER PARTS\b/.test(u)) return 'triggers';
    if (/\bMAINSPRING HOUSING\b|\bEXTRACTOR\b|\bGRIP SFTY\b|\bGRIP SAFETY\b|\bTHUMB SAFETY\b|\bTHUMB SFTY\b|\bHAMMERS?\b|\bSEAR\b/.test(u)) return 'internals';
    if (/\bBEAVERTAIL\b|\bBVR TAIL\b|\bBVRTL\b/.test(u) && !/HANDALL/.test(u)) return 'safeties';
    if (/\bGRIP SCREWS?\b/.test(u) || (/\bHEX HEAD\b/.test(u) && /\b(SCREWS?|SET)\b/.test(u)) || /TORX SCREW SET/.test(u)) return 'internals';
    if (/\bLASERGRIPS?\b|\bLASER[- ]?GRIPS?\b|\bLSR GRIPS?\b/.test(u) ||
        /\bGRIPS?\b|\bGRP\b|\bPSTL GRP\b|HANDALL|BACKSTRAP|HNDALL|MONOGRIP|SUREGRIP|\bKAG\b|\bRVG\b|\bMVG\b|WRAP GRT|FRAME INSERT|FRME INSRT|FRAME INSRT|SHARPS GEN3|STOR CORE|LUBE BOTTLE CORE|CARGO KIT/.test(u) ||
        (/^HOGUE\b/.test(u) && /\bHA[B ]|\bHAB\b|\bHA BV\b|\bHA BS\b/.test(u)) ||
        ((/PACHMAYR|\bPKMYR\b/.test(u) || /PACHMAYR|\bPKMYR\b/.test(v)) &&
          !/HOLSTER|RECOIL PAD|SPEEDLOAD/.test(u))) return 'grips';
    if (
      /\bHOLSTERS?\b|\bHLSTR\b|\bHLSTER\b|\bIWB\b|\bOWB\b|\bAIWB\b|\bSERPA\b|\bMINI WING\b|\bT-SERIES\b|\bINCOG\b|\bLIB MK\b|7378RDS|DISRUPTOR/.test(u) ||
      holsterBrand.test(v) || holsterBrand.test(u) || /TAGUA/.test(v)
    ) return 'holsters';
    if (/\bMAG PCH\b|\bMAG POUCH\b|\bMAGPCH\b/.test(u)) return 'pouches';
    if (!/SL-SIDESADDLE|HARD HAT/.test(u) && !/\bSDL MNT\b/.test(u) &&
        /\bSIDE SADDLES?\b|\bSIDESADDLE\b|\bSDE SDDLE\b|\bSIDE SDL\b|\bSADDLERAIL\b|\bSURESHELLS?\b|\bSURESHL\b|\bSURSHL\b|\bSRSHL\b|\bSHELL HLDR\b|\bSHL CARRIER\b|\bSHELL CARRIER\b/.test(u)) {
      return 'side-saddles';
    }
    if (/\bWML\b|\bTLR-|\bTLR\d|\bTLR\b|\bXSC\b|WEAPONLIGHT|WEAPON LIGHT|\bLIGHTGUARD\b|\bLASERGUARD\b|\bLASERS?\b|\bLASR\b|\bLSR\b|\bFLASHLIGHT\b|\bFLSHLGHT\b|\bTAC LIGHT\b|\bWMLX\b|LIGHT\/LSR|LGHT\/LSR|LASERMAX|\bFENIX GL|\bCTL FITS|NIGHTSTICK|ACCU-GUARD/.test(u) ||
        (/^VIRIDIAN\b/.test(u) && /\bE SERIES\b|\bCTL\b|\bLIGHT\b/.test(u) && !/HOLSTER|BATTERY/.test(u)) ||
        (/\d+LUM/.test(u) && /GLOCK|GLK|PSTL|PISTOL|P365/.test(u))) {
      if (/HOLSTER|HLSTR|BULLDOG EXTREME|VARMINT WRANGLER|\bPERUN\b|DUST COVER|DST CVR|LASER ENGRAVED|BORE SIGHTER|W\/LASER|\bW LZR\b/.test(u)) {
        /* holster / engraved / sighter — not a light */
      } else {
        return 'lights';
      }
    }
    if (/\bPLATE\b|\bPLT\b|\bADP\b|\bADAPTER\b|\bADPTR\b/.test(u) && /TRIJICON|RMR|HOLO|DOT|SRO|MOS/.test(u)) {
      return 'plates';
    }
    if (/MOS TO |TO RMR|TO SRO|TO HOLO|TO RMS/.test(u)) return 'plates';
    if (/GUARDIAN/.test(u) && /MNT|MOUNT|RMR|EPS|SRO|MOS|407|507/.test(u) && !/SIGHTS/.test(u)) return 'mounts';
    if (/RMR MOUNT|FASTFIRE MNT|PA03 MOUNT|SCOUT MNT|SCOUT MOUNT|SCOUT MOD MOUNT|LIGHT MOUNT|LIGHT MOD MOUNT/.test(u)) return 'mounts';
    if (/\bHK USP\b/.test(u) && /M3\/M6/.test(u) && /\b(MNT|MOUNT)\b/.test(u)) return 'lights';
    if (isRmrFootprintPistolDot(title, vendor)) return 'red-dots';
    if (/\b(SIGHT ADJUST|SIGHT ADJSTR|SIGHT TOOL|PENCIL SIGHT|FROT SIGHT ADJUST)\b/.test(u)) {
      return 'tools';
    }
    if (/\b(ARMORERS? BLOCK|GUNSMITHING TOOL|FIELD REPAIR)\b/.test(u)) return 'tools';
    if (/\bGBLOCK\b/.test(u)) return 'other';
    if (
      !/\bBARRELS?\b|\bBBL\b|\bXBBL\b|\bBRL\b/.test(u) &&
      (/\bSIGHTS?\b|\bSGHTS?\b|\bSGTS?\b|\bSGT\b|\bTRITIUM\b|\bTRIT\b|\bNS FOR\b|\bNIGHT SIGHT\b|\bFASTDOT\b|\bRFX|\bR3D\b|\bTFX\b|CARRY HANDLE/.test(u) ||
      ((/TRUGLO|HIVIZ|AMERIGLO|NIGHT FISION|MEPROLT|MEPROLIGHT|XS SIGHT|\bXS R3D\b|\bSTND DOT\b|\bSTANDARD DOT\b|TRIJICON/.test(u) ||
        /TRUGLO|HIVIZ|AMERIGLO|NIGHT FISION|MEPROLIGHT|TRIJICON|XS SIGHT/.test(v)) &&
        !/\bPLATE\b|\bMOUNT\b|\bADP\b|\bBLOCK\b|\bTOOL\b/.test(u)))
    ) return 'sights';
    if (/\bSLIDES?\b|\bSLD\b/.test(u) &&
        !/SLIDE CATCH|SLD CATCH|SLIDE CAP|SLD RELEASE|SLIDE RELEASE|SLIDE RLS|SLD RLS|SLD IN|SOLD INDV|SLIDE STOP|SLD STOP|SLIDE STP|SLIDE LOCK|SLD LOCK/.test(u)) {
      return 'slides';
    }
    if (/\bBARREL NUT\b|\bBBL NUT\b|\bBRL NUT\b/.test(u)) return 'hardware';
    if ((/\bBARRELS?\b|\bBBL\b|\bXBBL\b|\bBRL\b/.test(u) || (/\bTB\b/.test(u) && /P320|P365|GLOCK|GLK/.test(u))) &&
        !/\b(BUSHING|WRENCH|TAKE-?DOWN|NUT|APOLLO|FLASH|MUZZLE|5\/8X24|RAIL|MNT|MOUNT|CLAMP|SPACER)\b/.test(u)) return 'barrels';
    if (/\bHAMMERS?\b/.test(u) && !/\bTRIGGERS?\b|\bTRIGGER\b/.test(u) && !/WRENCH|PUNCH|TOOL/.test(u)) return 'internals';
    if ((/TIMNEY|APEX|GHOST/.test(u) || /TIMNEY|APEX TACTICAL|GHOST INC/.test(v)) &&
        /GLOCK|GLK/.test(u) &&
        /TGR|TRIGGER|KIT|CNCT|CONNECTOR|SHOE|UBK|ALPHA|AET|AEK|ENH|RANGER|ROCKET|ANGEL|EDGE|UNIT PERF|\bCNC\b|\bDI\b/.test(u) &&
        !/SLDE REL|SLIDE REL/.test(u)) {
      return 'triggers';
    }
    if (/TYRANT/.test(u) && /SHOE|ITTS|I\.T\.T\.S/.test(u)) return 'triggers';
    if ((/TIMNEY|CMC TRIGGERS|^CMC\b|GEISSELE|HIPERFIRE|\bHF EDT\b/.test(u + ' ' + v)) &&
        /AR[- ]?15|AR15|\bSSA\b|SSA-E|STRGHT|MATCH COMBAT|TRI ASSE/.test(u) &&
        !/\bHAMMERS?\b/.test(u)) {
      return 'triggers';
    }
    if ((/^TIMNEY\b/.test(u) || /TIMNEY/.test(v)) && /700|R700/.test(u) &&
        !/BASE|RAIL|STOCK|SCOPE|RING|BIPOD/.test(u)) {
      return 'triggers';
    }
    if (/\bTRIGGERS?\b|\bTRIGGER\b|\bTRIGG\b|\bTRIG\b|\bTRIGR\b|\bTRGGR\b|\bTRGR\b|\bTRG KIT\b|\bTRG\b|TRIGRTECH|TRIGGERTECH|TRIGGER TECH|SING STAGE|HIPERTOUCH|HIPERFIRE|\bSSA-E\b|\bSSA\b/.test(u) &&
        !/\bHAMMERS?\b/.test(u) && !/SPRING ACTION/.test(u)) return 'triggers';
    if (/\bJAM NUT\b/.test(u)) return 'hardware';
    if (/\bBACK PLT\b|\bBACK PLATE\b/.test(u) && /GLOCK|GLK/.test(u) && !/OPTIC|RMR|MOS/.test(u)) {
      return 'internals';
    }
    if ((/^ZEV\b/.test(u) || /ZEV/.test(v)) && /\bFPS\b/.test(u) && !/GUIDE|ROD/.test(u)) return 'internals';
    if ((/^STREAMLIGHT\b/.test(u) || /STREAMLIGHT/.test(v)) && /\bREMOTE\b/.test(u)) return 'lights';
    if (/^GLOCK\b/.test(v) && /\bSCREW\b/.test(u) && !/GRIP SCREW/.test(u)) return 'hardware';
    if (/\bSCOPE SET\b/.test(u)) return 'mounts';
    if (/RINGMOUNT|RING MOUNT|X-LOCK/.test(u) && /X-?BOLT|BROWNING|A-?BOLT/.test(u + ' ' + v)) return 'rings';
    if ((/^WARNE\b/.test(u) || /WARNE/.test(v)) && /\bRAIL\b/.test(u) && !/MAG EXT|MAGAZINE/.test(u)) {
      return 'mounts';
    }
    if (/\bSWIVELS?\b/.test(u) && (/UNCLE MIKE/.test(v) || /7400/.test(u))) return 'sling-mounts';
    if (/\bBOLT HANDLE\b/.test(u) && /NORDIC|BENELLI|REMINGTON|870|1301/.test(u + ' ' + v)) {
      return 'charging-handles';
    }
    if (/\bCHEEK PROTECTOR\b|GEL-TEK CHEEK/.test(u)) return 'stocks';
    if (/\bSADDLE MOUNT\b|\bSDL MNT\b/.test(u) && /509|HE509|1301|A300/.test(u)) return 'mounts';
    if (/\bMOUNTS?\b|\bMNT\b/.test(u) && /1301|A300|HE509/.test(u) && !/FOLLOWER|\bMAG\b/.test(u)) {
      return 'mounts';
    }
    if (/BASE SET|MATTE BASE/.test(u) && /X-?BOLT|BROWNING/.test(u + ' ' + v)) return 'mounts';
    if (/\bCOMPENSATOR\b|\bAFTRBRNR\b|\bAFTRBRBR\b|\bAFTERBURNER\b|\bRAMJET\b|\bRMJT\b|\bMZL BRK\b|\bMUZZLE BRAKE\b|\bEXOS\b|\bCOMP FOR\b|\bFLASH HIDERS?\b|\bFLASH SUPPRESSORS?\b|\bA2 FLASH\b|\bBIRDCAGE\b|\bDYNACOMP\b|\bHIPERCOMP\b|\bSOCOM FH\b|\bPRONG FH\b|\bX-CMP\b/.test(u) ||
        (/\bFH\b/.test(u) && /5\/8X24|7\.62|AR[- ]?10|AR10/.test(u)) ||
        (/\bMB\b/.test(u) && /5\/8X24|7\.62|6\.5\s*CM|PEGASUS|APOLLO|DRAGON|PROCOMP/.test(u) && !/SHIM/.test(u)) ||
        (/\bCOMP\b/.test(u) && /1\/2X28|5\/8X24|GLOCK|GLK|P320|P365|G43/.test(u)) ||
        (/\bCMP\b/.test(u) && /P320|P365|GLOCK|GLK|AGENCY/.test(u)) ||
        (/\bPISTON\b/.test(u) && /1\/2X28|5\/8X24/.test(u) && !/PISTON RING|GAS PISTON/.test(u)) ||
        (/\bBRAKE\b/.test(u) && !/TRIGGER|TRIG/.test(u))) {
      if (!/COMP-TAC|COMPLETION|COMPACT CASE/.test(u)) return 'compensators';
    }
    if (/\bSHOK[- ]?BUFF/.test(u)) return 'recoil';
    if (/\b(SPRG KIT|SPRING KIT)\b/.test(u) && /\b1911\b/.test(u)) return 'recoil';
    if (/\bGUIDE ROD\b|GUIDEROD|\bGUD ROD\b|\bGUD-ROD\b|\bRECOIL SPNG\b|\bRECOIL SPRNG\b|\bRECOIL SPRING\b|\bQUICKTUNE\b|\bQUICK TUNE\b|\bQWKTN\b/.test(u)) return 'recoil';
    if (/\b(MAG|SLIDE|SLD|SLDE|BOLT)\s*(RLS|REL|RELEASE|CATCH|CTCH|STP|STOP)\b/.test(u) && !/\bTOOL\b/.test(u)) return 'releases';
    if (/OPTICS MOUNT|OPTIC MOUNT|SCOPE MOUNT|SCOPE RAIL|SCOPE BASE|BASE SYS/.test(u) &&
        !/\bSTOCKS?\b|\bSTK\b|\bCHASSIS\b/.test(u)) return 'mounts';
    if (/MAGPUL/.test(u) && /X-?22|HTR X22|BCKPCKR|\bBPKR\b/.test(u) && /\bHG\b/.test(u)) {
      return 'handguards';
    }
    if (/\bBOLT\b/.test(u) && /10\/22|10-22|TP\/22/.test(u) && !/BOLT CATCH|BOLT CARRIER/.test(u)) {
      return 'bolts';
    }
    if (/SWIVEL SET|LCK SWIVEL|QD SWIVEL/.test(u)) return 'sling-mounts';
    return partTypeFromDesc(desc) || 'other';
  }

  var KNIFE_BRANDS = [
    { id: 'spyderco', label: 'Spyderco' },
    { id: 'kershaw', label: 'Kershaw' },
    { id: 'cold-steel', label: 'Cold Steel' },
    { id: 'outdoor-edge', label: 'Outdoor Edge' },
    { id: 'sog', label: 'SOG' },
    { id: 'ka-bar', label: 'KA-BAR' },
    { id: 'stroup', label: 'Stroup' },
    { id: 'camillus', label: 'Camillus' },
    { id: 'hogue', label: 'Hogue' },
    { id: 'magpul', label: 'Magpul' },
    { id: 'real-avid', label: 'Real Avid' },
    { id: 'sharpeners', label: 'Sharpeners' }
  ];
  var SPYDERCO_SERIES = [
    { id: 'para', label: 'Para Military / Para 3', re: /PARA MIL|PARA MLTRY|PARA MITRY|PARA MILITARY|PARA 3|\bPARA3\b|\bPM2\b/ },
    { id: 'native', label: 'Native', re: /NATIVE/ },
    { id: 'manix', label: 'Manix', re: /MANIX/ },
    { id: 'tenacious', label: 'Tenacious', re: /TENACIOUS/ },
    { id: 'sage', label: 'Sage', re: /SAGE/ },
    { id: 'bodacious', label: 'Bodacious', re: /BODACIOUS/ },
    { id: 'delica', label: 'Delica', re: /DELICA|ENDELA/ },
    { id: 'byrd', label: 'Byrd', re: /BYRD/ },
    { id: 'endura', label: 'Endura', re: /ENDURA/ },
    { id: 'military', label: 'Military', re: /MILITARY|\bMIL 2\b/ },
    { id: 'bug', label: 'Bug / Ladybug', re: /\bBUG\b|HONEYBEE|GRASSHOPPER|LADYBUG|MANBUG/ }
  ];
  var KNIFE_L2 = {
    'cold-steel': [
      { id: 'knives', label: 'Knives' },
      { id: 'tools', label: 'Machetes & tools' }
    ],
    sog: [
      { id: 'knives', label: 'Knives' },
      { id: 'tools', label: 'Multi-tools' }
    ],
    'outdoor-edge': [
      { id: 'knives', label: 'Knives' },
      { id: 'blades', label: 'Replacement blades' },
      { id: 'sharpeners', label: 'Sharpeners' }
    ],
    sharpeners: [
      { id: 'sharpeners', label: 'Sharpeners' },
      { id: 'knives', label: 'Processing knives' }
    ]
  };

  var GEAR_CATS = [
    {
      id: 'optics',
      label: 'Optics & mounts',
      skipOnGear: 1,
      l2: [
        { id: 'scopes', label: 'Scopes', brandFilter: 1 },
        { id: 'spotting', label: 'Spotting scopes', brandFilter: 1 },
        { id: 'binoculars', label: 'Binoculars', brandFilter: 1 },
        { id: 'red-dots', label: 'Red dots & reflex', brandFilter: 1, coreBrands: { burris: 1, eotech: 1, trijicon: 1, holosun: 1, aimpoint: 1, leupold: 1, shield: 1 } },
        { id: 'rangefinders', label: 'Rangefinders', brandFilter: 1 },
        { id: 'thermal', label: 'Thermal & IR', brandFilter: 1 },
        { id: 'magnifiers', label: 'Magnifiers', brandFilter: 1, coreBrands: { eotech: 1, aimpoint: 1, holosun: 1 } },
        { id: 'weapon-lights', label: 'Weapon lights', brandFilter: 1, coreBrands: { streamlight: 1, surefire: 1, 'crimson-trace': 1 } },
        { id: 'lasers', label: 'Lasers', brandFilter: 1 },
        { id: 'bore-sighters', label: 'Bore sighters', brandFilter: 1 },
        { id: 'rings', label: 'Rings', brandFilter: 1 },
        { id: 'mounts', label: 'Mounts', brandFilter: 1 },
        { id: 'plates', label: 'Plates', brandFilter: 1 },
        { id: 'accessories', label: 'Accessories' },
        { id: 'other', label: 'Other optics' }
      ]
    },
    {
      id: 'storage',
      label: 'Cases, bags & safes',
      l2: [
        { id: 'cases', label: 'Soft cases', brandFilter: 1 },
        { id: 'hard-cases', label: 'Hard cases', brandFilter: 1 },
        { id: 'bags', label: 'Bags & packs', brandFilter: 1 },
        { id: 'safes', label: 'Safes & vaults' },
        { id: 'ammo-boxes', label: 'Ammo boxes' },
        { id: 'other', label: 'Other storage', brandFilter: 1 }
      ]
    },
    {
      id: 'cleaning',
      label: 'Cleaning & gun care',
      l2: [
        { id: 'kits', label: 'Kits', brandFilter: 1 },
        { id: 'chemicals', label: 'Solvents & oils', brandFilter: 1 },
        { id: 'rods-brushes', label: 'Rods, brushes, patches', brandFilter: 1 },
        { id: 'gloves', label: 'Gloves' },
        { id: 'other', label: 'Tools & other', brandFilter: 1 }
      ]
    },
    {
      id: 'lights',
      label: 'Lights',
      skipL2: 1,
      brandFilter: 1
    },
    {
      id: 'hearing',
      label: 'Ear protection',
      l2: [
        { id: 'over-ear-elec', label: 'Electronic muffs' },
        { id: 'over-ear-passive', label: 'Passive muffs' },
        { id: 'in-ear', label: 'In ear' }
      ]
    },
    {
      id: 'eyes',
      label: 'Eye protection',
      skipL2: 1,
      brandFilter: 1
    },
    { id: 'slings', label: 'Slings', skipL2: 1, brandFilter: 1 },
    {
      id: 'range',
      label: 'Range gear',
      l2: [
        { id: 'targets', label: 'Targets', brandFilter: 1 },
        { id: 'spotting', label: 'Spotting scopes' },
        { id: 'binoculars', label: 'Binoculars' },
        { id: 'other', label: 'Other range gear' }
      ]
    },
    {
      id: 'reloading',
      label: 'Reloading',
      l2: [
        { id: 'dies', label: 'Dies', brandFilter: 1 },
        { id: 'presses', label: 'Presses & kits', brandFilter: 1 },
        { id: 'bullets', label: 'Bullets', brandFilter: 1 },
        { id: 'tools', label: 'Tools & other', brandFilter: 1 }
      ]
    },
    {
      id: 'med',
      label: 'First aid',
      l2: [
        { id: 'kits', label: 'Kits' },
        { id: 'tourniquets', label: 'Tourniquets' },
        { id: 'pouches', label: 'Med pouches' },
        { id: 'supplies', label: 'Dressings & supplies' }
      ]
    },
    {
      id: 'defense',
      label: 'Personal defense',
      l2: [
        { id: 'spray', label: 'Pepper spray' },
        { id: 'stun', label: 'Stun guns' },
        { id: 'other', label: 'Other defense' }
      ]
    },
    { id: 'bipods', label: 'Bipods', skipL2: 1, brandFilter: 1 },
    { id: 'gloves', label: 'Gloves', skipL2: 1, brandFilter: 1 },
    { id: 'loaders', label: 'Mag loaders', skipL2: 1, brandFilter: 1 },
    { id: 'carriers', label: 'Carriers & pouches', skipL2: 1, brandFilter: 1 },
    { id: 'batteries', label: 'Batteries', skipL2: 1, brandFilter: 1 },
    { id: 'locks', label: 'Locks', skipL2: 1, brandFilter: 1 },
    {
      id: 'other',
      label: 'Everything else',
      l2: [
        { id: 'other', label: 'Other gear' }
      ]
    }
  ];

  var OPTIC_BRANDS = [
    { id: 'leupold', re: /LEUPOLD/, label: 'Leupold' },
    { id: 'trijicon', re: /TRIJICON|^TRIJ$/, label: 'Trijicon' },
    { id: 'burris', re: /BURRIS/, label: 'Burris' },
    { id: 'riton', re: /RITON/, label: 'Riton' },
    { id: 'eotech', re: /EOTECH/, label: 'EOTech' },
    { id: 'holosun', re: /HOLOSUN/, label: 'Holosun' },
    { id: 'aimpoint', re: /AIMPOINT/, label: 'Aimpoint' },
    { id: 'vortex', re: /VORTEX/, label: 'Vortex' },
    { id: 'weaver', re: /WEAVER/, label: 'Weaver' },
    { id: 'warne', re: /WARNE/, label: 'Warne' },
    { id: 'talley', re: /TALLEY/, label: 'Talley' },
    { id: 'ch-precision', re: /C&H PRECISION/, label: 'C&H Precision' },
    { id: 'ncstar', re: /NCSTAR|NC STAR/, label: 'NcSTAR' },
    { id: 'truglo', re: /TRUGLO/, label: 'TRUGLO' },
    { id: 'sig', re: /SIG SAUER/, label: 'Sig Sauer' },
    { id: 'utg', re: /LEAPERS|\bUTG\b/, label: 'UTG' },
    { id: 'agm', re: /AGM GLOBAL|\bAGM\b/, label: 'AGM' },
    { id: 'rix', re: /\bRIX\b/, label: 'RIX' },
    { id: 'unity', re: /UNITY TACTICAL/, label: 'Unity Tactical' },
    { id: 'crimson-trace', re: /CRIMSON TRACE/, label: 'Crimson Trace' },
    { id: 'night-fision', re: /NIGHT FISION/, label: 'Night Fision' },
    { id: 'adm', re: /AMERICAN DEFENSE/, label: 'American Defense' },
    { id: 'reptilia', re: /REPTILIA/, label: 'Reptilia' },
    { id: 'midwest', re: /MIDWEST INDUSTRIES/, label: 'Midwest Industries' },
    { id: 'meprolight', re: /MEPROLIGHT|MEPROLT/, label: 'Meprolight' },
    { id: 'bushnell', re: /BUSHNELL/, label: 'Bushnell' },
    { id: 'shield', re: /SHIELD SIGHTS/, label: 'Shield' },
    { id: 'primary-arms', re: /PRIMARY ARMS/, label: 'Primary Arms' },
    { id: 'swampfox', re: /SWAMPFOX/, label: 'Swampfox' },
    { id: 'nightforce', re: /NIGHTFORCE/, label: 'Nightforce' },
    { id: 'steiner', re: /STEINER/, label: 'Steiner' },
    { id: 'bsa', re: /BSA OPTICS|\bBSA\b/, label: 'BSA' },
    { id: 'gbrs', re: /GBRS/, label: 'GBRS Group' },
    { id: 'halo', re: /HALO OPTICS/, label: 'Halo' },
    { id: 'sightmark', re: /SIGHTMARK/, label: 'Sightmark' },
    { id: 'streamlight', re: /STREAMLIGHT/, label: 'Streamlight' },
    { id: 'surefire', re: /SUREFIRE/, label: 'Surefire' },
    { id: 'calculated-kinetics', re: /CALCULATED KINETICS/, label: 'Calculated Kinetics' },
    { id: 'arisaka', re: /ARISAKA/, label: 'Arisaka' },
    { id: 'athlon', re: /ATHLON/, label: 'Athlon' }
  ];

  // Same company, different Spark vendor strings. Canonical id/label is the
  // name with more catalog hits (Magpul Industries 708 vs MAGPUL 6).
  var VENDOR_ALIASES = [
    { id: 'magpul', re: /MAGPUL/, label: 'Magpul Industries' },
    { id: 'aero-precision', re: /^AERO\b/, label: 'Aero Precision' },
    { id: 'bravo-company', re: /^BRAVO\b/, label: 'Bravo Company' },
    { id: 'fortis-manufacturing-inc', re: /^FORTIS\b/, label: 'Fortis Manufacturing' },
    { id: 'lantac-usa-llc', re: /^LANTAC\b/, label: 'LanTac USA' },
    { id: 'gamo-usa', re: /^GAMO\b/, label: 'Gamo' },
    { id: 'samson-manufacturing-corp', re: /^SAMSON\b/, label: 'Samson Manufacturing' },
    { id: 'atn-corp', re: /^ATN\b/, label: 'ATN' },
    { id: 'troy-industries', re: /^TROY\b/, label: 'TROY Industries' },
    { id: 'rosco-manufacturing', re: /^ROSCO\b/, label: 'Rosco Manufacturing' }
  ];
  var MAKER_ALIASES = {
    aero: 'aero-precision',
    'magpul-industries': 'magpul',
    bravo: 'bravo-company',
    fortis: 'fortis-manufacturing-inc',
    lantac: 'lantac-usa-llc',
    gamo: 'gamo-usa',
    samson: 'samson-manufacturing-corp',
    atn: 'atn-corp',
    troy: 'troy-industries',
    rosco: 'rosco-manufacturing',
    trij: 'trijicon'
  };

  function vendorBrandKey(vendor) {
    var v = (vendor || '').toUpperCase();
    var i;
    for (i = 0; i < OPTIC_BRANDS.length; i++) {
      if (OPTIC_BRANDS[i].re.test(v)) return OPTIC_BRANDS[i].id;
    }
    for (i = 0; i < VENDOR_ALIASES.length; i++) {
      if (VENDOR_ALIASES[i].re.test(v)) return VENDOR_ALIASES[i].id;
    }
    var slug = String(vendor || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return slug || 'other';
  }

  function normalizeMaker(id) {
    if (!id) return null;
    var key = String(id).toLowerCase();
    if (MAKER_ALIASES[key]) return MAKER_ALIASES[key];
    if (VENDOR_ALIASES) {
      var i;
      for (i = 0; i < VENDOR_ALIASES.length; i++) {
        if (VENDOR_ALIASES[i].re.test(String(id).toUpperCase())) return VENDOR_ALIASES[i].id;
      }
    }
    return vendorBrandKey(id);
  }

  var OPTIC_SERIES = {
    trijicon: [
      { id: 'acog', label: 'ACOG', re: /ACOG/ },
      { id: 'accupoint', label: 'AccuPoint', re: /ACCUPOINT|ACCUPNT/ },
      { id: 'credo', label: 'Credo', re: /CREDO/ },
      { id: 'tenmile', label: 'Tenmile', re: /TENMILE/ },
      { id: 'vcog', label: 'VCOG', re: /VCOG/ }
    ],
    leupold: [
      { id: 'mark5', label: 'Mark 5', re: /MARK 5|MK 5|MARK5/ },
      { id: 'mark4', label: 'Mark 4', re: /MARK 4|MK 4|MRK 4/ },
      { id: 'mark3', label: 'Mark 3HD', re: /MARK 3|MRK 3/ },
      { id: 'freedom', label: 'VX-Freedom', re: /VX-FREEDOM|FREEDOM/ },
      { id: 'vx6', label: 'VX-6', re: /VX-?6/ },
      { id: 'vx5', label: 'VX-5', re: /VX-?5/ },
      { id: 'vx4', label: 'VX-4HD', re: /VX-?4/ },
      { id: 'vx3', label: 'VX-3', re: /VX-?3/ }
    ]
  };

  function opticSeriesOf(u, brand) {
    var rows = OPTIC_SERIES[brand] || [];
    var i;
    for (i = 0; i < rows.length; i++) {
      if (rows[i].re.test(u)) return rows[i].id;
    }
    return rows.length ? 'other' : '';
  }

  function opticSeriesLabel(brand, id) {
    if (id === 'all') return 'All series';
    var rows = OPTIC_SERIES[brand] || [];
    var i;
    for (i = 0; i < rows.length; i++) {
      if (rows[i].id === id) return rows[i].label;
    }
    return 'Other';
  }

  function opticBrandLabel(id, vendor) {
    if (id === 'all') return 'All brands';
    var i;
    for (i = 0; i < OPTIC_BRANDS.length; i++) {
      if (OPTIC_BRANDS[i].id === id) return OPTIC_BRANDS[i].label;
    }
    for (i = 0; i < VENDOR_ALIASES.length; i++) {
      if (VENDOR_ALIASES[i].id === id) return VENDOR_ALIASES[i].label;
    }
    return vendor || id;
  }

  function wantsBrand(cat, typeId) {
    if (!cat) return false;
    if (cat.brandFilter) return true;
    return typeWantsBrand(cat, typeId);
  }

  function typeWantsBrand(cat, typeId) {
    if (!cat || !cat.l2 || !typeId) return false;
    var t = cat.l2.filter(function (x) { return x.id === typeId; })[0];
    return !!(t && t.brandFilter);
  }

  var GUN_PISTOL = /GLOCK|\bGLK\b|\bP320|\bP365|\bP226|\bP229|\bP220|\bP938|\bM&P\b|HELLCAT|\bXDS\b|\bXDM\b|TAURUS|\bGX4\b|\bG2C\b|\bG3C\b|\bG3X\b|\b1911\b|BERETTA|\bVP9\b|\bUSP\b|\bHK45\b|BODYGUARD|\bSHIELD\b|\bLCP\b|\bPX4\b|\bAPX\b/;
  var GUN_ANY = /GLOCK|\bGLK\b|\bSIG\b|SAUER|\bP320|\bP365|SMITH\s*&\s*WESSON|\bS&W\b|\bM&P\b|MOSSBERG|\bMSBRG\b|\bMOSS\b|REMINGTON|\bRUGER\b|SPRINGFIELD|HELLCAT|BERETTA|\bCOLT\b|\bHK\b|HECKLER|\b1911\b|\bAR[- ]?15\b|\bAR15\b|\bAR[- ]?10\b|\bAR10\b|TAURUS|\bGX4\b|\bG2C\b|\bG3C\b|WALTHER|KIMBER|CANIK|CMMG|BENELLI|BERSA|BROWNING|X-?BOLT|BUCKMARK|KEL[- ]?TEC|\bIWI\b|MASADA|KAHR|HENRY|\bFN 509\b|\bFNX\b|TIKKA|MARLIN|\bMRLN\b|\bMRLIN\b|SAVAGE/;
  var GUN_PART = /BUFFER|GAS TUBE|GAS BLOCK|MUZZLE BRAKE|FLASH HIDER|BIRDCAGE|EJECTION PORT|HANDGUARD|HNDGRD|HNGRD|FOREGRIP|FOREND|BARREL NUT|MAG RELEASE|MBUS|BOLT CARRIER|\bBCG\b|CHARGING HANDLE|LOWER PARTS|CASTLE NUT|END PLATE|TAKEDOWN PIN|PISTOL GRIP|CARBINE STK|MIL-SPEC STK|\bSTK\b|BUTTSTOCK|COMPENSATOR|AFTRBRNR|AFTERBURNER|RAMJET|\bBRAKE\b|THREAD ADAPTER|\bBBL\b|TRIGGER|\bTRIG\b|\bSLIDE\b|BACKSTRAP|NIGHT SIGHT|\bSIGHTS?\b|\bSGHT\b|TRITIUM|TRUGLO|AMERIGLO|HIVIZ|MEPROLIGHT|SUPPRESSOR|SILENCER/;
  var GUN_VENDORS = /LUTH-?AR|LBE UNLIMITED|YANKEE HILL|AERO PRECISION|BRAVO COMPANY|RADIAN WEAPONS|STRIKE INDUSTRIES|KAK INDUSTRY|ODIN WORKS|DEAD AIR|FORTIS|CMMG|GEISSELE|B5 SYSTEMS|BATTLE ARMS|TRUE PRECISION|ARMASPEC|LANTAC|TYRANT CNC|BADGER ORDNANCE/;
  var HOLSTER_RE = /\bHOLSTERS?\b|\bHLSTR\b|\bHLSTER\b|\bIWB\b|\bOWB\b|\bAIWB\b|\bSERPA\b|\bSOLIS\b|INCOGX|INCOG-X|\bRDSO\b|6360RDS|6354RDS|6378RDS|6390RDS|7378RDS|BULLDOG EXTREME|VARMINT WRANGLER|\bPERUN\b|VANGUARD 2|^STICKY (MD|LG|SM|OR)-/;
  var KNIFE_VENDOR_RE = /SPYDERCO|KERSHAW|COLD STEEL|KA-?BAR|OUTDOOR EDGE|SOG KNIVES|^SOG |CAMILLUS|ACCUSHARP|STROUP KNIVES/;
  var KNIFE_TITLE_RE = /\bKNIFE\b|\bKNIVES\b|\bFOLDER\b|\bFLDNG\b|\bFIXED BLADE\b|\bKARAMBIT\b|\bMACHETE\b|\bSHARPENER\b|\bKBAR\b|\bCOLD STL\b|\bOD EDGE\b|\bSPYDERCO\b|\bKERSHAW\b|BUTCHER SET|\bSCALPEL\b|\bTOMAHAWK\b/;
  var KNIFE_NOT_STOCK = /SIDE FOLDER|FOLDING STOCK|FLDNG STK|T-FLDNG|BEAM SIDE FOLDER/;
  var KA_BAR_GADGET = /CHOPSTICK|KA-PAR|WHISTLE|SLING ?SHOT|KA-BARLEY|KRUNCH|BACKPACK KASTER|DIVOT/;
  var HOGUE_KNIFE = /DEKA|\bK320\b|EXF01|EXTRAK|EXPEL|\bX5\b/;
  var OPTIC_VENDOR_RE = /TRIJICON|^TRIJ$|LEUPOLD|BURRIS|WARNE|WEAVER|EOTECH|RITON|TALLEY|HOLOSUN|AIMPOINT|VORTEX|PRIMARY ARMS|C&H PRECISION|SWAMPFOX|SIGHTRON|NIGHTFORCE|BUSHNELL|SHIELD SIGHTS|BSA OPTICS|^BSA$|STEINER|MEPROLIGHT|MEPROLT|HALO OPTICS|SIGHTMARK|KONUS|FIREFIELD/;
  var OPTIC_FALSE_RING_RE = /MOA RING|RED RING|GREEN RING|GRN RING|WHT RING|WHITE RING|O-RING|O['’]RING|DELTA RING|SLIP RING|GAS RING|GHOST RING|GHST RNG|KEY RING|\bD RING\b|DBL RING|DOUBLE RING|DETENT RING|X-?RING TRIGGER/;
  var STORE_VENDOR_RE = /ALLEN COMPANY|BULLDOG CASES|PLANO|SKB SPORTS|US PEACEKEEPER|EVOLUTION OUTDOOR|GREY GHOST GEAR|MTM CASE-?GARD|^MTM$/;
  var CLEAN_VENDOR_RE = /REAL AVID|OTIS|OUTERS|HOPPE|WHEELER|KLEEN-BORE|BREAKTHROUGH CLEAN|PRO-SHOT|BORESNAKE|SHOOTER.?S CHOICE|DEWEY RODS|^DEWEY$/;
  var LIGHT_VENDOR_RE = /^STREAMLIGHT$|^SUREFIRE$|^FENIX$|^OLIGHT$|^NIGHTSTICK$|^INFORCE$|CRIMSON TRACE/;
  var PROT_VENDOR_RE = /WALKER|HOWARD LEIGHT|3M\/PELTOR|^RADIANS$/;
  var RANGE_VENDOR_RE = /ACTION TARGET/;
  var MAG_ACC = /\bMAG EXT\b|\bMAGEX\b|\bMAGWELL\b|MAG RELEASE|MAG PLATE|MAGPLATE/;

  function knifeBrandLabel(id) {
    if (id === 'all') return 'All knives';
    var b = KNIFE_BRANDS.filter(function (x) { return x.id === id; })[0];
    return b ? b.label : id;
  }

  function knifeSeriesLabel(brand, id) {
    if (id === 'all') return 'All ' + knifeBrandLabel(brand);
    if (brand === 'spyderco') {
      var s = SPYDERCO_SERIES.filter(function (x) { return x.id === id; })[0];
      return s ? s.label : id;
    }
    var rows = KNIFE_L2[brand] || [];
    var r = rows.filter(function (x) { return x.id === id; })[0];
    return r ? r.label : id;
  }

  function gearCatLabel(id) {
    var c = GEAR_CATS.filter(function (x) { return x.id === id; })[0];
    return c ? c.label : id;
  }

  function gearTypeLabel(cat, id) {
    var c = (GEAR_CATS || []).filter(function (x) { return x.id === cat; })[0];
    if (!c || !c.l2) return id;
    var t = c.l2.filter(function (x) { return x.id === id; })[0];
    return t ? t.label : id;
  }

  function spydercoSeriesOf(u) {
    var i;
    for (i = 0; i < SPYDERCO_SERIES.length; i++) {
      if (SPYDERCO_SERIES[i].re.test(u)) return SPYDERCO_SERIES[i].id;
    }
    return '';
  }

  function isKnifeHit(title, vendor) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var blob = u + ' ' + v;
    if (KNIFE_NOT_STOCK.test(u)) return false;
    if (/KNIFE\/WATCH|KNIFE WATCH|WOOD KNIVES PUZ/.test(u)) return false;
    if ((/KA-?BAR|\bKBAR\b/.test(blob)) && KA_BAR_GADGET.test(u) && !/\bKNIFE\b/.test(u)) return false;
    if (/TRAUMA/.test(u) && /HOGUE/.test(blob) && /TOOL/.test(u)) return false;
    if ((/^HOGUE\b/.test(u) || /HOGUE/.test(v)) && HOGUE_KNIFE.test(u)) return true;
    if (/BORN READY/.test(u) && /AVID/.test(blob)) return true;
    if (/BRESLAU KNIFE/.test(u)) return true;
    if (/STROUP/.test(blob)) return true;
    return KNIFE_VENDOR_RE.test(v) || KNIFE_VENDOR_RE.test(u) || KNIFE_TITLE_RE.test(u);
  }

  function knifeClassify(title, vendor) {
    if (!isKnifeHit(title, vendor)) return null;
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    var blob = u + ' ' + v;
    var brand = 'other';
    if (/SPYDERCO/.test(blob)) brand = 'spyderco';
    else if (/KERSHAW/.test(blob)) brand = 'kershaw';
    else if (/COLD STEEL|COLD STL/.test(blob)) brand = 'cold-steel';
    else if (/OUTDOOR EDGE|OD EDGE/.test(blob)) brand = 'outdoor-edge';
    else if (/SOG KNIVES|^SOG |\bSOG\b/.test(blob)) brand = 'sog';
    else if (/KA-?BAR|\bKBAR\b/.test(blob)) brand = 'ka-bar';
    else if (/STROUP/.test(blob)) brand = 'stroup';
    else if (/CAMILLUS/.test(blob)) brand = 'camillus';
    else if (/HOGUE/.test(blob) && HOGUE_KNIFE.test(u)) brand = 'hogue';
    else if (/BRESLAU/.test(u) && /MAGPUL/.test(blob)) brand = 'magpul';
    else if (/BORN READY/.test(u) && /AVID/.test(blob)) brand = 'real-avid';
    else if (/ACCUSHARP|SHARPENER|SHARPENING/.test(blob)) brand = 'sharpeners';
    var series = '';
    if (brand === 'spyderco') series = spydercoSeriesOf(u);
    else if (brand === 'cold-steel') series = /MACHETE|TOMAHAWK|AXE|HATCHET|SHOVEL|KUKRI|SWORD/.test(u) ? 'tools' : 'knives';
    else if (brand === 'sog') series = /POWER|MULTI|PLIER/.test(u) ? 'tools' : 'knives';
    else if (brand === 'outdoor-edge') {
      if (/SHARPENER|SHRPNR/.test(u)) series = 'sharpeners';
      else if (/BLDS|BLADE SET|BLADE PACK|\d+\s*PK|REPLACEMENT BLADE/.test(u)) series = 'blades';
      else series = 'knives';
    } else if (brand === 'sharpeners') {
      series = (/\bKNIFE\b/.test(u) && !/SHARPENER|SHRPNR/.test(u)) ? 'knives' : 'sharpeners';
    } else if (brand === 'camillus') {
      series = /AXE|SAW|MACHETE/.test(u) ? 'tools' : 'knives';
    }
    return { brand: brand, series: series };
  }

  function opticMountKindOf(u) {
    var plate = /\bPLT\b|\bPLATES?\b/.test(u);
    var falseRing = OPTIC_FALSE_RING_RE.test(u);
    var ring = !falseRing && (
      /\bRINGS?\b|\bRNGS\b|\bRNG\b|RING SET|SCOPE RING/.test(u) ||
      (/MAXIMA/.test(u) && !/\bBSE\b|\bBASE\b|\bRAIL\b/.test(u))
    );
    var mountCue = /\bMOUNT\b|\bMNT\b|CANTILEVER|CNTLVR|\bPEPR\b|\bRISER\b|SCOPE RAIL|\bRAIL\b|Q-LOC|\bQLOC\b|\bBASES?\b|\bBSE\b|20\s*MOA|30\s*MOA|SKELETON|\bADP\b|\bADAPTER\b|\bADPTR\b/.test(u);
    if (/PEPR SPRY|PEPPER/.test(u)) return '';
    if (/ACOG/.test(u) && falseRing && !plate && !/\bMNT\b|\bMOUNT\b/.test(u)) return '';
    if (falseRing && !plate && !mountCue) return '';
    if (plate) return 'plates';
    if (ring) return 'rings';
    return 'mounts';
  }

  function opticTypeOf(u, v) {
    v = v || '';
    if (/FLIP CAP|FLIP LENS|LENS COVER|BUTLER CREEK|SCOPE COV|SCOPECOAT|SCOPE COAT|SCOPECAP|HEXCAP|KILLFLASH|KILL FLASH|HONEYCOMB|LENS PEN|LENS CLOTH|ALUMINA|ARMOURED HOOD|ARMORED HOOD|SPARE COVER|COVER CLEAR LENS|BATTERY CAP TOOL|R CAP FOR MNT|\bCAP FOR MNT\b|ADJ CAP|\bCAPS\b/.test(u)) {
      return 'accessories';
    }
    if (/UNITY FAST FTC/.test(u)) {
      if (/\b[3-6]X\b/.test(u) && !/30MM|HOLOSUN|\bPA MAGNIFIER/.test(u)) return 'magnifiers';
      return 'accessories';
    }
    if (/RED DOT/.test(u) && /\bRISER\b/.test(u)) return 'mounts';
    if (/RED DOT/.test(u) && /\b(ADAPT|ADAPTER|ADPTR)\b/.test(u) &&
        !/W\/DT|W\/ ?MNT|W\/ ?MOUNT|WITH MOUNT/.test(u)) {
      return 'plates';
    }
    if (/LEVEL RITE|SCOPE ALGN|SCOPE ALIGN|SCOPE LEVEL/.test(u)) return '';
    if (/SCOPE STAND|KIKSTAND/.test(u)) return '';
    if (/GAS RING|LOCK RING|CASTLE NUT|PISTON RING|DELTA RING|SLIP RING/.test(u)) return '';
    if (/CHEEK RISER|CHK RISER|CHK RISR|COMB RISER/.test(u)) return '';
    if (/PEPR SPRAY|PEPR SPRY|PEPPER/.test(u)) return '';
    if (/GAS BLOCK/.test(u)) return '';
    if (/SCOPE MOUNTING|\bMOUNTING KIT\b|SCOPE MOUNT KIT/.test(u)) return '';
    if (/HELM MNT|HELMET MNT|HELMET MOUNT|HELM MOUNT/.test(u)) return 'mounts';
    if (/SMARTCLIP|DIVINGBOARD|KNOB SYNERGY|RACE DIAL|MAGN ADJ/.test(u)) return 'accessories';
    if (/\bBTC ADPTR\b|\bBTC RAIL/.test(u)) return 'mounts';
    if (/ARCA HEAD/.test(u)) return 'mounts';
    if (/TRIPOD/.test(u)) return 'accessories';
    if (/KEY RING|\bD RING\b|BIPOD|GUNSMITH|SPEED FEED/.test(u)) return '';
    if (/SHT-N-C|SHT N C|EZE-SCORER|SILHOUETTE TGT|PAPER TGT/.test(u)) return '';
    if (/BULLSEYE/.test(u) && !/MEPRO|M-21|\bM21\b|RED DOT|REFLEX/.test(u)) return '';
    if ((/TARGET|\bTGT\b|\bTRGT\b/.test(u)) &&
        !/RIFLESCOPE|LPVO|ASCENT|MEPRO|M-21|\bM21\b/.test(u) &&
        !/\bSCOPE\b/.test(u)) {
      return '';
    }
    if (/\.177|AIR RIFLE|AIRGUN|PELLET|POWERLINE/.test(u) && /W\/ ?SCOPE|WITH SCOPE|\bRFL\b/.test(u)) return '';
    if (/\bBINO|\bBINOC/.test(u) || (/\bBX-/.test(u) && (/^LEUP\b/.test(u) || /LEUPOLD/.test(v)))) {
      if ((/\bMOUNT\b|\bMNT\b|\bADAPTER\b|\bADPTR\b|\bADPT\b/.test(u)) &&
          !/\b\d{1,2}X\d{2}\b/.test(u)) {
        if (/\bADAPTER\b|\bADPTR\b|\bADPT\b/.test(u)) return 'accessories';
        return 'mounts';
      }
      return 'binoculars';
    }
    if (/SPOTTING|SPOTTER|SPTNG|SPTSCP|KONUSPOT/.test(u) ||
        (/\bSX-/.test(u) && (/^LEUP\b/.test(u) || /LEUPOLD/.test(v)))) {
      return 'spotting';
    }
    if (/REAP-IR|IR-HUNTER|\bWRAITH\b|\bDBAL\b|\bOGL\b|VCSEL|\bTHERMAL\b|IR AIMING/.test(u)) return 'thermal';
    if (/RANGEFIND|RNGFNDR|RANGEFINDR/.test(u) || /LEUP RX-|\bRX-\d|\bRX-FULLDRAW|\bHORIZONLINE\b/.test(u)) {
      return 'rangefinders';
    }
    if (/\bACOG\b/.test(u)) {
      var acogMag = /\d+\.\d+X|\b\d{1,2}X\d{2}/.test(u);
      if (!acogMag && (/\bMNT\b|\bMOUNT\b|MOD UPPER/.test(u))) return 'mounts';
      return 'scopes';
    }
    // Magnifiers before red-dot keywords (G33/G45/HM3X used to land in red dots).
    if (
      (/MAGNIFIER|MICROMAG|\bMMX3\b|\bMMX4\b|\bMMX5\b|\bG33\b|\bG43\b|\bG45\b|\bG49\b|\bHM3X|\b3XMAG|\b6XMAG|\b3X-C\b|3X MAG|4X MAG|5X MAG/.test(u) ||
        (/\bHHS/.test(u) && /G3|G4|MAG/.test(u))) &&
      !/MOUNT FOR MAGNIFIER|MNT FOR MAGNIFIER/.test(u) &&
      !(/MAGNIFIER MNT|MAGNIFIER MOUNT/.test(u) && !/W\/|WITH /.test(u))
    ) {
      return 'magnifiers';
    }
    // Holosun-vendor sights. Spark titles often omit "red dot" / "Holosun"
    // (MRS, Shake Awake, 2MOA, HOLEPS…) and used to dump into Other optics.
    if (/HOLOSUN/.test(v) || /^HOLOSUN\b/.test(u) || /HOLEPS|\bHOLO EPS\b/.test(u)) {
      if (/MAGNIFIER|\bHM3X\b|\bHM5X\b/.test(u)) return 'magnifiers';
      if ((/WHITE LIGHT|WEAPON LIGHT|\bWML\b|\d+\/\d+\s*LUMEN/.test(u)) &&
          !/DOT|RETICLE|\bMRS\b|REFLEX|SIGHT/.test(u)) {
        return 'weapon-lights';
      }
      if (/FLIP CAP|LENS COVER|KILLFLASH|BATTERY CAP|LENS PEN/.test(u)) return 'accessories';
      if (/\b(PLT|PLATES?)\b/.test(u) && !/DOT|RETICLE|\bMRS\b|REFLEX|SIGHT/.test(u)) return 'plates';
      if ((/\bMOUNT\b|\bMNT\b/.test(u)) &&
          !/W\/MNT|W\/ ?MOUNT|WITH MOUNT|DOT|RETICLE|\bMRS\b|REFLEX|SIGHT/.test(u)) {
        return 'mounts';
      }
      return 'red-dots';
    }
    // Dedicated rings/mounts before magnification: "LPVO 34MM RNG" is rings,
    // "MARK 4 35MM HIGH" is rings. A riflescope that ships with rings stays a scope.
    if ((/\bRINGS?\b|\bRNGS\b|\bRNG\b|RING SET|SCOPE RING/.test(u) ||
        ((/^LEUP\b/.test(u) || /LEUPOLD/.test(v)) && /\d+MM/.test(u) && /HIGH|HGH|LOW|MED|MATTE/.test(u))) &&
        !/W\/ ?RINGS|WITH RINGS|MOA[- ]RING/.test(u) &&
        !/\d+-\d+X/.test(u) &&
        !/\b\d{1,2}X(?:20|24|30|32|40|42|44|50|52|56)/.test(u)) {
      if (/\bPLT\b|\bPLATES?\b/.test(u)) return 'plates';
      if (!OPTIC_FALSE_RING_RE.test(u) && !/\bTRIGGER\b/.test(u)) {
        return 'rings';
      }
    }
    // Sights that ship with a mount stay sights. Dedicated hardware is
    // "MRO LOW MNT" / "FASTFIRE MNT FOR GLK", not "RED DOT W/ LOW MOUNT".
    if (/FASTFIRE|FAST FIRE/.test(u) && !/\b(MNT|MOUNT|PLATE|ADAPTER|ADP|ADPTR)\s+FOR\b/.test(u)) {
      return 'red-dots';
    }
    if (/\bMRO\b/.test(u) && /RED DOT|GRN DOT|GREEN DOT|RED DT|\bSD\b|\bHD\b|\bPATROL\b/.test(u)) {
      return 'red-dots';
    }
    if (/\bRFX\d|\bRFX\b/.test(u) && !/\b(MNT|MOUNT|PLATE|ADAPTER|ADP|ADPTR)\s+FOR\b/.test(u)) {
      return 'red-dots';
    }
    if (/RED DOT|GRN DOT|GREEN DOT|REFLEX SIGHT|MINI SGHT|MINI SIGHT/.test(u) &&
        !/\b(MNT|MOUNT|PLATE|PLT|ADAPTER|ADP|ADPTR)\s+FOR\b/.test(u) &&
        !/HYDRA|GUARDIAN RMR|MODULAR UPPER|\bROF-|\bROF /.test(u)) {
      return 'red-dots';
    }
    var bundledMount = /W\/MNT|W\/RMR|\bW\/ ?RMR\b|\bW\/ ?(?:LOW |HIGH |FULL |CO-WIT(?:NESS)? |DT )?MNTS?\b|\bW\/ ?(?:LOW |HIGH |FULL |CO-WIT(?:NESS)? |DT )?MOUNTS?\b|\bWITH (?:A |LOW |HIGH )?MOUNTS?\b/.test(u);
    var noMountOnly = /\bNO MNT\b|\bNO MT\b|\bNO MOUNT\b/.test(u);
    if ((/\bMOUNT\b|\bMNT\b|SCOPE MOUNT|SCOPE MNT|CANTILEVER|CNTLVR|PEPR MNT|OPTIC RISER/.test(u)) &&
        !/\d+-\d+X/.test(u) &&
        !/ACOG|VCOG|VUDU|ACCUPOINT|CREDO/.test(u) &&
        !bundledMount &&
        !noMountOnly) {
      var dk = opticMountKindOf(u);
      if (dk) return dk;
    }
    if (/UNITY FAST/.test(u) && !/MAGNIFIER|FTC/.test(u)) {
      if (/\bPLT\b|\bPLATE\b/.test(u)) return 'plates';
      return 'mounts';
    }
    if (/HYDRA|MODULAR UPPER|\bROF-|\bROF /.test(u)) return 'mounts';
    if (/GUARDIAN RMR/.test(u) && !/SIGHTS/.test(u)) return 'mounts';
    if (/\bPLT\b|\bPLATE\b|TO RMR|TO SRO|TO HOLO|MOS TO |OR TO RMR|OR TO HOLO/.test(u) &&
        !/RED DOT|REFLEX SIGHT|MINI SGHT|MINI SIGHT/.test(u)) {
      return 'plates';
    }
    if ((/CO-WITNESS|CO-WIT|LOWER 1\/3|1\/3 CO-WIT|QR CO-WIT|LW QR/.test(u) ||
        ((/AM DEF|AMERICAN DEFENSE/.test(u) || /AMERICAN DEFENSE/.test(v)) &&
          /AIMPOINT|HOLOSUN|MRO|AEMS|509T|\bT1\b|\bT2\b/.test(u))) &&
        !/RED DOT|MRO SD|MRO HD|\bPATROL\b|TYPE 2|REFLEX SIGHT/.test(u)) {
      return 'mounts';
    }
    if (/MK2 \d+MM/.test(u) && /CAP|OFFSET/.test(u)) return 'mounts';
    if (/GEISSELE/.test(u) && /MRO|AIMPOINT|EOTECH|ACOG/.test(u) && !/RED DOT/.test(u) && !/\d+-\d+X/.test(u)) return 'mounts';
    if (/MOD UPPER|MODULAR UPPER/.test(u)) return 'mounts';
    if ((/^RS REG\b/.test(u) || /RS REGULATE/.test(v)) && /ACOG|RMR|MRO|AIMPOINT|PIC RAIL|MODULAR/.test(u)) {
      return 'mounts';
    }
    if (/THROW LVR MT|RG THROW/.test(u)) return 'mounts';
    if (/REAR SIGHT ADAPT/.test(u)) return 'mounts';
    if (/\bROC\b/.test(u) && /RMRCC|RMR/.test(u)) return 'plates';
    // Magnification in the title is a scope, even when a mount/rings ship with it
    // (VCOG 1-8X28 Q-LOC, TRUGLO 4X32 W/ RINGS). Dedicated mounts stay mounts.
    if ((/\d+-\d+X|\d+X-\d+X|\d+\.\d+X|\b\d{1,2}X(?:20|24|30|32|40|42|44|50|52|56)(?:MM)?\b/.test(u) || /VCOG|ACCUPOINT|CREDO|TENMILE|LPVO|RIFLESCOPE/.test(u)) &&
        !/SCOPE MOUNT|SCOPE MNT|SCOPE RAIL|FLIP SCOPE COVER|SCOPE COVER|SCOPECAP/.test(u) &&
        !/\b(MNT|MOUNT|PLATE|PLT|ADAPTER|ADP|ADPTR)\s+FOR\b/.test(u) &&
        !/CNTLVR|CANTILEVER|PEPR MNT|OPTIC RISER/.test(u) &&
        !/7\.62X|5\.7X|6\.8X|9X19|X39|X51/.test(u) &&
        !/SHT-N-C|PAPER TGT|SPOTTER|SPTNG|\bBINO|KONUSPOT/.test(u) &&
        !((/\bTGT\b|\bTRGT\b/.test(u) || /TARGET/.test(u)) && !/BDC|ASCENT|\d+-\d+X|\bSCOPE\b/.test(u))) {
      return 'scopes';
    }
    // EOTech: Vudu is a scope line. Dedicated PRS SCOPE MOUNT stays mounts.
    // Holographic sights (EXPS/XPS/512) still fall through to red-dots.
    if (/^EOTECH\b/.test(u) || /EOTECH/.test(v)) {
      if (/SCOPE MOUNT|SCOPE MNT/.test(u)) return 'mounts';
      if (/VUDU/.test(u) || (/\bSCOPE\b|\d+-\d+X/.test(u) && !/EXPS|XPS|EFLX|HOLO|\bHWS\b|REFLEX/.test(u))) {
        return 'scopes';
      }
      if (/\bOGL\b|VCSEL/.test(u)) return 'thermal';
    }
    if (/\bBX-|\bSX-/.test(u) && (/^LEUP\b/.test(u) || /LEUPOLD/.test(v))) return 'other';
    if (/DELTAPOINT|DELTA PNT|FREEDOM RDS/.test(u)) return 'red-dots';
    if (/SHIELD SIGHTS/.test(v) || /^SHLDS?\b/.test(u)) {
      if (/COVER|HOOD/.test(u)) return 'accessories';
      if ((/\b(MOUNT|MNT|PLATE|PLT)\b|\bMP FOR\b|\bMP /.test(u)) && !/\bMOA\b|MINI SGHT|MINI SIGHT|\bRFX\b/.test(u)) {
        var sm = opticMountKindOf(u);
        return sm || 'mounts';
      }
      return 'red-dots';
    }
    if (
      /\bRINGS?\b|\bRNGS\b|\bRNG\b|\bBASES?\b|\bBASE\b|CANTILEVER|CNTLVR|\bPEPR\b|SCOPE MOUNT|SCOPE MNT|SCOPE RAIL|\bRAIL\b|OPTIC MOUNT|OPTIC PLATE|MOS PLATE|RMR PLATE|\bADP\b|\bADAPTER\b|\bADPTR\b|\bMOUNT\b|\bMNT\b|\bPLT\b|\bPLATE\b|\bRISER\b|20\s*MOA|30\s*MOA|SKELETON|MAXIMA|\bQLOC\b|Q-LOC|CTL MT|BLT MT|\bPIC RAIL\b/.test(u) &&
      !bundledMount &&
      !noMountOnly
    ) {
      var mk = opticMountKindOf(u);
      if (mk) return mk;
    }
    if (/^LEUP\b/.test(u) || /LEUPOLD/.test(v)) {
      var leupHw = leupoldHardwareOf(u);
      if (leupHw) return leupHw;
    }
    if (
      /RED DOT|REFLEX|HOLO |\bHWS\b|HOLOGRAPHIC|HOLOSUN|AIMPOINT|EOTECH|\bRMR\b|RMRCC|TRIJICON RCR|\bRCR ADJ\b|\bSRO\b|FASTFIRE|VENOM|SPARC|ROMEO|407C|507C|508T|EPS CARRY|HS507|HS407|\bMRO\b|COMPM|\bT2\b|\bRDS\b|\bRFX\b|MINI SGHT|MINI SIGHT|ENCLOSED EMITTER|\bRMS[A-Z0-9]*\b|\bSMS[A-Z0-9]*\b|\bAMS[A-Z0-9]*\b/.test(u)
    ) {
      return 'red-dots';
    }
    if (
      /ACOG|LPVO|RIFLESCOPE|\bSCOPE\b|\bVUDU\b|VX-FREEDOM|VX-3|VX-5|VX-6|MARK 5|MARK 4|VERACITY|FULLFIELD|DROPTINE|ACCUPOINT|\bCREDO\b|TENMILE|\bVCOG\b|\bHURON\b|\bASCENT\b|\b\d{1,2}X(?:20|24|30|32|40|42|44|50|52|56)\b|\b\d{1,2}(?:\.\d{1,2})?-\d{1,2}(?:\.\d{1,2})?X/.test(u)
    ) {
      return 'scopes';
    }
    if (/MICRO PISTOL SIGHT|\bMINISHOT\b|MINI[- ]?SHOT|ULTRA SHOT|MEPRO M22|\bM22\b.{0,12}BULLSEY/.test(u)) {
      return 'red-dots';
    }
    if (/MEPRO MCO|\bMCO PRO\b|\bM-21\b|\bM21\b/.test(u)) return 'red-dots';
    if (/ENCLSD RD|\bEDC XL RD\b|\bEDC XL RED\b|\bEDC ENCLSD/.test(u)) return 'red-dots';
    if (/TACTIX ARD|TACTIX MPRD|TACTIX PRD/.test(u)) return 'red-dots';
    if ((/^WARNE\b/.test(u) || /WARNE/.test(v)) && !/BIPOD|ARCA HEAD|DIVINGBOARD/.test(u)) {
      if (/\bMT\b|\b7\.3\b/.test(u)) return 'rings';
      if (/1(?:PC|-PIECE)|TACTICAL 1/.test(u)) return 'mounts';
    }
    if ((/^WEAVER\b/.test(u) || /WEAVER/.test(v)) && !/GUNSMITH|HAMMER|PUNCH/.test(u)) {
      if (/1PC|1-PIECE|MULTI[- ]?SLOT|MULTI SLT|MULT SLOT|#\d|EXT(?:ENDED)? MULT|BSE\b|\bBASE/.test(u)) return 'mounts';
    }
    if ((/^TALLEY\b/.test(u) || /TALLEY/.test(v)) && /\d+MM/.test(u) && /HIGH|LOW|MED/.test(u) && !/\bBASE\b|\bPIC\b/.test(u)) {
      return 'rings';
    }
    if (/BURRIS SCOUT/.test(u) && /\d/.test(u)) return 'scopes';
    if (/GEISSELE/.test(u) && /VORTEX|EOTECH|AIMPOINT|ACOG/.test(u) && !/\d+-\d+X/.test(u)) return 'mounts';
    if (/UNITY FAST FTC/.test(u) && /\b[3-6]X\b/.test(u) && !/30MM|HOLOSUN|\bPA MAGNIFIER/.test(u)) {
      return 'magnifiers';
    }
    if (/XTB |PIC BASE|PICATINNY BOLT-ON|BOLT-ON 0 MOA|MULTI[- ]?SLOT|MULT SLOT|EXTENDED MULT/.test(u)) return 'mounts';
    if (/REAP-IR|IR-HUNTER|\bWRAITH\b|\bDBAL\b|\bOGL\b|VCSEL|\bTHERMAL\b/.test(u)) return 'thermal';
    if (/RANGEFIND|RNGFNDR|RANGEFINDR/.test(u) || /LEUP RX-|\bRX-\d|\bRX-FULLDRAW|\bHORIZONLINE\b/.test(u)) {
      return 'rangefinders';
    }
    if ((/\bLASER\b|\bLSR\b|GREEN LASER|RED LASER|\bTOR FUSION\b|LSR SIGHT/.test(u) ||
        (/STEINER/.test(u + ' ' + v) && /ATLAS|TOR /.test(u))) &&
        !/BORE SIGHT|BORESIGHT/.test(u)) {
      return 'lasers';
    }
    if (/BATTERY PACK|QD BATTERY/.test(u)) return 'accessories';
    if (/RGR TO WVR|RGR TO WEAVER|RUGER TO WEAVER|VAPOR RL|VAPR RL/.test(u)) return 'mounts';
    return 'other';
  }

  function opticKindOf(title) {
    var u = (title || '').toUpperCase();
    if (/\bHHS/.test(u) || /W\/G3|W\/G4|WITH G3|WITH G4/.test(u)) return 'combos';
    if (/SPOTTING|SPOTTER|SPTNG|SPTSCP/.test(u)) return 'spotting';
    if (/\bBINO|\bBINOC/.test(u)) {
      if ((/\bMOUNT\b|\bMNT\b|\bADAPTER\b|\bADPTR\b|\bADPT\b/.test(u)) && !/\b\d{1,2}X\d{2}\b/.test(u)) {
        return /\bADAPTER\b|\bADPTR\b|\bADPT\b/.test(u) ? 'accessories' : 'mounts';
      }
      return 'binoculars';
    }
    if (/MAGNIFIER|\bG33\b|\bG43\b|\bG45\b|\bG49\b|\bHM3X|\b3XMAG|\b6XMAG|\b3X-C\b|3X MAG|5X MAG/.test(u)) {
      return 'magnifiers';
    }
    if (/\bOGL\b|VCSEL/.test(u)) return 'lasers';
    if (/VUDU/.test(u) && /SCOPE MOUNT|SCOPE MNT|PRS 2 SCOPE MOUNT/.test(u)) return 'mounts';
    if (/VUDU/.test(u)) return 'scopes';
    if ((/LPVO|RIFLESCOPE|\bSCOPE\b|\d+-\d+X/.test(u)) && !/EXPS|XPS|EFLX|HOLO|\bHWS\b|REFLEX|RED DOT/.test(u)) {
      if (/SCOPE MOUNT|SCOPE MNT/.test(u)) return 'mounts';
      return 'scopes';
    }
    if (/EXPS|XPS|\b512\b|\b552\b|\b518\b|\b558\b|EFLX|HOLO|\bHWS\b|REFLEX|RED DOT|HOLOGRAPHIC/.test(u)) {
      return 'red-dots';
    }
    return 'other';
  }

  function colorOf(title) {
    var u = (title || '').toUpperCase();
    if (/\bTAN\b/.test(u)) return 'tan';
    if (/\bFDE\b/.test(u)) return 'fde';
    if (/\bBLK\b|\bBLACK\b/.test(u)) return 'blk';
    if (/\bODG\b|\bOD GRN\b|\bOD GREEN\b/.test(u)) return 'od';
    if (/\bGRY\b|\bGRAY\b|\bGREY\b/.test(u)) return 'gry';
    return '';
  }

  function magCapOf(title) {
    var u = (title || '').toUpperCase();
    var m = u.match(/\b(\d+)\s*RD\b/) || u.match(/\b(\d+)RD\b/) ||
      u.match(/\b(\d+)\s*-?\s*ROUNDS?\b/) || u.match(/\b(\d+)\s*ROUND/);
    return m ? m[1] : '';
  }

  var MAG_CALS = [
    { id: '9mm', label: '9mm', re: /\b9MM\b|\b9\s*MM\b|\b9X19\b/ },
    { id: '40sw', label: '.40 S&W', re: /\b40S&W\b|\b40SW\b|\b40\s*S&W\b|\.40/ },
    { id: '45acp', label: '.45 ACP', re: /\b45ACP\b|\b45\s*ACP\b|\.45ACP|\.45\s*ACP|\b45\s*AUTO\b|\b\.45\b/ },
    { id: '10mm', label: '10mm', re: /\b10MM\b|\b10\s*MM\b/ },
    { id: '380acp', label: '.380 ACP', re: /\b380ACP\b|\b380\s*ACP\b|\.380|\b380\b/ },
    { id: '38super', label: '.38 Super', re: /\b38SUPER\b|\b38SUP\b|\b38\s*SUPER/ },
    { id: '32acp', label: '.32 ACP', re: /\b32ACP\b|\b32\s*ACP\b/ },
    { id: '25acp', label: '.25 ACP', re: /\b25ACP\b|\b\.25\b/ },
    { id: '57x28', label: '5.7x28', re: /\b5\.7X28|\b57X28\b/ },
    { id: '22lr', label: '.22 LR', re: /\b22LR\b|\b22\s*LR\b|\.22LR\b|\b22\s*LONG/ },
    { id: '22wmr', label: '.22 WMR', re: /\b22WMR\b|\b22\s*WMR\b/ },
    { id: '17hmr', label: '.17 HMR', re: /\b17HMR\b|\b17\s*HMR\b/ },
    { id: '556', label: '5.56 / .223', re: /\b5\.56\b|\b556NATO\b|\b223REM\b|\.223|\b556\b|\b223\b/ },
    { id: '300blk', label: '.300 BLK', re: /\b300BLK\b|\b300\s*BLK\b|\b300AAC\b/ },
    { id: '338arc', label: '.338 ARC', re: /\b338ARC\b|\b338\s*ARC\b/ },
    { id: '65grendel', label: '6.5 Grendel', re: /6\.5\s*GRENDEL/ },
    { id: '65cm', label: '6.5 CM', re: /\b6\.5CM\b|\b6\.5\s*CM\b|\b6\.5\s*CREED/ },
    { id: '762x39', label: '7.62x39', re: /\b762X39\b|\b7\.62X39\b/ },
    { id: '308', label: '.308 / 7.62', re: /\b308WIN\b|\b\.308\b|\b7\.62X51\b|\bAR308\b|\bAR[- ]?308\b|\b308\b/ },
    { id: '7mm', label: '7mm Mag', re: /\b7MM[- ]?REM|\b7MM\b/ },
    { id: '12ga', label: '12 ga', re: /\b12GA\b|\b12\s*GA\b|\b12-GA|\b12\s*GAUGE\b/ },
    { id: '20ga', label: '20 ga', re: /\b20GA\b|\b20\s*GA\b|\b20\s*GAUGE\b/ }
  ];
  var CAL_LABELS = {};
  MAG_CALS.forEach(function (c) { CAL_LABELS[c.id] = c.label; });

  function magCalOf(title) {
    var u = (title || '').toUpperCase();
    var i;
    for (i = 0; i < MAG_CALS.length; i++) {
      if (MAG_CALS[i].re.test(u)) return MAG_CALS[i].id;
    }
    if (/\b45\b/.test(u) && !/\bGLK\b|\bGLOCK\b|\bG45\b|\bXDM?\b|\bHK45\b/.test(u)) return '45acp';
    return '';
  }

  function magStyleOf(title) {
    var u = (title || '').toUpperCase();
    if (/\bDRUM\b/.test(u)) return 'drum';
    if (/\bTDE\b/.test(u)) return 'tan';
    if (/\bCLR\b|CLEAR|TRANSLUCENT|TRANSLUC|\bCSMK\b|\bSMOKE\b|\bTSMK\b|TRANS SMK/.test(u)) return 'clear';
    if (/\bFDE\b|\bTAN\b/.test(u)) return 'tan';
    if (/\bOBLK\b|OPAQUE BLK|OPAQUE BLACK|\bBLACK\b|\bBLK\b/.test(u)) return 'black';
    return '';
  }

  function holsterCarryOf(title) {
    var u = (title || '').toUpperCase();
    if (/\bAIWB\b|APPENDIX/.test(u)) return 'aiwb';
    if (/\bIWB\b|INSIDE-THE-WAISTBAND|INSIDE THE WAISTBAND/.test(u)) return 'iwb';
    if (/\bOWB\b|\bPADDLE\b|DROP LEG|OUTSIDE-THE-WAISTBAND|OUTSIDE THE WAISTBAND/.test(u)) return 'owb';
    return '';
  }

  var MISC_JOBS = {
    'castle-nut': 'Castle nuts',
    'end-plate': 'End plates',
    vise: 'Vise blocks',
    catch: 'Catches & releases',
    wrench: 'Wrenches',
    comp: 'Comps & brakes',
    rail: 'Rails & covers',
    sling: 'Sling hardware',
    pin: 'Pins',
    qd: 'QD / swivels'
  };

  function miscJobOf(title) {
    var u = (title || '').toUpperCase();
    if (/\bCASTLE NUT/.test(u)) return 'castle-nut';
    if (/\bEND PLATE/.test(u) || /SLING ATTCH PLT|SLING ATTACH/.test(u)) return 'end-plate';
    if (/\bVISE BLOCK/.test(u)) return 'vise';
    if (/\b(MAG|SLIDE|SLD|BOLT)\s*(RLS|RELEASE|CATCH|CTCH)/.test(u) || /\bMAG (REL|RLS|RLESE|RLSE)\b/.test(u)) return 'catch';
    if (/\bWRENCH\b|\bCROWS FT\b/.test(u)) return 'wrench';
    if (/\bCOMPENSATOR\b|\bAFTRBRNR\b|\bAFTERBURNER\b|\bRAMJET\b|\bJAM NUT\b|\bMUZZLE BRAKE\b|\bMZL BRK\b/.test(u) ||
        (/\bBRAKE\b/.test(u) && !/TRIGGER|TRIG/.test(u))) return 'comp';
    if (/RAIL CVR|RAIL COVER|PICATINNY.*COVER|1913.*COVER|PANEL COVER/.test(u)) return 'rail';
    if (/\bSLING\b|\bSLNG\b/.test(u)) return 'sling';
    if (/\bQD\b|SWIVEL/.test(u)) return 'qd';
    if (/\bPIVOT PIN\b|\bTAKEDOWN PIN\b|\bTD PIN\b|\bPINS?\b/.test(u)) return 'pin';
    return '';
  }

  function leupoldHardwareOf(u) {
    if (/DELTAPOINT|DELTA PNT|FREEDOM RDS/.test(u)) return 'red-dots';
    if (/ALUMINA|FLIP LENS|LENS PEN/.test(u)) return 'accessories';
    if (/MARK 4/.test(u) && /\d+MM/.test(u) && !/\d+-\d+X/.test(u) && !/\b\d{1,2}X(?:20|24|30|32|40|42|44|50|52|56)/.test(u)) {
      return 'rings';
    }
    if (/\bRX-/.test(u)) return 'other';
    if (/\bIMS\b/.test(u)) return 'mounts';
    if (/\bSTD\b|STANDARD/.test(u) && !/\d+MM/.test(u) && !/\bRINGS?\b/.test(u) &&
        !/\d+-\d+X/.test(u) && !/FIREDOT/.test(u)) {
      if (/\b1(?:PC|-PIECE)\b/.test(u) && !/\b2(?:PC|-PIECE)\b/.test(u)) return 'mounts';
      if (/\b2(?:PC|-PIECE)\b/.test(u)) return 'rings';
      return 'mounts';
    }
    if (/\b1(?:PC|-PIECE)\b/.test(u) && !/\b2(?:PC|-PIECE)\b/.test(u) && !/\bRINGS?\b/.test(u) && !/\d+MM/.test(u)) {
      return 'mounts';
    }
    if (/\bBASE\b/.test(u)) return 'mounts';
    if (/RIFLEMAN|RFLMN|OPEN RANGE|\b2(?:PC|-PIECE)\b|\bPRW|\bRM\b|\bBC\b|CNTRY|COUNTRY|\bHGH\b/.test(u) &&
        !/\d+-\d+X/.test(u) && !/FIREDOT/.test(u)) {
      if (/\b1(?:PC|-PIECE)\b/.test(u) && !/\d+MM/.test(u)) return 'mounts';
      return 'rings';
    }
    return '';
  }

  function isOpticHit(u, v) {
    if (
      /(FRONT|FRNT|REAR|RR) SIGHT|FLIP-UP|FLIP UP|IRON SIGHT|NIGHT SIGHT|SIGHT SET|\bNS FOR\b|\bHD NS\b|\bSUP NS\b|\bFIBER SIGHT\b|\bHD XR\b|SUPPRSR NS|\bDI NS\b|DUAL DEFENSE|\bFRBS\b|FT BE FOR GL/.test(u) &&
      !/RED DOT|RMR|ACOG|MRO|REFLEX|HOLO|\bSCOPE\b|RCR|RMRCC/.test(u)
    ) {
      return false;
    }
    if (/^TRIJICON\b/.test(u) && /\b(HD FOR|HD XR FOR|NS |FIBER SIGHT)\b/.test(u) &&
        !/RMR|MRO|ACOG|RCR|RMRCC|RED DOT|REFLEX/.test(u)) {
      return false;
    }
    if (/SHT-N-C|SHT N C|EZE-SCORER|SILHOUETTE TGT|PAPER TGT/.test(u)) return false;
    if (/BIRCHWOOD/.test(v) || /^B\/C\b/.test(u)) return false;
    if (/LEVEL RITE|SCOPE ALGN|SCOPE ALIGN|SCOPE STAND|KIKSTAND|ADJ CAP|\bCAPS\b/.test(u)) {
      if (/ADJ CAP|\bCAPS\b|FLIP CAP|LENS COVER|ALUMINA|SCOPECAP/.test(u)) {
        /* caps still count as optic accessories */
      } else {
        return false;
      }
    }
    if (/BULLSEYE/.test(u) && !/MEPRO|M-21|\bM21\b|RED DOT|REFLEX/.test(u)) return false;
    if ((/TARGET|\bTGT\b|\bTRGT\b/.test(u)) &&
        !/RIFLESCOPE|LPVO|ASCENT|MEPRO|M-21|\bM21\b/.test(u) &&
        !/\bSCOPE\b/.test(u)) {
      return false;
    }
    if (/\b(SLIDE|SLD)\b/.test(u) && /GLOCK|\bGLK|P320|\bRXM\b/.test(u)) return false;
    if (/SURSHL|SURESHELL|\bSRSHL\b/.test(u)) return false;
    if (/HIPERTOUCH REFLEX|HIPERFIRE|TRIG ASSEM/.test(u)) return false;
    if (/HT SGT|HT SGTS|BLNK RMR/.test(u) && !/RED DOT/.test(u)) return false;
    if (/READYDOT/.test(u)) return false;
    if (/CHEEK RISER|CHK RISER|CHK RISR|COMB RISER/.test(u)) return false;
    if (/PEPR SPRAY|PEPR SPRY/.test(u)) return false;
    if (/GAS BLOCK/.test(u)) return false;
    if (/SCOPE MOUNTING|SCOPE MOUNT KIT|\bMOUNTING KIT\b/.test(u)) return false;
    if (/GUARDIAN/.test(u) && /SIGHTS/.test(u) && !/\b(MNT|MOUNT)\b/.test(u)) return false;
    if (/\.177|AIR RIFLE|AIRGUN|PELLET|POWERLINE/.test(u) && /W\/ ?SCOPE|WITH SCOPE|\bRFL\b/.test(u)) return false;
    if ((/CROSMAN|DAISY|GAMO/.test(v) || /CROSMAN|DAISY|GAMO/.test(u)) && /W\/RED DOT|W\/ SCOPE|W\/SCOPE/.test(u)) return false;
    if ((/CROSMAN|DAISY|GAMO/.test(v) || /CROSMAN|DAISY|GAMO/.test(u)) &&
        /DBL RING|DOUBLE RING|PELLET|\bPEL\b|\d+\s*CT|\d+PK/.test(u) &&
        !/SCOPE|W\/SCP|W\/ ?SCOPE|\d+X\d{2}/.test(u)) {
      return false;
    }
    if ((/HIVIZ|HI-VIZ/.test(v) || /HIVIZ|HI-VIZ/.test(u)) &&
        /RING/.test(u) && !/SCOPE|RED DOT|REFLEX/.test(u)) {
      return false;
    }
    if (/X-?RING TRIGGER|\bXRT\b/.test(u) && /TRIGGER|TACSOL|TAC SOL/.test(u + ' ' + v)) {
      return false;
    }
    if (/PEPR SPRY|PEPR SPRAY|PEPPER SPRAY|KEY RING|\bD RING\b|DELTA RING|SLIP RING|GAS RING|O-RING|O['’]RING|DETENT RING|BIPOD|GUNSMITH|SPEED FEED|SLING SWIVEL|GHOST RING|LEVERRAIL|BORESIGHT|FOREGRIP|FORE GRP|HANDGUARD|HNDGRD|\bVEST\b|\bSTOCKS?\b|\bSTK\b|STOCK KIT|CARRY HANDLE|RECEIVER WEDGE|\bIFAK\b|TOURNIQUET|FIRST AID|MEDICAL POUCH|MED POUCH/.test(u)) {
      return false;
    }
    if (/(?:MEPROLT|MEPROLIGHT).{0,16}(?:TRU[- ]?DOT|\bTD\b|\bHB\b|FT BE|SHOTGUN BEAD|SUPPRESSOR SIGHT|SUP SGHT)/.test(u) &&
        !/RED DOT|MCO|\bRDS\b|M-21|\bM21\b/.test(u)) return false;
    if (/(FLIP|FRNT|FRONT|REAR|RR)[- ]SIGHT/.test(u) && !/RED DOT|RMR|MRO|ACOG|REFLEX/.test(u)) return false;
    if ((/^UNITY\b/.test(u) || /UNITY TACTICAL/.test(v)) && /AXON|MODBUTTON|GASCAP|SPARK CAGE/.test(u)) return false;
    if ((/^UNITY\b/.test(u) || /UNITY TACTICAL/.test(v)) && /FAST |MAGNIFIER|AEMS|OMNI|RISER|OPTIC/.test(u)) return true;
    if (
      /RED DOT|REFLEX|HOLOGRAPHIC|\bHWS\b|HOLOSUN|AIMPOINT|EOTECH|\bRMR\b|RMRCC|TRIJICON RCR|\bSRO\b|\bACOG\b|\bMRO\b|LPVO|RIFLESCOPE|\bSCOPE\b|DELTAPOINT|\bRDS\b|\bRFX\b|OPTIC PLATE|OPTIC PLT|OPTICS PLATE|OPTICS MOUNT|MOS PLATE|RMR PLATE|SCOPE MOUNT|SCOPE RING|SCOPE RAIL|SCOPECAP|MAGNIFIER|\bRINGS?\b|\bRNGS\b|CANTILEVER|\bPEPR\b|OPTIC MOUNT|\bRISER\b|\d+-\d+X|RNGFNDR|RANGEFIND|RANGEFINDR|MICRO PISTOL SIGHT|\bMINISHOT\b|ULTRA SHOT|\bWRAITH\b|\bDBAL\b|REAP-IR|IR-HUNTER|\bTHERMAL\b|\bBINO|\bBINOC|SPOTTING|SPOTTER|SPTNG|HOLO K|HOLO EPS|HOLO 509|MOUNTING PLATE/.test(u)
    ) {
      return true;
    }
    if (/GEISSELE/.test(u) && /VORTEX|EOTECH|AIMPOINT|ACOG/.test(u)) return true;
    if (OPTIC_VENDOR_RE.test(v) && !/\bCASE\b|\bBAG\b|FLASHLIGHT|HOLSTER|\bGRIP\b|CLEANING|\bMAG EXT\b|\bMAG\b/.test(u)) {
      return true;
    }
    return false;
  }

  function storageTypeOf(u) {
    if (/CASE PREP|CASE TUMBLER|CASE POLISH|VIBRATORY CASE|\d+CT CASE/.test(u)) return '';
    if (/SAFE|LOCKBOX|VAULT/.test(u) && !/GUN SCRUBBER|SYN SAFE|SHARPS|P365|GRIP MODULE/.test(u)) return 'safes';
    if (/AMMO BOX|AMMO CAN|\bAMMOBOX\b|\bAMMO BX\b|SHOT SHELL BOX/.test(u)) return 'ammo-boxes';
    if (/RUCK SACK|SLING PACK|SLING BAG|BACKPACK|\bPACK\b/.test(u) && !/PATCH|PACK OF|\d+ PACK|\d+PK/.test(u)) return 'bags';
    if (/RANGE BAG|GEAR BAG|\bBAG\b|DUFFEL|DUFFLE|CHEST RIG|APPARITION/.test(u)) return 'bags';
    if (/HARD CASE|PELICAN|PLANO|SKB |HNTR CS|RIFLE CASE|SHOTGUN CASE|DBL RFLE|DOUBLE RIFLE|DBL CARB/.test(u)) {
      return 'hard-cases';
    }
    if (/SOFT CASE|SOFT CS|GUN CASE|PISTOL CASE|CARB CS|DISCREET|RFL CS|TACT SINGLE RIFLE|TACT LONG RANGE RFL|DBL TACT RIFLE|LIBERATOR/.test(u)) {
      return 'cases';
    }
    if (/\bCASE\b|\bCS\b/.test(u) && !/CASE PREP|CASE TUMBLER/.test(u)) return 'cases';
    return 'other';
  }

  function isStorageHit(u, v) {
    if (HOLSTER_RE.test(u)) return false;
    if (/CASE PREP|CASE TUMBLER|CASE POLISH|VIBRATORY CASE|\d+CT CASE/.test(u)) return false;
    if (/CLEANING|CLN KIT|CLEAN KIT/.test(u)) return false;
    if (/MAG POUCH|TRIGGER LOCK|TRIGGER FUN|EZAIM|PLATE CARRIER|BATTLE BELT/.test(u)) return false;
    if (/PEPPER|PPR LNCHR|LAUNCHER/.test(u) && /SABRE|MACE|OC /.test(u)) return false;
    if (/SHARPS/.test(v) && /SAFE/.test(u)) return false;
    if (/REST\/REAR BAG|SHOOTING REST/.test(u)) return false;
    if (/AMMO BOX|AMMO CAN|\bAMMOBOX\b|\bAMMO BX\b|SHOT SHELL BOX/.test(u)) return true;
    if (/\bSAFE\b|GUNSAFE|LOCKBOX|LOCK BOX|VAULT|\bCASE\b|\bCASES\b|\bBAG\b|BACKPACK|RANGE BAG|SOFT CASE|HARD CASE|PELICAN|PLANO|BOYT|GUN CASE|CHEST RIG|SLING PACK|SLING BAG|RUCK SACK|APPARITION/.test(u)) {
      return true;
    }
    if (STORE_VENDOR_RE.test(v) &&
        !/SLING|HOLSTER|TARGET|BIPOD|BULLSEYE|CLEAN|MAG POUCH|TRIGGER|PLATE CARRIER|BATTLE BELT|EZAIM/.test(u)) {
      return true;
    }
    return false;
  }

  function isNitrileGlove(u) {
    return /NITRILE/.test(u) && /\bGLOVES?\b/.test(u);
  }

  function cleanTypeOf(u) {
    if (isNitrileGlove(u)) return 'gloves';
    if (/\bKIT\b|CLN KIT|CLEANING KIT/.test(u)) return 'kits';
    if (/SOLVENT|\bCLP\b|\bOIL\b|LUBE|LUBRICANT|BORE CLEAN|BLUEING|BLUING|GUN BLU|#9/.test(u)) return 'chemicals';
    if (/\bROD\b|BRUSH|PATCH|JAG|MOP|BORESNAKE/.test(u)) return 'rods-brushes';
    return 'other';
  }

  function isCleanHit(u, v) {
    if (/TARGET|TGT|SPLASH|REACTIVE/.test(u) && /BIRCHWOOD/.test(v)) return false;
    if (/TRIGRTECH|TRIGGERTECH|TRIGGER TECH/.test(u)) return false;
    if (/BELT CLP/.test(u)) return false;
    if (/BIPOD|SHOOTING BENCH/.test(u)) return false;
    if (/SCOPE MOUNTING|SCOPE MOUNT KIT/.test(u)) return true;
    if (/BORE SIGHTER|BORESIGHT|BORE SIGHT/.test(u)) return false;
    if (/BORE|CLEANING|GUN CLEANER|\bCLEANER\b|CLN KIT|\bCLN\b|\bSOLVENT\b|\bCLP\b|PATCHES|\bBRUSH\b|\bLUBE\b|LUBRICANT|GUN OIL|[- ]OIL\b|\bOIL\b|BREAKFREE|BALLISTOL|BORESNAKE|GUN BLU|BLUEING|BLUING/.test(u)) {
      return true;
    }
    if (CLEAN_VENDOR_RE.test(v) && !/TARGET|\bBAG\b|\bCASE\b/.test(u)) return true;
    if (/BIRCHWOOD/.test(v) && !/TARGET|TGT|SPLASH|\bBAG\b|\bCASE\b|HOLSTER/.test(u)) return true;
    return false;
  }

  function isMerchHit(u) {
    if (!u) return false;
    if (/HARD HAT/.test(u)) return false;
    return /T-?SHIRT|\bTSHRT\b|\bSHIRT\b|\bHOODIE\b|\bHAT\b|APPAREL|SPORT BOTTLE|MERINO/.test(u);
  }

  function skipFirearmFamily(title, vendor) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    if (isCleanHit(u, v)) return true;
    if (isMerchHit(u)) return true;
    if (knifeClassify(title, vendor)) return true;
    if (/DUMMY ROUNDS?|SNAP CAPS?/.test(u)) return true;
    if (/BACKPACK|\bVEST\b|\bGUN CASE\b/.test(u)) return true;
    if (isReloadHit(u, v)) return true;
    return false;
  }

  function isBoreSighterHit(u) {
    return /BORE SIGHTER|BORESIGH|BORE SIGHT|BORE SGHTR|SIGHT-?RITE|VIZ-MAX|LASER CARTRIDGE|LASER BORES?\b/.test(u);
  }

  function isLightCapHit(u, v) {
    if (!/REAR CAP|TAIL CAP|CAP ASSY|REPLCEMNT REAR|REPLACEMENT REAR|PROTECTIVE REAR CAP/.test(u)) return false;
    if (!(LIGHT_VENDOR_RE.test(v) || /SUREFIRE|STRMLGHT/.test(u))) return false;
    // Complete lights that ship with a tail-cap switch stay weapon lights.
    if (/TLR-|\bTLR\b|WML|X300|X400|SCOUT LIGHT|PROTAC|WEAPON LIGHT|WPN LIGHT/.test(u) &&
        !/REPLCEMNT|REPLACEMENT|PROTECTIVE REAR|REAR CAP ASSY/.test(u)) {
      return false;
    }
    return true;
  }

  function lightTypeOf(u, v) {
    if (isBoreSighterHit(u) || isLightCapHit(u, v)) return 'handheld';
    if (/TLR-|\bTLR\b|TLR\d|WML|WEAPON LIGHT|WPN LIGHT|WPN MNTD|X300|X400|XSC|LIGHTGUARD|SCOUT LIGHT|\bSCOUT\b|M600|M300|INFORCE|RAIL MNT|RAIL MOUNT|RAILMOUNT|RL MNT|LASERGUARD|\bBALDR\b|\bODIN\b|RAILMASTER|CMP LIGHT|XH30|MASTERFIR/.test(u)) {
      return 'weapon-lights';
    }
    if (/LASER/.test(u) && !/FLASHLIGHT|HEADLAMP/.test(u)) {
      if (/^FENIX$|^NITECORE$/.test(v || '')) return 'handheld';
      return 'weapon-lights';
    }
    return 'handheld';
  }

  function isLightHit(u, v) {
    if (/HOLSTER|HLSTR|\bIWB\b|\bOWB\b|6360RDS|6354RDS|6378RDS|6390RDS|7378RDS|OMNIVORE/.test(u)) return false;
    if (/STICKY HOLSTERS|COLE-?TAC|RAVEN CONCEALMENT|BULLDOG CASES|BRAVO CONCEAL|DESANTIS|GUNHIDE/.test(v)) return false;
    if (/BULLDOG EXTREME|VARMINT WRANGLER|\bPERUN\b|VANGUARD 2|^STICKY |\bCOLETAC\b|COLE-TAC/.test(u)) return false;
    if (/DUST COVER|DST CVR|LASER ENGRAVED/.test(u)) return false;
    if (isBoreSighterHit(u)) return false;
    if (isLightCapHit(u, v)) return false;
    if (/W\/\s*LASER|W\/LASER|\bW LZR\b|\bW\/ ?LZR\b/.test(u)) return false;
    if (/SUPPR|SUPPRESSOR/.test(u) && !/LIGHT|TLR|WML/.test(u)) return false;
    if (/\bMOUNT\b|\bMNT\b/.test(u) && !/RAILMOUNT|RAIL MOUNT|RAIL MNT|PROTAC RL MNT|PROTAC RAIL/.test(u)) return false;
    if (/SHOTGUN RAIL/.test(u) && !/LUM|PROTAC|WEAPON LIGHT|WPN LIGHT/.test(u)) return false;
    if (LIGHT_VENDOR_RE.test(v) && !/HOLSTER|HLSTR|SUPPR/.test(u)) return true;
    return /FLASHLIGHT|FLSHLGHT|STRMLGHT|SUREFIRE|OLIGHT|FENIX|NITECORE|TLR-|WML\b|WPN LIGHT|WEAPON LIGHT|TAC LIGHT|HEADLAMP|\bLASER/.test(u);
  }

  function hearingStyleOf(u) {
    var inEar = /EAR ?PLUG|EARPLUG|EARPLG|\bPLUGS?\b|EAR ?BUDS|\bBUDS\b|EARBUD|IN[- ]?EAR|SONIC DFNDR|SONIC DEFENDER|TRI-?FLANGE|EARSHIELD|BANDED|RAD BAND|SUPER LEIGHT|DISPENSER|REFILL|ROPE HEARING/.test(u);
    var overEar = /\bMUFFS?\b|EARMUFF|HEADSET|COMTAC|\bRAZOR\b|\bRZR\b|IMPACT SPORT|RANGEGUARD|BULL'?S EYE|SHOTGUNNER|SPORT TAC|SPORT ULTIMATE|TACTICAL 100|HEADBND|HEADBAND|TERMINATOR|GEL EAR|COOLING PAD|TACTI GRIP|COM LINK|ARC ADAPT|\bRECON\b|FIREMAX|XCEL \d|POWER MUFF|\bCLOAK\b|BOOMIES|WALKIE TALKIE/.test(u);
    if (inEar && !overEar) return 'in-ear';
    if (overEar) {
      if (/ELEC|ELECTRONIC|\bBT\b|BLUETOOTH|DIGI|DGTL|DIGITAL|\bRAZOR\b|\bRZR\b|IMPACT SPORT|COMTAC|FIREMAX|XCEL \d|\bRECON\b|E-MAX|2-WAY COMM/.test(u)) {
        return 'over-ear-elec';
      }
      return 'over-ear-passive';
    }
    if (inEar) return 'in-ear';
    return 'over-ear-passive';
  }

  function protectionTypeOf(u, v) {
    var hear = /\bEAR\b|EARMUFF|EAR MUFF|EAR ?PLUG|\bPLUGS?\b|HEARING|\bMUFFS?\b|\bNRR|SONIC DFNDR|\bBUDS\b/.test(u);
    var eye = /GLASS|\bGLS\b|EYE PROT|EYEWEAR|GOGGLE|\bLENS\b|SFTY|SAFETY GLASS|SHOOTING GLASS/.test(u) &&
      !/GLS BRKR|GLS PRO-FIT/.test(u);
    if (eye && !hear) return 'eyes';
    if (hear) return hearingStyleOf(u);
    if (/^RADIANS$/.test(v) && /DISPENSER|REFILL/.test(u)) return 'in-ear';
    if (/^RADIANS$/.test(v)) return 'eyes';
    if (/LENS|FR\//.test(u)) return 'eyes';
    return hearingStyleOf(u);
  }

  function isHearingHit(u, v) {
    if (/TARGET|TGT|SPLASH|REACTIVE|BULLSEYE/.test(u) && !/MUFF|PLUG|HEARING|NRR/.test(u)) return false;
    if (PROT_VENDOR_RE.test(v) && /MUFF|PLUG|HEARING|EAR |NRR|BUDS|COMTAC|SONIC/.test(u + ' ' + v)) return true;
    if (/SONIC DFNDR|SONIC DEFENDER/.test(u)) return true;
    return /EAR MUFF|EARMUFF|HEARING|\bNRR|EAR PLUG|EARPLUG|EAR ?BUDS|\bMUFFS?\b|COMTAC/.test(u);
  }

  function isEyeHit(u, v) {
    if (/TARGET|TGT|SPLASH|REACTIVE|BULLSEYE/.test(u)) return false;
    if (/GLS BRKR|GLS PRO-FIT/.test(u)) return false;
    if (/MUFF|EAR PLUG|HEARING|\bNRR/.test(u)) return false;
    if (PROT_VENDOR_RE.test(v) && /GLASS|EYE|GOGGLE|LENS|SFTY/.test(u)) return true;
    return /EYE PROT|EYEWEAR|GLASSES|GOGGLE|SHOOTING GLASS|SAFETY GLASS|SFTY GLASS|SHTNG GLASS/.test(u);
  }

  function isProtectionHit(u, v) {
    return isHearingHit(u, v) || isEyeHit(u, v);
  }

  function rangeTypeOf(u) {
    if (/SPOTTING|SPOTTER|SPTNG|SPTSCP|KONUSPOT/.test(u)) return 'spotting';
    if (/\bBINO|\bBINOC/.test(u) && !/\bMOUNT\b|\bMNT\b|\bADAPTER\b|\bADPTR\b|\bADPT\b/.test(u)) {
      return 'binoculars';
    }
    if (/TARGET|\bTGT\b|\bTRGT\b|SPLASH|REACTIVE|BULLSEYE|SHT-N-C|EZE-SCORER|SIGHT-IN|SIGHTIN|SILHOUETTE|EZAIM|TRIGGER FUN/.test(u)) {
      return 'targets';
    }
    return 'other';
  }

  function reloadTypeOf(u) {
    if (/\bDIE\b|DIE SET|SIZING DIE|SEATER DIE|DECAPPING|DECAP DIE|TAPER CRIMP DIE|FULL LENGTH DIE|SMALL BASE DIE/.test(u)) {
      return 'dies';
    }
    if (/\bPRESS\b|LOCK-N-LOAD CLASSIC|LNL CLASSIC/.test(u) && !/SHELL HOLDER|POWDER/.test(u)) {
      return 'presses';
    }
    if (/ELD-?M|ELD-?X|\bSST\b|\bXTP\b|\bV-MAX\b|\bVMAX\b|HPBT|\bFMJ\b|\d+\s*-?GR(?:AIN)?\b/.test(u) &&
        !/DIE|PRESS|HOLDER|SCALE|MEASURE|TRIMMER/.test(u)) {
      return 'bullets';
    }
    return 'tools';
  }

  function isReloadHit(u, v) {
    if (/17A SIGHT|INSERT SET FOR 17A/.test(u)) return false;
    if (/SECURITY|LOCK BOX|LOCKBOX|PISTOL RACK|DEHUMIDIFIER|TREKLITE|DIGI-VAULT|TSA LOCK/.test(u)) return false;
    if (/ONE SHOT GUN CLEANER/.test(u)) return false;
    if (/GUNSMITH|PUNCH SET|BENCH BLOCK|GUN VISE|BORECAM|TRIGGER PULL|ARMORER|MAINTENANCE MAT|SONIC PARTS|RANGE BAG|SHOOTING STAND|SHTING BAG|BAG JACK|GUN STORAGE/.test(u)) return false;
    if (/^RCBS\b/.test(v) || /^RCBS\b/.test(u)) return true;
    if (/LOCK-N-LOAD|\bLNL\b/.test(u)) return true;
    if (/DIE SET|SIZING DIE|SEATER DIE|DECAPPING|DECAP DIE|TAPER CRIMP DIE|FULL LENGTH DIE|SMALL BASE DIE|\bAR DIE\b/.test(u)) return true;
    if (/SHELL HOLDER|SHELL HLD|POWDER MEASURE|POWDER FUNNEL|POWDER TRICKLER|CASE LUBE|CASE POLISH|CASE TRIMMER|CAM LOCK TRIMMER|PRIMING TOOL|PRIMER POCKET|LOADING BLOCK|RELOADING HANDBOOK|SHOTSHELL HANDBOOK|AUTO CHARGE|CONCENTRICITY/.test(u)) return true;
    if (/ONE SHOT/.test(u) && /CASE/.test(u) && !/GUN CLEANER/.test(u)) return true;
    if (/(FURNACE|CORNCOB|TUFNUT|CASE MEDIA|BRASS BOSS|EASY POUR)/.test(u) && /LYMAN|RCBS|HORNADY/.test(u + ' ' + v)) return true;
    if (/^HORNADY\b/.test(v) &&
        /ELD-?M|ELD-?X|\bSST\b|\bXTP\b|\bV-MAX\b|\bVMAX\b|HPBT|\bFMJ\b|\d+\s*-?GR(?:AIN)?\b|\d+CAL|\bCALIBER\b/.test(u) &&
        !/SECURITY|CLEANER|LOCK|RACK/.test(u)) {
      return true;
    }
    if (/RELOAD/.test(u) && !/RELOAD (MAG|KIT)|MAG RELOAD/.test(u)) return true;
    return false;
  }

  function isRangeHit(u, v) {
    if (PROT_VENDOR_RE.test(v)) return false;
    if (/EYE\/EAR|EARMUFF|HEARING/.test(u)) return false;
    if (/\d+-\d+X|RIFLESCOPE|ACOG|LPVO|ASCENT/.test(u) && /TARGET/.test(u)) return false;
    if (/BERGER/.test(v) && /TARGET|TRGT/.test(u)) return false;
    if (/MEPRO|M-21|\bM21\b/.test(u) && /BULLSEYE/.test(u)) return false;
    if (RANGE_VENDOR_RE.test(v)) return true;
    if (/CHAMPION/.test(v) && /TARGET|TGT|TRGT|SIGHT-IN|SIGHTIN|BULLSEYE|SPLASH|SCORE|VISISHOT|VISICOLOR|EZAIM/.test(u)) {
      return true;
    }
    if (/BIRCHWOOD/.test(v) && /TARGET|TGT|TRGT|SHT-N-C|SCORER|BULLSEYE|SILHOUETTE/.test(u)) return true;
    if (/ALLEN/.test(v) && /EZAIM|TRIGGER FUN/.test(u)) return true;
    if (/SHOOTING BENCH/.test(u)) return true;
    if (isBoreSighterHit(u)) return false;
    return /TARGET|PAPER TGT|\bTGT\b|\bTRGT\b|STEEL TGT|REACTIVE|SPLASH|BULLSEYE|SHT-N-C|EZE-SCORER|SILHOUETTE/.test(u);
  }

  function isDefenseHit(u, v) {
    if (/TACO|POUCH|PCH/.test(u) && /OC SPRAY|PEPPER/.test(u) && !/\d+\s*OZ|\d+GM|MK-/.test(u)) return false;
    if (/MACE SECURITY|^SABRE$|PS PRODUCTS|\bTASER\b/.test(v)) return true;
    return /PEPPER|PEPR SPRAY|PEPR SPRY|OC SPRAY|STUN |\bTASER\b|\bMACE\b|DEFENSE SPRAY|BATON|BEAR SPRAY|BEAR HORN|PPR LNCHR|PEPPER GUN|PEPPERBLAST|\bZAP\b|ZAPGUN/.test(u);
  }

  function defenseTypeOf(u) {
    if (/STUN|\bZAP\b|ZAPGUN|BLAST KNUCKLE|\bTASER\b/.test(u)) return 'stun';
    if (/PEPPER|PEPR SPRAY|PEPR SPRY|GEL|OC |SPRAY|\bMACE\b|BEAR SPRAY|PPR LNCHR|LAUNCHER|PEPPERBLAST|PEPPER GUN/.test(u)) {
      return 'spray';
    }
    return 'other';
  }

  function isGunPartHit(u, v) {
    if (GUN_PART.test(u) || GUN_ANY.test(u)) return true;
    if (GUN_VENDORS.test(v)) return true;
    if (/MAGPUL/.test(v) && !/SLING|\bBAG\b|\bCASE\b|GLOVE|PACK/.test(u)) return true;
    if (/MIDWEST INDUSTRIES/.test(v) && !/RAIL|SCOPE|MOUNT/.test(u)) return true;
    return false;
  }

  function isMiscGear(u, v) {
    return !!miscTypeOf(u, v);
  }

  function isBatteryHit(u) {
    if (/TORCH|WML|WEAPON LIGHT|STOR CORE|CAP BATTERY T2/.test(u) && !/BATTERY PACK|LITHIUM BAT/.test(u)) {
      return /BATTERY PACK|LITHIUM BAT|BATTERY CHARGER/.test(u);
    }
    return /BATTERY PACK|LITHIUM BAT|\bBATTERY\b|\bBATTERIES\b|\bBTRY\b|BATTERY CHARGER|CR2 LITH|\bCR123A\b|IBP-1 BATTERY|EXTND BATTERY/.test(u);
  }

  function isCableLockHit(u, v) {
    v = v || '';
    if (/CHAMBER FLAG/.test(u)) return false;
    if (/SLIDE LOCK|MAG LOCK|PIVOT LOCK|LOCK RING|LOCK SET|LOCKING BLOCK/.test(u) &&
        !/CABLE LOCK|GUN LOCK|TRIGGER LOCK/.test(u)) {
      return false;
    }
    return /CABLE LOCK|GUN LOCK|TRIGGER LOCK|MASTERLOCK|TSA COMBO|PADLOCK|TRGR LOCK|TRIG LOCK|SHACKLE LOCK/.test(u) ||
      ((/MASTERLOCK|FIREARM SAFETY DEVICES|BULLDOG CASES/.test(v)) && /LOCK|PADLOCK/.test(u));
  }

  function miscTypeOf(u, v) {
    var blob = u + ' ' + v;
    if (/MAGLULA|UPLULA|MAGPUMP|LOADER|MAGLDR|MAGLOADER/.test(blob)) return 'loaders';
    if (/\bGLOVE/.test(u) || /MECHANIX/.test(v)) return 'gloves';
    if ((/HIGH SPEED GEAR|\bHSGI\b/.test(v) || /^HSGI\b/.test(u)) &&
        /TACO|MAG-NET|DUMP POUCH|DIP PCH|MAG POUCH/.test(u) &&
        !/TOURNIQUET|IFAK/.test(u)) return 'pouches';
    if (/PLATE CARRIER|BATTLE BELT/.test(u)) return 'other';
    if (/BIPOD|MONOPOD|SHOOTING REST|SANDBAG|LEAD SLED|GRIP POD|REAR BAG/.test(u) || /HARRIS ENGINEERING|ACCU-TAC/.test(v)) {
      return 'bipods';
    }
    if (isBatteryHit(u)) return 'batteries';
    if (isCableLockHit(u, v)) return 'locks';
    if (/\bPOUCH\b/.test(u) && !/MAG PCH|MAG POUCH/.test(u)) return 'pouches';
    if (/TSHRT|T-SHIRT|\bHAT\b|HOODIE|APPAREL/.test(u)) return 'other';
    return '';
  }

  function isMedHit(u, v) {
    if (/GLOVE|NITRILE/.test(u)) return false;
    if (/\bNAR\b/.test(u) && /HANDGUARD|RAIL MOUNT|LOW PRO MOUNT|\bMP5/.test(u)) return false;
    if (/NORTH AMERICAN RESCUE/.test(v)) return true;
    if (/IFAK|TOURNIQUET|CHEST SEAL|FIRST AID|QUIKCLOT|M-FAK|\bIPOK\b|COMBAT APPL|\bC-A-T\b|TRAUMA DRESS|EMERG TRAUMA|COMPRESSED GAUZE|\bGAUZE\b/.test(u)) return true;
    if (/MEDICAL POUCH|MED POUCH|REVIVE MEDICAL/.test(u)) return true;
    return false;
  }

  function medTypeOf(u) {
    if (/TOURNIQUET|\bC-A-T\b|COMBAT APPL|TQ CASE|TQ HOLDER|TOURNIQUET STRAP|TOURNIQUET TACO|TOURNIQUET TACT/.test(u)) {
      return 'tourniquets';
    }
    if (/GAUZE|DRESSING/.test(u) && !/KIT|IFAK|M-FAK/.test(u)) return 'supplies';
    if (/MED POUCH|MEDICAL POUCH|REVIVE MEDICAL|TOURNIQUET POUCH/.test(u) && !/IFAK SYSTEM/.test(u)) {
      return 'pouches';
    }
    if (/IFAK|M-FAK|FIRST AID|\bIPOK\b|KIT INDIVIDUAL|PATROL OFCR/.test(u)) return 'kits';
    return 'kits';
  }

  function gearClassify(title, vendor) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    if (isKnifeHit(title, vendor)) return null;
    if (HOLSTER_RE.test(u)) return null;
    if (/SAFARILAND/.test(v) && /RDS|SOLIS|INCOG|6354|6360|6378|6390|7378|7TS|RDSO/.test(u)) return null;
    if (POS_MAG.test(u) && !NEG_MAG.test(u) && !/^EOTECH\b/.test(u) && !/^EOTECH/.test(v)) return null;
    if (MAG_ACC.test(u)) return null;

    if (isMedHit(u, v)) return { cat: 'med', type: medTypeOf(u) };
    if (isBoreSighterHit(u)) return { cat: 'optics', type: 'bore-sighters' };
    if (isLightCapHit(u, v)) return { cat: 'optics', type: 'accessories' };

    if (isOpticHit(u, v)) {
      var ot = opticTypeOf(u, v);
      if (ot) return { cat: 'optics', type: ot };
    }
    if (isLightHit(u, v)) {
      var lt = lightTypeOf(u, v);
      if (lt === 'weapon-lights') return { cat: 'optics', type: 'weapon-lights' };
    }
    if (/SLING PACK|SLING BAG/.test(u)) {
      return { cat: 'storage', type: 'bags' };
    }
    if (/\bSLING\b|\bSLNG\b/.test(u)) {
      if (/SLING (STUD|MOUNT|SWIVEL|PLATE|ATTACH|LOOP|ADPTR)|SLNG MNT|QD SLING SWIVEL|SLING POINT/.test(u) &&
          !/W\/SWIVEL|WITH SWIVEL|MS[0-9]|VICKERS|\bMS1\b|\bMS3\b|\bMS4\b/.test(u)) {
        return null;
      }
      return { cat: 'slings', type: 'all' };
    }
    if (isHearingHit(u, v)) return { cat: 'hearing', type: hearingStyleOf(u) };
    if (isEyeHit(u, v)) return { cat: 'eyes', type: 'glasses' };
    if (isReloadHit(u, v)) return { cat: 'reloading', type: reloadTypeOf(u) };
    if (isRangeHit(u, v)) return { cat: 'range', type: rangeTypeOf(u) };
    if (isStorageHit(u, v)) {
      var st = storageTypeOf(u);
      if (st) return { cat: 'storage', type: st };
    }
    if (isCleanHit(u, v) && !/BOLT CARRIER|\bBCG\b|CHARGING HANDLE|LOWER PARTS/.test(u)) {
      return { cat: 'cleaning', type: cleanTypeOf(u) };
    }
    if (isLightHit(u, v)) {
      return { cat: 'lights', type: lightTypeOf(u, v) };
    }
    if (isDefenseHit(u, v)) return { cat: 'defense', type: defenseTypeOf(u) };
    if (/BIPOD|MONOPOD|GRIP[- ]?POD|SHOOTING REST|LEAD SLED|REAR BAG/.test(u) || /HARRIS ENGINEERING|ACCU-TAC/.test(v)) {
      return { cat: 'bipods', type: 'all' };
    }
    if (/MAGLULA|UPLULA|STRIPLULA|MAGPUMP|\bLULA\b|BABYUPLULA|\bMAGLDR\b|MAGLOADER|MAG LOADER|MAG LDR/.test(u + ' ' + v) ||
        /HKS SPEED LOADERS/.test(v) ||
        (/\b(LOADER|SPDLR|SPDLDR|SPEEDLOADERS?|SPEEDLOAD)\b/.test(u + ' ' + v) && !/BOLT CARRIER|CHARGING HANDLE/.test(u))) {
      return { cat: 'loaders', type: 'all' };
    }
    if (/PLATE CARRIER|BATTLE BELT/.test(u) ||
        /TACO|MAG-NET|DUMP POUCH/.test(u) ||
        ((/HIGH SPEED GEAR|\bHSGI\b/.test(v) || /^HSGI\b/.test(u) || /^GBRS\b/.test(u)) && /POUCH|PCH|TACO/.test(u))) {
      if (!/TOURNIQUET|IFAK|MED POUCH/.test(u)) return { cat: 'carriers', type: 'all' };
    }
    if (/\b(POUCH|PCH)\b/.test(u) && !/MED POUCH|IFAK|TOURNIQUET|BATTERY PACK/.test(u)) {
      return { cat: 'carriers', type: 'all' };
    }
    if ((/\bGLOVE/.test(u) || /MECHANIX/.test(v))) {
      return { cat: 'gloves', type: 'all' };
    }
    if (isBatteryHit(u)) return { cat: 'batteries', type: 'all' };
    if (isCableLockHit(u, v)) return { cat: 'locks', type: 'all' };
    if (isGunPartHit(u, v)) return null;
    if (isMiscGear(u, v)) return { cat: 'other', type: miscTypeOf(u, v) || 'other' };
    return null;
  }

  var GUN_FAMILIES = [
    { id: 'ar-15', label: 'AR-15' },
    { id: 'glock', label: 'Glock' },
    { id: '1911', label: '1911' },
    { id: 'sig-sauer', label: 'Sig Sauer' },
    { id: 'mossberg', label: 'Mossberg' },
    { id: 'ak-47', label: 'AK-47' },
    { id: '10-22', label: '10/22' },
    { id: 'ar-10', label: 'AR-10' },
    { id: 'benelli', label: 'Benelli' },
    { id: 'beretta', label: 'Beretta' },
    { id: 'bersa', label: 'Bersa' },
    { id: 'browning', label: 'Browning' },
    { id: 'canik', label: 'Canik' },
    { id: 'cmmg', label: 'CMMG' },
    { id: 'colt', label: 'Colt' },
    { id: 'cz', label: 'CZ' },
    { id: 'fn', label: 'FN' },
    { id: 'henry', label: 'Henry' },
    { id: 'hk', label: 'H&K' },
    { id: 'iwi', label: 'IWI' },
    { id: 'kahr', label: 'Kahr' },
    { id: 'kel-tec', label: 'Kel-Tec' },
    { id: 'kimber', label: 'Kimber' },
    { id: 'marlin', label: 'Marlin' },
    { id: 'remington', label: 'Remington' },
    { id: 'ruger', label: 'Ruger' },
    { id: 'savage', label: 'Savage' },
    { id: 'springfield', label: 'Springfield' },
    { id: 'smith-wesson', label: 'Smith & Wesson' },
    { id: 'taurus', label: 'Taurus' },
    { id: 'tikka', label: 'Tikka' },
    { id: 'walther', label: 'Walther' }
  ];
  var GUN_FAMILY_FN = {
    'ar-15': isAr15Firearm,
    glock: isGlock,
    '1911': is1911Firearm,
    'sig-sauer': isSigFirearm,
    mossberg: isMossbergFirearm,
    'ak-47': isAkFirearm,
    '10-22': is1022Firearm,
    'ar-10': isAr10Firearm,
    benelli: isBenelliFirearm,
    beretta: isBerettaFirearm,
    bersa: isBersaFirearm,
    browning: isBrowningFirearm,
    canik: isCanikFirearm,
    cmmg: isCmmgFirearm,
    colt: isColtFirearm,
    cz: isCzFirearm,
    fn: isFnFirearm,
    henry: isHenryFirearm,
    hk: isHk,
    iwi: isIwiFirearm,
    kahr: isKahrFirearm,
    'kel-tec': isKeltecFirearm,
    kimber: isKimberFirearm,
    marlin: isMarlinFirearm,
    remington: isRemingtonFirearm,
    ruger: isRugerFirearm,
    savage: isSavageFirearm,
    springfield: isSpringfieldFirearm,
    'smith-wesson': isSwFirearm,
    taurus: isTaurusFirearm,
    tikka: isTikkaFirearm,
    walther: isWaltherFirearm
  };

  function gunFamilyLabel(id) {
    var i;
    for (i = 0; i < GUN_FAMILIES.length; i++) {
      if (GUN_FAMILIES[i].id === id) return GUN_FAMILIES[i].label;
    }
    return id || '';
  }

  function gunFamiliesOf(title, vendor, desc) {
    var out = [];
    var i;
    for (i = 0; i < GUN_FAMILIES.length; i++) {
      var id = GUN_FAMILIES[i].id;
      var fn = GUN_FAMILY_FN[id];
      if (fn && fn(title, vendor, desc)) out.push(id);
    }
    return out;
  }

  function isTenRoundBody(u) {
    if (!u) return false;
    if (/10RD\s*\/\s*\d+RD/.test(u)) return true;
    if (/10\/\d+RD\s*BDY/.test(u)) return true;
    if (/\b10\s*\/\s*30\b/.test(u)) return true;
    if (/10RD\/30RD/.test(u)) return true;
    if (/\b10-30\b/.test(u) && /BDY|BODY|BLOCK|PIN/.test(u)) return true;
    if (/\b(BLOCKED|PINNED)\b/.test(u) && (/\bMAG\b|\bMAGAZINE\b|\bPMAG\b|\d+RD\b/.test(u))) return true;
    if (/10RD.{0,16}(BDY|BODY)/.test(u)) return true;
    if (/10\s*-?\s*ROUND.{0,16}(BODY|BLOCKED|PINNED)/.test(u)) return true;
    return false;
  }

  function magRdCaps(u) {
    var caps = [];
    var re = /\b(\d+)\s*-?\s*(RD|ROUND|ROUNDS)\b/g;
    var m;
    while ((m = re.exec(u))) {
      var n = parseInt(m[1], 10);
      if (n >= 2 && n <= 150) caps.push(n);
    }
    return caps;
  }

  function isRestrictedMagazine(title, vendor, desc) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (/AMMO BOX|AMMO CAN|AMMO CASE|AMMUNITION BOX|AMMO WALLET|SHOTSHELL|GAUGE BOX|FLIP TOP|SLIP-?TOP|BANDOLIER|GRIP PAD|SAF-T-CLAD|BORE BRUSH|CLEANING ROD/.test(u)) return false;
    if (/\bBOX\b/.test(u) && !/\b(MAG|MAGAZINE|PMAG|HEXMAG)\b/.test(u)) return false;
    if (/\bCASE\b/.test(u) && !/\b(MAG|MAGAZINE|PMAG|HEXMAG)\b/.test(u)) return false;
    if (isTenRoundBody(u)) return false;
    if (/\b10RD\b|\b10RND\b|\b10\s*RD\b|\b10-RD\b|\b10\s*-?\s*ROUNDS?\b/.test(u)) return false;
    if (/\b10\s*\//.test(u)) return false;
    var p = partType(title, vendor, desc);
    if (p === 'mag-extensions' || p === 'loaders' || p === 'magwells') return false;
    if (MAG_ACC_RE.test(u) || isMagFloorplate(u)) return false;
    var mag = p === 'magazines' || isCompleteMag(u, v);
    if (!mag && /\bDRUM\b/.test(u) && /\b(MAG|MAGAZINE|PMAG)\b/.test(u) && !NEG_MAG.test(u)) mag = true;
    if (!mag) return false;
    var caps = magRdCaps(u);
    if (caps.some(function (n) { return n > 10; })) return true;
    if (/\bDRUM\b/.test(u)) return true;
    return false;
  }

  var COMPLETE_GUN_RE = /\bCOMPLETE (RIFLE|PISTOL|SHOTGUN|CARBINE|REVOLVER|FIREARM|HANDGUN|GUN)\b|\b(RIFLE|PISTOL|SHOTGUN|CARBINE|REVOLVER|HANDGUN) COMPLETE\b|\bSTRIPPED LOWER\b|\bCOMPLETE LOWER\b|\bLOWER RECEIVER\b|\bLWR RECVR\b|\bLWR RECEIVER\b|\bLOWER RECVR\b|\b80\s*%\s*LOWER\b|\b80 PERCENT LOWER\b|\bSERIALIZED (FRAME|LOWER|RECEIVER)\b|\bFFL REQUIRED\b|\bMACHINE GUN\b|\bSHORT BARRELED (RIFLE|SHOTGUN)\b/;
  var GUN_NOUN_RE = /\b(PISTOL|HANDGUN|REVOLVER|RIFLE|SHOTGUN|CARBINE|FIREARM)\b/;
  var GUN_NOUN_PART_RE = /\b(STOCK|STK|MAT|TARGET|TGT|BAG|CASE|RAIL|CLEAN|COVER|PAD|PLUG|RACK|HOLDER|BORE|SNAKE|TOOL|BRUSH|RUG|REST|BOSS|CARTRIDGE|CLN|THROWBACK|SIGHT|SGHT|HEIGHT|HIGHT|HOLSTER|HLSTR|SUPPRESSOR|SILENCER|SBR|FLASH HIDER|PROTECTOR|THREAD|BUCKLE|SCABBARD|SPACER|LABEL|CLAMP|TRAP|DIVERTER|ROD|FOLLOWER|PEN|METERING|ORGANIZER|BLOCKS|AEROSOL|CLEANER|RELOAD|DISPLAY|GRID|FABRIC|HANGER|BOTTLE|GIFT|HANDLE|MOLLE|WALL|LATCH|SLIP|ROTOR|ASSY|DIE SET|CARBINE SET|BUILDING|PUZ|BLOOMER|DELAYED|SYSTM|SYSTEM|3-HOLE|BLMR|ACCESSORY|GREASE|LUBE|LUBRICANT|ALL WEATHER|KIT|SCHEMATIC|SLINGS?)\b/;

  function isRestrictedFirearm(title, vendor, desc, extra) {
    var u = (title || '').toUpperCase();
    var v = (vendor || '').toUpperCase();
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (knifeClassify(title, vendor)) return false;
    if (gearClassify(title, vendor)) return false;
    if (isOpticHit(title, vendor)) return false;
    if (isCleanHit(u, v)) return false;
    if (/LEGEND OUTDOOR|GUN STORAGE SOLUTIONS|CALIBER GOURMET|SOUTHERN BLOOMER|CERUS GEAR/.test(v)) return false;
    if (COMPLETE_GUN_RE.test(u) && !/COMPLETE UPPER|UPPER RECEIVER|BUILDING BLOCKS/.test(u)) return true;
    var p = partType(title, vendor, desc);
    if (p && p !== 'other') return false;
    var ptype = String((extra && extra.product_type) || '').toUpperCase();
    if (ptype && /HANDGUN|PISTOL|REVOLVER|RIFLE|SHOTGUN|FIREARM|LONG GUN/.test(ptype) &&
        !/PART|ACCESSOR|MAGAZINE|OPTIC|AMMO|AIR|KNIFE/.test(ptype)) {
      return true;
    }
    if (!GUN_NOUN_RE.test(u)) return false;
    if (GUN_NOUN_PART_RE.test(u)) return false;
    if (/\bAIR\b|\bBB\b|\bPELLET\b|\bCO2\b|\bPCP\b/.test(u)) return false;
    return true;
  }

  function restrictedOf(title, vendor, desc, extra) {
    if (isRestrictedMagazine(title, vendor, desc)) {
      return { kind: 'magazine', why: 'over-10' };
    }
    if (isRestrictedFirearm(title, vendor, desc, extra)) {
      return { kind: 'firearm', why: 'complete-gun' };
    }
    return null;
  }

  function isPartsHit(title, vendor, desc) {
    if (isAirgunFirearm(title, vendor, desc)) return false;
    if (knifeClassify(title, vendor)) return false;
    if (gearClassify(title, vendor)) return false;
    var p = partType(title, vendor, desc);
    if (!p || p === 'other') return false;
    return true;
  }

  var api = {
      PLATFORMS: PLATFORMS,
      TYPES: TYPES,
      CORE_TYPES: CORE_TYPES,
      TYPE_MIN: TYPE_MIN,
      partType: partType,
      is1911Wilson: is1911Wilson,
      is1911Firearm: is1911Firearm,
      isAr15Firearm: isAr15Firearm,
      isAkFirearm: isAkFirearm,
      is1022Firearm: is1022Firearm,
      isAr10Firearm: isAr10Firearm,
      isRemingtonFirearm: isRemingtonFirearm,
      isBerettaFirearm: isBerettaFirearm,
      isColtFirearm: isColtFirearm,
      isGlock: isGlock,
      isRmrFootprintPistolDot: isRmrFootprintPistolDot,
      isHk: isHk,
      isMossbergFirearm: isMossbergFirearm,
      isRugerFirearm: isRugerFirearm,
      isSigFirearm: isSigFirearm,
      isSpringfieldFirearm: isSpringfieldFirearm,
      isSwFirearm: isSwFirearm,
      isTaurusFirearm: isTaurusFirearm,
      isCzFirearm: isCzFirearm,
      isWaltherFirearm: isWaltherFirearm,
      isBenelliFirearm: isBenelliFirearm,
      isBersaFirearm: isBersaFirearm,
      isBrowningFirearm: isBrowningFirearm,
      isCanikFirearm: isCanikFirearm,
      isCmmgFirearm: isCmmgFirearm,
      isFnFirearm: isFnFirearm,
      isHenryFirearm: isHenryFirearm,
      isIwiFirearm: isIwiFirearm,
      isKahrFirearm: isKahrFirearm,
      isKeltecFirearm: isKeltecFirearm,
      isKimberFirearm: isKimberFirearm,
      isSavageFirearm: isSavageFirearm,
      isTikkaFirearm: isTikkaFirearm,
      isMarlinFirearm: isMarlinFirearm,
      isAirgunFirearm: isAirgunFirearm,
      knifeClassify: knifeClassify,
      gearClassify: gearClassify,
      opticBrandLabel: opticBrandLabel,
      opticTypeOf: opticTypeOf,
      isOpticHit: isOpticHit,
      opticKindOf: opticKindOf,
      magCapOf: magCapOf,
      magCalOf: magCalOf,
      magStyleOf: magStyleOf,
      modelsOf: modelsOf,
      vendorBrandKey: vendorBrandKey,
      promagFitsPlatform: promagFitsPlatform,
      isCompleteMag: isCompleteMag,
      isTenRoundBody: isTenRoundBody,
      restrictedOf: restrictedOf,
      isRestrictedMagazine: isRestrictedMagazine,
      isRestrictedFirearm: isRestrictedFirearm,
      isPartsHit: isPartsHit,
      glockGensOf: glockGensOf,
      GUN_FAMILIES: GUN_FAMILIES,
      gunFamilyLabel: gunFamilyLabel,
      gunFamiliesOf: gunFamiliesOf,
      normalizeMaker: normalizeMaker,
      opticSeriesOf: opticSeriesOf,
      opticSeriesLabel: opticSeriesLabel,
      knifeBrandLabel: knifeBrandLabel,
      knifeSeriesLabel: knifeSeriesLabel,
      gearCatLabel: gearCatLabel,
      gearTypeLabel: gearTypeLabel,
      holsterCarryOf: holsterCarryOf,
      isCleanHit: isCleanHit,
      isMerchHit: isMerchHit,
      skipFirearmFamily: skipFirearmFamily,
      isNitrileGlove: isNitrileGlove,
      colorOf: colorOf,
      miscJobOf: miscJobOf,
      wantsBrand: wantsBrand,
      GEAR_CATS: GEAR_CATS,
      CAL_LABELS: CAL_LABELS,
      SPYDERCO_SERIES: SPYDERCO_SERIES,
      KNIFE_L2: KNIFE_L2,
      MAG_CALS: MAG_CALS,
      MISC_JOBS: MISC_JOBS,
      KNIFE_BRANDS: KNIFE_BRANDS,
      OPTIC_SERIES: OPTIC_SERIES
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) {
    root.GPC = root.GPC || {};
    root.GPC.classify = api;
  }
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this));
